import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { DateRange, MatCalendar } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { Moment } from 'moment';
import { DateAdapter } from '@angular/material/core';
declare var $: any;
import { UIChart } from 'primeng/chart';
import { BsDatepickerConfig, BsDatepickerDirective, BsDatepickerViewMode } from 'ngx-bootstrap/datepicker';
import { ApexAxisChartSeries, ApexChart, ApexDataLabels, ApexGrid, ApexLegend, ApexPlotOptions, ApexStroke, ApexTooltip, ApexXAxis, ApexYAxis, ChartComponent } from 'ng-apexcharts';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart, Filler, registerables } from 'chart.js';
import { BehaviorSubject, Subject } from 'rxjs';
import { FollowupDashboardService } from './followup-dashboard.service';
import moment from 'moment';

Chart.register(...registerables, ChartDataLabels);
export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  tooltip: ApexTooltip;
  grid: ApexGrid;
  colors: string[];
  legend: ApexLegend;
  stroke: ApexStroke;
};
@Component({
    selector: 'app-followup-dashboard',
    templateUrl: './followup-dashboard.component.html',
    styleUrls: ['./followup-dashboard.component.scss'],
    standalone: false
})
export class FollowupDashboardComponent implements OnInit, AfterViewInit {
  isLoading: Subject<boolean> = new Subject<boolean>();
  stageIds: any = environment.salesDashboardId;
  bucketurl = environment.bucketUrl;
  selectedButton: any = 'custom';
  @ViewChild('dateRangePicker') dateRangePickerTemplate!: TemplateRef<any>;
  @ViewChild('cancelButton') cancelButton!: ElementRef;
  @ViewChild('startCalendar') startCalendar!: MatCalendar<Date>;
  @ViewChild('dpFollowupStart', { static: true }) dpFollowupStart!: BsDatepickerDirective;
  @ViewChild('dpFollowupEnd', { static: true }) dpFollowupEnd!: BsDatepickerDirective;
  @ViewChild('dpBarStart', { static: true }) dpBarStart!: BsDatepickerDirective;
  @ViewChild('dpBarEnd', { static: true }) dpBarEnd!: BsDatepickerDirective;

  public headerCards: any = []
  public subHeaderCards: any = []
  public followupCards: any = [{ title: 'Digital Desk TAT', zoneInfo: 'The number in the bottom right corner indicates the total leads on which the first follow-up has been applied by DD. ', info: 'Time taken by Digital Desk to update the first follow up after a lead is captured for the selected date range. Calculated during Working hours (9:30 AM - 7:30 PM)', icon: 'first-followup.png', value: 'ddFolloUpTat' },
  { title: 'DSE TAT for Digital Desk lead', zoneInfo: 'The number in the bottom right corner indicates the total enquiries on which the first follow-up has been applied by DSE.', info: 'Time taken by DSE to update the first follow up after a lead is assigned by the Digital Desk for the selected date range. Calculated during Working hours (9:30 AM - 7:30 PM).', icon: 'first-followup.png', value: 'dseFolloUpTat' },
  { title: "Avg. Followup count for Enquiries", zoneInfo: 'Average follow up count of Enquiries for ', info: 'The total number of follow-ups till date divided by the total number of enquiries created during the selected date range.', icon: 'first-followup.png', value: 'avgFolloUpTat' },
  // { title: 'Follow Ups', zoneInfo: 'Follow up counts for ', info: 'The total numberof follow-ups completed.', icon: 'first-followup.png', value: 'FollowUp' },
  // { title: 'Missed Follow Ups', zoneInfo: 'Missed follow up counts for ', info: 'The total number of follow-ups that were not completed as scheduled.', icon: 'first-followup.png', value: 'missedFollowUp' },
  { title: "Today's Follow Up", zoneInfo: "Today's follow up count for ", info: 'The follow-ups that need to be done today.', icon: 'first-followup.png', value: 'todaysFollowUp' }]
  today: Date = new Date(); // Initialize today's date
  startDate: any;
  endDate: any;
  // Set the range
  range: { start: Date | null; end: Date | null } = {
    start: moment().endOf('month').subtract(1, 'week').toDate(),
    end: moment().endOf('month').add(1, 'week').toDate()
  };

  // DateRange instance using range
  dateRange = new DateRange(this.range.start, this.range.end);
  @ViewChildren(UIChart) chartComponents!: QueryList<UIChart>;  // Access all chart components
  @ViewChild("chart", { static: false }) chart!: ChartComponent;
  dropdownData: any = [];
  categoryData: any = [];
  modelsData: any = [];
  sourceData: any = [];
  statusData: any = [];
  userData: any = [];
  selectedCardIndex: any = -1;
  selectedFollowupCardIndex: any = 0
  statusesToggle = [
    // { label: 'Untouched', checked: false, value: 'untouch' },
    { label: 'Follow Up TAT', checked: true, value: 'firstFolloUpTat' },
    // { label: '2nd Follow Up TAT', checked: false, value: '2folloUpTat' },
    // { label: '3rd Follow Up TAT', checked: false, value: '3folloUpTat' },
    // { label: '4th Follow Up TAT', checked: false, value: '4folloUpTat' },
    // { label: '5th Follow Up TAT', checked: false, value: '5folloUpTat' },
    // { label: '6th Follow Up TAT', checked: false, value: '6folloUpTat' },
    // { label: '7th Follow Up TAT', checked: false, value: '7folloUpTat' },
    // { label: '>7th Follow Up TAT', checked: false, value: '7greatefolloUpTat' },
    // { label: 'DD Follow Up TAT', checked: true, value: 'ddFolloUpTat' },
    // { label: 'DSE Follow Up TAT', checked: false, value: 'dseFolloUpTat' },
    // { label: 'Avg Follow Up TAT', checked: false, value: 'avgFolloUpTat' },
    // { label: 'First Follow Up TAT', checked: true, value: 'firstFolloUpTat' },
    // { label: 'Missed Follow Ups', checked: false, value: 'missedFollowUp' },
    // { label: 'Zero Follow Ups', checked: false, value: 'zeroFollowUp' },
    { label: 'Today’s Follow Up', checked: false, value: 'todaysFollowUp' },
    // { label: 'Hot', checked: false, value: 'dmsStages__1003' },
    // { label: 'Warm', checked: false, value: 'dmsStages__1008' },
    // { label: 'Cold', checked: false, value: 'dmsStages__1006' },
    // { label: 'Negotiation', checked: false, value: 'customerRequirement__4' },
    // { label: 'Test Ride', checked: false, value: 'customerRequirement__2' },
    // { label: 'Invoiced', checked: false, value: 'dmsStages__10' },
    // { label: 'Booked', checked: false, value: 'dmsStages__9' }
  ];
  zoneSettings = {
    singleSelection: false,
    enableCheckAll: false,
    idField: 'zone_id',
    textField: 'Zone_Manager',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  regionSettings = {
    singleSelection: false,
    enableCheckAll: false,
    idField: 'outlet_id',
    textField: 'username',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  areaSettings = {
    singleSelection: false,
    enableCheckAll: false,
    idField: 'outlet_id',
    textField: 'username',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  zonalList: any = [];
  regionalList: any = [];
  areaList: any = [];
  constructor(public dialog: MatDialog, private toastr: ToastrService, private _dateAdapter: DateAdapter<Moment>, private cdr: ChangeDetectorRef, private followupService: FollowupDashboardService) {
    this.followupChart();
    this.horizontalBarChart();
  }
  followupOptions: any = {}
  horizontalBarOptions: any = {}
  followupChart() {
    this.followupOptions = {
      series: [
      ],
      chart: {
        type: 'line',
        height: 300,
        dropShadow: {
          enabled: true,
          color: "#000",
          top: 15,
          left: 7,
          blur: 10,
          opacity: 0.2
        },
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false,
        },

      },
      colors: ['#165DFF', '#14C9C9'],
      stroke: {
        curve: 'smooth',
        width: 2
      },
      tooltip: {
        enabled: true // Tooltip to show more information if needed
      },
      xaxis: {
        categories: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13'],
        labels: {
          show: true,
          style: {
            fontSize: '12px'
          }
        }
      },
      yaxis: {
        labels: {
          style: {
            fontSize: '12px'
          }
        },
        title: {
          text: 'Count'
        }
      },
      dataLabels: {
        enabled: false, // Enable the data labels to show the count
        offsetY: -10, // Position the count above the dot
        style: {
          fontSize: '11px',
          colors: ['#165DFF', '#14C9C9'] // Match the label color with the dot color
        },
        background: {
          enabled: false // Disable background around the label
        },
        distributed: false,
      },
      grid: {
        borderColor: '#e7e7e7',
        strokeDashArray: 3
      },
      legend: {
        position: 'top',
        horizontalAlign: 'left'
      }
    }
  }

  horizontalBarChart() {
    this.horizontalBarOptions = {
      series: [
      ],
      chart: {
        type: "bar",
        height: 430,
        events: {
          click: function (chart: any, w: any, e: any) {
          },
        },
        toolbar: {
          show: false
        }
      },

      plotOptions: {
        bar: {
          columnWidth: '40px',
          horizontal: true,
          distributed: true,
          dataLabels: {
            position: "top"
          }
        }
      },
      dataLabels: {
        enabled: true,
        offsetX: 28,
        style: {
          fontSize: '12px',
          fontWeight: 'bold',
          colors: ["#DCEFFA"], // Text color from .stat-value
        },
        background: {
          enabled: true,
          foreColor: '#007bff',
          borderRadius: 3,
          padding: 7,
          opacity: 0.9,
          borderWidth: 1,
          borderColor: '#e7f3ff'
        },
      },
      colors: [
        '#AE83E8', // Purple
        '#E67FE6', // Pink
        '#8AE9E9', // Light Blue
        '#E9EB72', // Yellow
        '#E78F92', // Light Red
        '#E6B76B', // Orange
        '#A0DA8C', // Green
        '#E983A6', // Dark Pink
        '#6BAAE6', // Blue
        '#A783E6', // Lavender
        '#E6A083'  // Coral
      ],
      stroke: {
        show: true,
        width: 1,
        colors: ["#fff"]
      },
      xaxis: {
        categories: [],
        max: (max: number) => {
          console.log("maxxxx: ", max)
          return Math.ceil(max * 1.1); // Increase max value by 10%
        },
        min: 0 // Start x-axis from 0
      },
      yaxis: {
        labels: {
          formatter: (val: number) => {
            return Math.round(val).toString(); // Round and convert to string
          }
        },
        max: (max: number) => {
          return Math.ceil(max * 1.1); // Increase the maximum by 10% and round up
        },
        min: 0 // Ensure the y-axis starts from 0
      },
      legend: {
        show: false // Disable the legend
      }
    };
  }

  selectedZone: any = {}
  totalLeads: any = 0;
  selectCard(index: number, zone: any) {
    if (index != this.selectedCardIndex) {
      this.selectedCardIndex = index; // Update the selected index
      this.selectedZone = zone; // Update the selected zone
      this.getRegionWiseCounts();
    } else {
      this.selectedCardIndex = -1; // Reset the selected index
      this.selectedZone = {}; // Reset the selected zone
      this.subHeaderCards = [];
    }
  }

  getTooltipContent(card: any): string {
    return `${this.selectedCardInfo}`;
  }

  getOverallCardInfo() {
    if (this.selectedFollowupCardIndex === 0) {
      return 'The total time taken by all leads for the first action (within the selected date range) divided by the total number of leads in that range.';
    } else if (this.selectedFollowupCardIndex === 1) {
      return 'The total time taken for the first follow-up on all leads (within the selected date range) divided by the total number of leads in that range.';
    } else if (this.selectedFollowupCardIndex === 2) {
      return 'The total number of follow-ups on all enquiries (within the selected date range) divided by the total number of enquiries in that range.';
    } else if (this.selectedFollowupCardIndex === 3) {
      return 'This is the sum of all follow-ups done today. It is not dependent on the selected date range.';
    } else {
      return 'Total'
    }
  }



  isUserType: boolean = false;
  selectedFollowupCard: any = 'ddFolloUpTat'
  selectedCardInfo: any = 'The number in the bottom right corner indicates the total leads on which the first follow-up has been applied by DD'
  columns: any = 6
  selectFollowupCard(index: number, data: any) {
    this.selectedFollowupCardIndex = index;
    console.log("selected: ", this.selectedFollowupCardIndex)
    this.cdr.detectChanges();
    this.selectedCardInfo = data.zoneInfo
    if (index == 0 || index == 1 || index == 2) {
      this.isUserType = false;
    } else {
      this.isUserType = true;
    }
    // if (this.selectedFollowupCardIndex != index) {
       // Update the selected index
      this.columns = (this.selectedFollowupCardIndex === 0 || this.selectedFollowupCardIndex === 1) ? 6 : 5;
      this.userData.forEach((item: any) => {
        if (index == 0) {
          if (item.role_id == 4) {
            item.checked = true;
          } else {
            item.checked = false;
          }
        } else {
          if (item.role_id == 3) {
            item.checked = true;
          } else {
            item.checked = false;
          }
        }
      })
      this.selectedFollowupCard = data.value;
      if (this.roleId == 7 || this.roleId == 6) {
        this.getRegionWiseCounts();
      } else {
        this.getZoneWiseCounts();
      }
      this.getGeographyChartCounts();
      this.getHorizontalChartCounts(index);
      // this.getFollowupTableCountData();
      if (this.selectedCardIndex != -1) {
        this.getRegionWiseCounts();
      }
    // }
  }

  openDateRangePicker() {
   const dialogRef:any = this.dialog.open(this.dateRangePickerTemplate, { panelClass: 'modal-picker-class' });
   dialogRef.afterOpened().subscribe(() => {
    if (this.startCalendar) {
      const selectMonth = new Date(this.startDate);
      this.startCalendar.activeDate = selectMonth;
    }
  });
    setTimeout(() => {
      if (this.cancelButton) {
        this.cancelButton.nativeElement.focus();
      }

    }, 300);
  }


  selectToday() {
    const today = new Date();
    this.startDate = today;
    this.endDate = today;
    this.selectedButton = 'today';

    this.dateRange = new DateRange(this.startDate, this.endDate);
    const selectMonth = new Date();
    selectMonth.setMonth(selectMonth.getMonth());
    if (this.startCalendar) {
      this.startCalendar.activeDate = selectMonth;
    }
  }

  selectLast7Days() {
    const today = new Date();

    // Exclude today: Start from yesterday
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    // Set start date as 7 days before yesterday
    this.startDate = new Date(yesterday);
    this.startDate.setDate(yesterday.getDate() - 6); // 7 days excluding today

    this.endDate = yesterday; // Yesterday is the end date

    this.selectedButton = 'last7';

    this.dateRange = new DateRange(this.startDate, this.endDate);


    const selectMonth = new Date(this.startDate);
    selectMonth.setMonth(selectMonth.getMonth());
    if (this.startCalendar) {
      this.startCalendar.activeDate = selectMonth;
    }
  }

  selectLast15Days() {
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    // Set start date as 7 days before yesterday
    this.startDate = new Date(yesterday);
    this.startDate.setDate(yesterday.getDate() - 14);

    this.endDate = yesterday;
    this.selectedButton = 'last15';
    this.dateRange = new DateRange(this.startDate, this.endDate);

    const selectMonth = new Date(this.startDate);
    selectMonth.setMonth(selectMonth.getMonth());
    if (this.startCalendar) {
      this.startCalendar.activeDate = selectMonth;
    }
  }


 selectThisMonth() {
  this.selectedButton = 'thisMonth';
  const today = new Date();

  let startOfMonth: Date;
  let endOfMonth: Date;

  if (today.getDate() === 1) {
    // If today is the 1st, use last month's full range
    const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    startOfMonth = new Date(lastMonth.getFullYear(), lastMonth.getMonth(), 1);
    endOfMonth = new Date(lastMonth.getFullYear(), lastMonth.getMonth() + 1, 0); // Last day of last month
  } else {
    // Regular case: current month start to yesterday
    startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    endOfMonth = new Date(today);
    endOfMonth.setDate(today.getDate() - 1);
  }

  this.startDate = startOfMonth;
  this.endDate = endOfMonth;
  this.dateRange = new DateRange(this.startDate, this.endDate);

  // Keep the month selection in the calendar
  const selectMonth = new Date(this.startDate);
  if (this.startCalendar) {
    this.startCalendar.activeDate = selectMonth;
  }
}



  selectCustom() {
    this.selectedButton = 'custom';
    this.startDate = null;
    this.endDate = null;
    this.dateRange = new DateRange(this.startDate, this.endDate);
  }

  onStartDateChange(event: Date) {
    this.startDate = event;
  }

  onEndDateChange(event: Date) {
    this.endDate = event;
  }


  closeDialog() {
    if (moment(this.startDate).format('YYYY-MM-DD') > moment(this.endDate).format('YYYY-MM-DD')) {
      this.toastr.error("The end date should be greater than or equal to the start date!")
    } else {
      this.dialog.closeAll();
      this.selectThisMonth();
      setTimeout(() => {
        this.applyDateRange();
      }, 100)
    }
  }

  isGlobalDateCategory: boolean = true;
  applyDateRange() {
    // Logic to apply the date range
    this.selectedZone = {};
    this.selectedCardIndex = -1;
    this.subHeaderCards = []
    // Logic to apply the date range
    if (this.startDate == null || this.endDate == null) {
      this.toastr.error("Please select a date range!");
    } else {
      if (moment(this.startDate).format('YYYY-MM-DD') > moment(this.endDate).format('YYYY-MM-DD')) {
        this.toastr.error("The end date should be greater than or equal to the start date!")
      } else {
        // this.isLoading = new BehaviorSubject<boolean>(true);
        this.isGlobalDateCategory = true;
        this.dialog.closeAll();
        // if (this.roleId == 8 || this.roleId == 9) {
        //   this.getParentDealerChartCounts();
        // } else {
        if (this.roleId == 7 || this.roleId == 6) {
          this.getRegionWiseCounts();
        } else {
          this.getZoneWiseCounts();
        }
        this.getGeographyChartCounts();
        // }
        this.getHorizontalChartCounts(this.selectedFollowupCardIndex);
        // this.getFollowupTableCountData();
        // this.getLineChartCounts();
        let filterObject: any = {}
        if (sessionStorage.getItem('filterObject')) {
          filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
        }
        filterObject.startDate = moment(this.startDate).format('YYYY-MM-DD');
        filterObject.endDate = moment(this.endDate).format('YYYY-MM-DD');
        filterObject.selectedButton = this.selectedButton;
        sessionStorage.setItem('filterObject', JSON.stringify(filterObject))
        setTimeout(() => {
          // this.isLoading = new BehaviorSubject<boolean>(false);
        }, 1200)
      }
    }
  }

  clearDate() {
    this.selectedButton = 'thisMonth';
    this.startDate = null;
    this.endDate = null;
    this.closeDialog();
  }

  regionData: any = []
  filterObject: any = {};
  roleId: any = null;
  userDetails: any = {}
  isDateOne: boolean = false;

  ngOnInit() {
    if (this.today.getDate() == 1) {
      this.isDateOne = true
    } else {
      this.isDateOne = false
    }
    this.filterObject = {}
    if (sessionStorage.getItem('loginResponse')) {
      let resData: any = JSON.parse(sessionStorage.getItem('loginResponse') || '{}');
      this.userDetails = resData.data.user;
    }
    if (sessionStorage.getItem('filterObject')) {
      this.filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
      this.isActiveOutlet = this.filterObject.isActiveOutlet ? this.filterObject.isActiveOutlet : false;
      if (this.filterObject.zonalManagers) {
        this.selectedZonalMgrs = this.filterObject.zonalManagers || [];
      }
      if (this.filterObject.regionalManagers) {
        this.selectedRegionalMgrs = this.filterObject.regionalManagers || [];
      }
      if (this.filterObject.areaManagers) {
        this.selectedAreaMgrs = this.filterObject.areaManagers || [];
      }
      if (this.filterObject.startDate) {
        this.startDate = new Date(this.filterObject.startDate);
        this.endDate = new Date(this.filterObject.endDate);
        this.dateRange = new DateRange(this.startDate, this.endDate);
        this.selectedButton = this.filterObject.selectedButton;
      } else {
        this.selectThisMonth();
      }
    } else {
      this.selectThisMonth();
    }
    if (sessionStorage.getItem('loginResponse')) {
      const loginResponse = JSON.parse(sessionStorage.getItem('loginResponse') || '{}');
      if (loginResponse && loginResponse.data) {
        this.roleId = loginResponse.data?.user?.role_id;
      }
    }
    this.isLoading = new BehaviorSubject<boolean>(true);

    this.bsConfig = {
      adaptivePosition: true,
      keepDatesOutOfRules: true,
      minMode: 'month' as BsDatepickerViewMode,
      dateInputFormat: 'MMMM YYYY',
      maxDate: new Date() // restricts to the current month
    };
    // this.selectThisMonth()
    if (this.roleId == 8 || this.roleId == 9 || this.roleId == 5 || this.roleId == 10) {
      this.getDealerOutletList();
    } else {
      this.getGeographyList();
    }
    setTimeout(() => {
      this.getSourceList();
      // this.getStatusList();
      this.getProductList();
      this.getUserList();
      this.getZonalManager();
      this.getRegionalManager();
      this.getAreaManager();
    }, 1000)
    setTimeout(() => {
      this.getGeographyChartCounts();
      // this.getLineChartCounts();
      this.getHorizontalChartCounts(this.selectedFollowupCardIndex);
      // this.getFollowupTableCountData();
      // this.isLoading = new BehaviorSubject<boolean>(false);
    }, 3100)
  }

  chartsData: any = []

  // Helper function to generate random colors for the chart
  getRandomColors(count: number): string[] {
    const colors: string[] = [];
    for (let i = 0; i < count; i++) {
      const color = `#${Math.floor(Math.random() * 16777215).toString(16)}`; // Random Hex color
      colors.push(color);
    }
    return colors;
  }


  onPDChart() {
    let isEveryOutlet: boolean = this.regionData.every((object: any) => {
      return !object.outlets || object.outlets.length === 0;
    });

    if (isEveryOutlet) {
      const dealerLabels = this.regionData.map((dealer: any) => dealer.parent_dealer || dealer.parent_dealer_name);
      const dealerCounts = this.regionData.map((dealer: any) => dealer.count);
      const totalCount = dealerCounts.reduce((accumulator: any, currentValue: any) => accumulator + currentValue, 0);


      const chartData = {
        data: {
          labels: dealerLabels,  // Zone names as labels
          datasets: [
            {
              data: dealerCounts,  // Zone counts
              backgroundColor: [
                // Original colors
                "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                // First additional set
                "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                // New additional colors
                "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                // Additional colors to reach 40
                "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
              ],
              // hoverBackgroundColor: this.getRandomColors(zoneLabels.length)
            }
          ]
        },
        options: {
          title: '',
          subText1: '',
          subText2: '',
          cutout: '28%',
          plugins: {
            datalabels: {
              color: '#fff',
              display: true,
              formatter: function (value: any, context: any) {
                // Calculate percentage
                const total = context.chart._metasets[context.datasetIndex].total;
                const percentage = ((value / total) * 100).toFixed(0);

                // Return count and percentage on different lines
                return `${value}\n ${percentage}%`;
              },
              font: {
                size: 9
              },
              anchor: 'end',
              align: 'start'
            },
            legend: {
              display: true,
              labels: {
                usePointStyle: true,
                text: 'Zones'
              }
            }, tooltip: { enabled: false } //
          },
          responsive: true,
          maintainAspectRatio: false
        }
      };

      this.chartsData.push(chartData);

    } else {

      this.regionData.forEach((dealerObj: any) => {
        const dealerName = dealerObj.parent_dealer || dealerObj.parent_dealer_name;
        const dealerCount = dealerObj.count;

        if (dealerObj.outlets && dealerObj.outlets.length > 0) {
          dealerObj.outlets.forEach((ouletObj: any) => {
            const outletName = ouletObj.outlet_name;
            const outletCount = ouletObj.count;

            let filteredDataNoArea = dealerObj.outlets
            if (filteredDataNoArea.length != 0) {

              const outletLabels = filteredDataNoArea.map((outlet: any) => outlet.outlet_name);
              const outletCounts = filteredDataNoArea.map((outlet: any) => outlet.count);

              const chartData = {
                id:dealerObj.parent_dealer_id,
                zone: dealerName?.toLowerCase(),
                region: outletName?.toLowerCase(),
                data: {
                  labels: outletLabels,  // Region names as labels
                  datasets: [
                    {
                      data: outletCounts,  // Region counts
                      backgroundColor: [
                        // Original colors
                        "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                        // First additional set
                        "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                        // New additional colors
                        "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                        // Additional colors to reach 40
                        "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                        "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                        "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                        "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                        "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
                      ],
                      // hoverBackgroundColor: this.getRandomColors(regionLabels.length)
                    }
                  ]
                },
                options: {
                  title: `${dealerName} - ${dealerCount}`,
                  subText1: '',
                  subText2: '',
                  cutout: '28%',
                  plugins: {
                    datalabels: {
                      color: '#fff',
                      display: true,
                      formatter: function (value: any, context: any) {
                        // Calculate percentage
                        const total = context.chart._metasets[context.datasetIndex].total;
                        const percentage = ((value / total) * 100).toFixed(0);

                        // Return count and percentage on different lines
                        return `${value}\n ${percentage}%`;
                      },
                      font: {
                        size: 9
                      },
                      anchor: 'end',
                      align: 'start'
                    },
                    legend: {
                      display: true,
                      labels: {
                        usePointStyle: true,
                        text: 'Zones'
                      }
                    }, tooltip: { enabled: false } //
                  },
                  responsive: true,
                  maintainAspectRatio: false
                }
              };
              let filteredData: any = []

              filteredData = this.chartsData.filter((item: any) => item?.id == chartData?.id && item?.zone?.toLowerCase() == chartData?.zone)
              if (filteredData.length == 0) {
                this.chartsData.push(chartData);
              }

            }

          });
        } else {

          let filteredDataNoOutlets = this.regionData.filter((item: any) => {
            return item?.outlets && item?.outlets?.length == 0;
          });
          const dealerLabels = filteredDataNoOutlets.map((dealer: any) => dealer.parent_dealer || dealer.parent_dealer_name);
          const dealerCounts = filteredDataNoOutlets.map((dealer: any) => dealer.count);
          const totalCount = dealerCounts.reduce((accumulator: any, currentValue: any) => accumulator + currentValue, 0);

          const chartData = {
            zone: 'remaining-zones',
            data: {
              labels: dealerLabels,  // Zone names as labels
              datasets: [
                {
                  data: dealerCounts,  // Zone counts
                  backgroundColor: [
                    // Original colors
                    "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                    // First additional set
                    "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                    // New additional colors
                    "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                    // Additional colors to reach 40
                    "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                    "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                    "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                    "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                    "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
                  ],
                  // hoverBackgroundColor: this.getRandomColors(zoneLabels.length)
                }
              ]
            },
            options: {
              title: '',
              cutout: '28%',
              plugins: {
                datalabels: {
                  color: '#fff',
                  display: true,
                  formatter: function (value: any, context: any) {
                    // Calculate percentage
                    const total = context.chart._metasets[context.datasetIndex].total;
                    const percentage = ((value / total) * 100).toFixed(0);

                    // Return count and percentage on different lines
                    return `${value}\n ${percentage}%`;
                  },
                  font: {
                    weight: 'bold',
                    size: 9
                  },
                  anchor: 'end',
                  align: 'start'
                },
                legend: {
                  display: true,
                  labels: {
                    usePointStyle: true,
                    text: 'Zones'
                  }
                }, tooltip: { enabled: false } //
              },
              responsive: true,
              maintainAspectRatio: false
            }
          };
          let filteredData = this.chartsData.filter((item: any) => item?.zone?.toLowerCase() == chartData?.zone)
          if (filteredData.length == 0) {
            this.chartsData.push(chartData);
          }
        }

      });
    }
  }

  onPDChartMinutes() {
    let isEveryOutlet: boolean = this.regionData.every((object: any) => {
      return !object.outlets || object.outlets.length === 0;
    });
    let c = this.regionData.reduce((sum: number, dealer: any) => sum + (dealer.count ?? 0), 0);
    this.formattedTotalCount = c;
    if (isEveryOutlet) {
      const dealerLabels = this.regionData.map((dealer: any) => dealer.parent_dealer || dealer.parent_dealer_name);
      const dealerCounts = this.regionData.map((dealer: any) => dealer.count);
      const totalCount = dealerCounts.reduce((accumulator: any, currentValue: any) => accumulator + parseFloat(currentValue), 0);
      const formattedTotalCount = totalCount == 0 ? 0 : this.formatTime(totalCount);

      const chartData = {
        data: {
          labels: dealerLabels,  // Zone names as labels
          datasets: [
            {
              data: dealerCounts,  // Zone counts
              backgroundColor: [
                // Original colors
                "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                // First additional set
                "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                // New additional colors
                "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                // Additional colors to reach 40
                "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
              ],
              // hoverBackgroundColor: this.getRandomColors(zoneLabels.length)
            }
          ]
        },
        options: {
          title: '',
          subText1: '',
          subText2: '',
          cutout: '28%',
          plugins: {
            datalabels: {
              color: '#fff',
              display: true,
              formatter: function (value: any, context: any) {
                const totalSeconds = Math.floor(value);
                const hours = Math.floor(totalSeconds / 3600);
                const minutes = Math.floor((totalSeconds % 3600) / 60);
                const seconds = Math.floor(totalSeconds % 60);

                let formattedTime = '';

                // Conditionally format hours
                if (hours > 0) {
                  formattedTime += `${hours}h `;
                }

                // Conditionally format minutes
                if (minutes > 0) {
                  formattedTime += `${minutes}m `;
                }

                // Conditionally format seconds
                if (seconds > 0) {
                  // Only show seconds if there are no hours or if seconds are present with minutes
                  formattedTime += `${seconds}s`;
                }

                // Trim any trailing spaces
                return formattedTime.trim();

              },
              font: {
                size: 9
              },
              anchor: 'end',
              align: 'start'
            },
            legend: {
              display: true,
              labels: {
                usePointStyle: true,
                text: 'Zones'
              }
            }, tooltip: { enabled: false } //
          },
          responsive: true,
          maintainAspectRatio: false
        }
      };

      this.chartsData.push(chartData);

    } else {

      this.regionData.forEach((dealerObj: any) => {
        const dealerName = dealerObj.parent_dealer || dealerObj.parent_dealer_name;
        const dealerCount = dealerObj.count;
        const formattedDealerCount = this.formatTime(dealerCount / dealerObj.totalLeads);
        if (dealerObj.outlets && dealerObj.outlets.length > 0) {
          const outletLeadsCounts = dealerObj.outlets.map((zone: any) => zone.totalLeads ?? 0);
          console.log("outletLeadsCounts: ", outletLeadsCounts)
          dealerObj.outlets.forEach((ouletObj: any) => {
            const outletName = ouletObj.outlet_name;
            const outletCount = ouletObj.count;
            const formattedOutletCount = this.formatTime(outletCount);
            let filteredDataNoArea = dealerObj.outlets.filter((outlet: any) => outlet.count !== 0);
            if (filteredDataNoArea.length != 0) {

              const outletLabels = filteredDataNoArea.map((outlet: any) => outlet.outlet_name);
              const outletCounts = filteredDataNoArea.map((outlet: any) => outlet.count);

              const chartData = {
                id:dealerObj.parent_dealer_id,
                zone: dealerName?.toLowerCase(),
                region: outletName?.toLowerCase(),
                data: {
                  labels: outletLabels,  // Region names as labels
                  datasets: [
                    {
                      data: outletCounts,  // Region counts
                      backgroundColor: [
                        // Original colors
                        "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                        // First additional set
                        "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                        // New additional colors
                        "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                        // Additional colors to reach 40
                        "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                        "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                        "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                        "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                        "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
                      ],
                      // hoverBackgroundColor: this.getRandomColors(regionLabels.length)
                    }
                  ]
                },
                options: {
                  title: `${dealerName} - ${formattedDealerCount}`,
                  subText1: '',
                  subText2: '',
                  cutout: '28%',
                  plugins: {
                    datalabels: {
                      color: '#fff',
                      display: true,
                      formatter: function (value: any, context: any) {
                        const index = context.dataIndex; // Get index of data label
                        const leads = outletLeadsCounts[index]
                        const totalSeconds = Math.floor(value / leads);
                        const hours = Math.floor(totalSeconds / 3600);
                        const minutes = Math.floor((totalSeconds % 3600) / 60);
                        const seconds = Math.floor(totalSeconds % 60);

                        let formattedTime = '';

                        // Conditionally format hours
                        if (hours > 0) {
                          formattedTime += `${hours}h `;
                        }

                        // Conditionally format minutes
                        if (minutes > 0) {
                          formattedTime += `${minutes}m `;
                        }

                        // Conditionally format seconds
                        if (seconds > 0) {
                          // Only show seconds if there are no hours or if seconds are present with minutes
                          formattedTime += `${seconds}s`;
                        }

                        // Trim any trailing spaces
                        return formattedTime.trim();

                      },
                      font: {
                        size: 9
                      },
                      anchor: 'end',
                      align: 'start'
                    },
                    legend: {
                      display: true,
                      labels: {
                        usePointStyle: true,
                        text: 'Zones'
                      }
                    }, tooltip: { enabled: false } //
                  },
                  responsive: true,
                  maintainAspectRatio: false
                }
              };
              let filteredData: any = []

              filteredData = this.chartsData.filter((item: any) => item?.id == chartData?.id && item?.zone?.toLowerCase() == chartData?.zone)
              if (filteredData.length == 0) {
                this.chartsData.push(chartData);
              }

            }

          });
        } else {

          let filteredDataNoOutlets = this.regionData.filter((item: any) => {
            return item?.outlets && item?.outlets?.length == 0;
          });
          const dealerLabels = filteredDataNoOutlets.map((dealer: any) => dealer.parent_dealer || dealer.parent_dealer_name);
          const dealerCounts = filteredDataNoOutlets.map((dealer: any) => dealer.count);
          const totalCount = dealerCounts.reduce((accumulator: any, currentValue: any) => accumulator + currentValue, 0);
          const formattedCount = this.formatTime(totalCount);

          const chartData = {
            zone: 'remaining-zones',
            data: {
              labels: dealerLabels,  // Zone names as labels
              datasets: [
                {
                  data: dealerCounts,  // Zone counts
                  backgroundColor: [
                    // Original colors
                    "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                    // First additional set
                    "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                    // New additional colors
                    "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                    // Additional colors to reach 40
                    "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                    "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                    "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                    "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                    "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
                  ],
                  // hoverBackgroundColor: this.getRandomColors(zoneLabels.length)
                }
              ]
            },
            options: {
              title: '',
              cutout: '28%',
              plugins: {
                datalabels: {
                  color: '#fff',
                  display: true,
                  formatter: function (value: any, context: any) {
                    // const index = context.dataIndex; // Get index of data label
                    // const leads = outletLeadsCounts[index]
                    const totalSeconds = Math.floor(value);
                    const hours = Math.floor(totalSeconds / 3600);
                    const minutes = Math.floor((totalSeconds % 3600) / 60);
                    const seconds = Math.floor(totalSeconds % 60);

                    let formattedTime = '';

                    // Conditionally format hours
                    if (hours > 0) {
                      formattedTime += `${hours}h `;
                    }

                    // Conditionally format minutes
                    if (minutes > 0) {
                      formattedTime += `${minutes}m `;
                    }

                    // Conditionally format seconds
                    if (seconds > 0) {
                      // Only show seconds if there are no hours or if seconds are present with minutes
                      formattedTime += `${seconds}s`;
                    }

                    // Trim any trailing spaces
                    return formattedTime.trim();

                  },
                  font: {
                    weight: 'bold',
                    size: 9
                  },
                  anchor: 'end',
                  align: 'start'
                },
                legend: {
                  display: true,
                  labels: {
                    usePointStyle: true,
                    text: 'Zones'
                  }
                }, tooltip: { enabled: false } //
              },
              responsive: true,
              maintainAspectRatio: false
            }
          };
          let filteredData = this.chartsData.filter((item: any) => item?.zone?.toLowerCase() == chartData?.zone)
          if (filteredData.length == 0) {
            this.chartsData.push(chartData);
          }
        }

      });
    }
  }

  onZone() {
    let isEveryRegion: boolean = this.regionData.every((object: any) => {
      return !object.states || object.states.length === 0;
    });
    /**
     * If all the regions is empty in all the zones, then show all the zones count in single pie chart
     */
    if (isEveryRegion) {
      // No regions, show all zones in one chart
      const zoneLabels = this.regionData.map((zone: any) => zone.zone_name);
      const zoneCounts = this.regionData.map((zone: any) => zone.count);
      const totalCount = zoneCounts.reduce((accumulator: any, currentValue: any) => accumulator + currentValue, 0);


      const chartData = {
        data: {
          labels: zoneLabels,  // Zone names as labels
          datasets: [
            {
              data: zoneCounts,  // Zone counts
              backgroundColor: [
                // Original colors
                "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                // First additional set
                "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                // New additional colors
                "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                // Additional colors to reach 40
                "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
              ],
              // hoverBackgroundColor: this.getRandomColors(zoneLabels.length)
            }
          ]
        },
        options: {
          title: 'Enquiries' + ' - ' + totalCount,
          subText1: '',
          subText2: '',
          cutout: '28%',
          plugins: {
            datalabels: {
              color: '#fff',
              display: true,
              formatter: function (value: any, context: any) {
                // Calculate percentage
                const total = context.chart._metasets[context.datasetIndex].total;
                const percentage = ((value / total) * 100).toFixed(0);

                // Return count and percentage on different lines
                return `${value}\n ${percentage}%`;
              },
              font: {
                size: 9
              },
              anchor: 'end',
              align: 'start',
            },
            legend: {
              display: true,
              labels: {
                usePointStyle: true,
                text: 'Zones'
              }
            }
          },
          responsive: true,
          maintainAspectRatio: false
        }
      };

      this.chartsData.push(chartData);

    } else {
      let isEveryArea: boolean = this.regionData.every((object: any) => {
        return !object.states || object.states.length === 0;
      });

      this.regionData.forEach((zoneObj: any) => {
        const zoneName = zoneObj.zone_name;
        const zoneCount = zoneObj.count;

        if (zoneObj.states && zoneObj.states.length > 0) {
          // Zone has regions, create separate charts for each zone
          zoneObj.states.forEach((regionObj: any) => {
            const regionName = regionObj.state_name;
            const regionCount = regionObj.count;

            if (regionObj?.regions && regionObj?.regions.length > 0) {
              // Region has areas, show all areas in one chart
              const areaLabels = regionObj.regions.map((area: any) => area.region_name);
              const areaCounts = regionObj.regions.map((area: any) => area.count);

              const chartData = {
                zone: zoneName,
                region: regionName,
                data: {
                  labels: areaLabels,  // Area names as labels
                  datasets: [
                    {
                      data: areaCounts,  // Area counts
                      backgroundColor: [
                        // Original colors
                        "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                        // First additional set
                        "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                        // New additional colors
                        "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                        // Additional colors to reach 40
                        "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                        "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                        "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                        "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                        "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
                      ],
                      // hoverBackgroundColor: this.getRandomColors(areaLabels.length)
                    }
                  ]
                },

                options: {
                  title: `${zoneName} - ${zoneCount}`,
                  subText1: ` ${regionName} - ${regionCount}`,
                  subText2: '',
                  cutout: '28%',
                  plugins: {
                    datalabels: {
                      color: '#fff',
                      display: true,
                      formatter: function (value: any, context: any) {
                        // Calculate percentage
                        const total = context.chart._metasets[context.datasetIndex].total;
                        const percentage = ((value / total) * 100).toFixed(0);

                        // Return count and percentage on different lines
                        return `${value}\n ${percentage}%`;
                      },
                      font: {
                        size: 9
                      },
                      anchor: 'end',
                      align: 'start'
                    },
                    legend: {
                      display: true,
                      labels: {
                        usePointStyle: true,
                        text: 'Zones'
                      }
                    }
                  },
                  responsive: true,
                  maintainAspectRatio: false
                }
              };
              let filteredData: any = []
              filteredData = this.chartsData.filter((item: any) => item.region == chartData.region)
              if (filteredData.length == 0) {
                this.chartsData.push(chartData);
              }
            } else {
              // Region has no areas, show all regions in one chart for the zone
              let isNoArea: boolean = zoneObj.states.every((item: any) => !item?.regions || item?.regions?.length === 0);
              let filteredDataNoArea = zoneObj.states.filter((item: any) => {
                return !item?.regions || item?.regions?.length == 0;
              });
              if (filteredDataNoArea.length != 0) {

                const regionLabels = filteredDataNoArea.map((region: any) => region.state_name);
                const regionCounts = filteredDataNoArea.map((region: any) => region.count);

                const chartData = {
                  zone: zoneName.toLowerCase(),
                  region: regionName.toLowerCase(),
                  data: {
                    labels: regionLabels,  // Region names as labels
                    datasets: [
                      {
                        data: regionCounts,  // Region counts
                        backgroundColor: [
                          // Original colors
                          "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                          // First additional set
                          "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                          // New additional colors
                          "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                          // Additional colors to reach 40
                          "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                          "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                          "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                          "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                          "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
                        ],
                        // hoverBackgroundColor: this.getRandomColors(regionLabels.length)
                      }
                    ]
                  },
                  options: {
                    title: `${zoneName} - ${zoneCount}`,
                    subText1: '',
                    subText2: '',
                    cutout: '28%',
                    plugins: {
                      datalabels: {
                        color: '#fff',
                        display: true,
                        formatter: function (value: any, context: any) {
                          // Calculate percentage
                          const total = context.chart._metasets[context.datasetIndex].total;
                          const percentage = ((value / total) * 100).toFixed(0);

                          // Return count and percentage on different lines
                          return `${value}\n ${percentage}%`;
                        },
                        font: {
                          size: 9
                        },
                        anchor: 'end',
                        align: 'start'
                      },
                      legend: {
                        display: true,
                        labels: {
                          usePointStyle: true,
                          text: 'Zones'
                        }
                      }
                    },
                    responsive: true,
                    maintainAspectRatio: false
                  }
                };
                let filteredData: any = []
                if (isNoArea) {
                  filteredData = this.chartsData.filter((item: any) => item?.zone?.toLowerCase() == chartData.zone)
                  if (filteredData.length == 0) {
                    this.chartsData.push(chartData);
                  }
                } else {
                  filteredData = this.chartsData.filter((item: any) => item.zone.toLowerCase() == chartData.zone && item.region.toLowerCase() == chartData.region)
                  if (filteredData.length == 0) {
                    this.chartsData.push(chartData);
                  }
                }

              }
            }
          });
        } else {

          let filteredDataNoRegions = this.regionData.filter((item: any) => {
            return item?.states && item?.states?.length == 0;
          });
          const zoneLabels = filteredDataNoRegions.map((zone: any) => zone.zone_name);
          const zoneCounts = filteredDataNoRegions.map((zone: any) => zone.count);
          const totalCount = zoneCounts.reduce((accumulator: any, currentValue: any) => accumulator + currentValue, 0);

          const chartData = {
            zone: 'remaining-zones',
            data: {
              labels: zoneLabels,  // Zone names as labels
              datasets: [
                {
                  data: zoneCounts,  // Zone counts
                  backgroundColor: [
                    // Original colors
                    "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                    // First additional set
                    "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                    // New additional colors
                    "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                    // Additional colors to reach 40
                    "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                    "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                    "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                    "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                    "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
                  ],
                  // hoverBackgroundColor: this.getRandomColors(zoneLabels.length)
                }
              ]
            },
            options: {
              title: 'Enquiries' + ' - ' + totalCount,
              cutout: '28%',
              plugins: {
                datalabels: {
                  color: '#fff',
                  display: true,
                  formatter: function (value: any, context: any) {
                    // Calculate percentage
                    const total = context.chart._metasets[context.datasetIndex].total;
                    const percentage = ((value / total) * 100).toFixed(0);

                    // Return count and percentage on different lines
                    return `${value}\n ${percentage}%`;
                  },
                  font: {
                    weight: 'bold',
                    size: 9
                  },
                  anchor: 'end',
                  align: 'start'
                },
                legend: {
                  display: true,
                  labels: {
                    usePointStyle: true,
                    text: 'Zones'
                  }
                }
              },
              responsive: true,
              maintainAspectRatio: false
            }
          };
          let filteredData = this.chartsData.filter((item: any) => item.zone.toLowerCase() == chartData.zone)
          if (filteredData.length == 0) {
            this.chartsData.push(chartData);
          }
        }

      });
    }
  }


  // Private
  _startDate: any | null = null;
  _endDate: any | null = null;
  selectedChange(date: any): void {
    if (!this._startDate) {
      this._startDate = date;
    } else if (
      !this._endDate &&
      this._dateAdapter.compareDate(date, this._startDate) >= 0
    ) {
      this._endDate = date;
    } else {
      this._startDate = date;
      this._endDate = null;
    }
    this.dateRange = new DateRange(this._startDate, this._endDate);
    this.startDate = this._startDate;
    this.endDate = this._endDate;
  }

  @ViewChild('chartCarousel') chartCarousel!: ElementRef;
  ngAfterViewInit() {
    const nativeEl = this.chartCarousel.nativeElement;

    nativeEl.addEventListener('slid.bs.carousel', (e: any) => {
      console.log('>>> ', e.to);
      this.currentIndex = e.to;
    });
  }

  currentIndex = 0;
  totalSlides = 0
  nextSlide() {
    console.log("this.chartsData.length:",this.chartsData.length)
    const totalSlides = Math.ceil(this.chartsData.length / 2);
    this.totalSlides = totalSlides
    if (this.currentIndex < totalSlides  - 1) {
      $('#chartCarousel').carousel('next');
    }
  }
  
  prevSlide() {
    const totalSlides = Math.ceil(this.chartsData.length / 2);
    if (this.currentIndex > 0) {
      $('#chartCarousel').carousel('prev');
    }
  }

  visibleFollowupMonth: boolean = false
  followupStartMonth: any;
  followupEndMonth: any;
  bsConfig!: Partial<BsDatepickerConfig>;

  onclick() {
    this.visibleFollowupMonth = !this.visibleFollowupMonth
  }

  onclickBar() {
    this.visibleBarMonth = !this.visibleBarMonth
  }

  preventTyping(event: KeyboardEvent): void {
    event.preventDefault();
  }

  clearFollow(): void {
    this.visibleFollowupMonth = false;
    // Reset bsValue of dp1 and dp2 to undefined
    if (this.dpFollowupStart) {
      this.dpFollowupStart.bsValue = undefined;
    }
    if (this.dpFollowupEnd) {
      this.dpFollowupEnd.bsValue = undefined;
    }

    // Clear any selected start and end dates
    this.followupStartMonth = undefined;
    this.followupEndMonth = undefined;
    this.isGlobalDateCategory = true;
    // this.getLineChartCounts();
  }

  visibleBarMonth: boolean = false
  clearBarChart(): void {
    this.visibleBarMonth = false;
    // Reset bsValue of dp1 and dp2 to undefined
    if (this.dpBarStart) {
      this.dpBarStart.bsValue = undefined;
    }
    if (this.dpBarEnd) {
      this.dpBarEnd.bsValue = undefined;
    }

    // Clear any selected start and end dates
    this.horizontalBarStartMonth = undefined;
    this.horizontalBarEndMonth = undefined;
    this.isGlobalDateCategory = true;
    this.getHorizontalChartCounts(this.selectedFollowupCardIndex);
  }

  applyFilter() {
    let filterObject: any = {}
    if (sessionStorage.getItem('filterObject')) {
      filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
    }
    let checkedZones: any = [];
    checkedZones = this.dropdownData
      .filter((zone: any) => zone.checked)         // Filter checked zones
      .map((zone: any) => zone.zone_id);                // Map to zone IDs

    let checkedStates: any = []
    checkedStates = this.dropdownData.flatMap((zone: any) => zone.States)
      .filter((state: any) => state.checked)     // Filter checked regions
      .map((state: any) => state.state_id);            // Map to region IDs

    // Get checked region IDs
    let checkedRegions: any = []
    checkedRegions = this.dropdownData.flatMap((zone: any) => zone.States)
      .flatMap((zone: any) => zone.Regions)        // Flatten regions
      .filter((region: any) => region.checked)     // Filter checked regions
      .map((region: any) => region.region_id);            // Map to region IDs

    // Get checked area IDs
    let checkedAreas: any = []
    // checkedAreas = this.dropdownData.flatMap((zone: any) => zone.States)
    //   .flatMap((zone: any) => zone.Regions)        // Flatten regions
    //   .flatMap((region: any) => region.Areas)      // Flatten areas
    //   .filter((area: any) => area.checked)         // Filter checked areas
    //   .map((area: any) => area.area_id);                // Map to area IDs

    let checkedCategories: any = []
    checkedCategories = this.categoryData.filter((category: any) => category.checked)         // Filter checked areas
      .map((category: any) => category.category_id);

    let checkedModels: any = []
    checkedModels = this.modelsData.filter((model: any) => model.checked)     // Filter checked regions
      .map((model: any) => model.model_id);

    let checkedBaseLeadSource: any = []
    checkedBaseLeadSource = [
      ...new Set(
        this.sourceList
          .filter((source: any) => source.checked)
          .map((source: any) => source.base_lead_source_id)
      )
    ];

    let checkedSource: any = []
    checkedSource = this.sourceList
      .filter((source: any) => source.checked)
      .map((source: any) => source.id);

    let checkedSubSource: any = []
    checkedSubSource = this.sourceList
      .flatMap((source: any) => source.lead_sub_sources)
      .filter((subSource: any) => subSource.checked)
      .map((subSource: any) => subSource.id);

    let checkedUserType: any = [];
    checkedUserType = this.userData.filter((user: any) => user.checked)         // Filter checked areas
      .map((user: any) => user.role_id);

    let checkedStatus: any = []
    checkedStatus = this.statusesToggle.filter((status: any) => status.checked)         // Filter checked areas
      .map((status: any) => status.value);

    let checkedDealer: any = [];
    let checkedOutlet: any = []
    if (this.roleId == 8 || this.roleId == 5 || this.roleId == 10) {
      checkedDealer = [
        ...new Set(
          this.dealerData
            .filter((dealer: any) => dealer.checked)
            .map((dealer: any) => dealer.parent_dealer_id)
        )
      ];

      checkedOutlet = this.dealerData
        // .flatMap((dealer: any) => dealer.Outlets)
        .filter((outlet: any) => outlet.checked)
        .map((outlet: any) => outlet.outlet_id);
    } else {
      checkedDealer = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)
        // .flatMap((region: any) => region.Areas)
        .flatMap((area: any) => area.ParentDealers)
        .filter((dealer: any) => dealer.checked)
        .map((dealer: any) => dealer.parent_dealer_id);


      checkedOutlet = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)
        // .flatMap((region: any) => region.Areas)
        .flatMap((area: any) => area.ParentDealers)
        .flatMap((dealer: any) => dealer.Outlets)
        .filter((outlet: any) => outlet.checked)
        .map((outlet: any) => outlet.outlet_id);

    }

    filterObject.startDate = moment(this.startDate).format('YYYY-MM-DD');
    filterObject.endDate = moment(this.endDate).format('YYYY-MM-DD');
    filterObject.selectedButton = this.selectedButton;
    filterObject.zones = checkedZones;
    filterObject.states = checkedStates;
    filterObject.regions = checkedRegions;
    filterObject.areas = checkedAreas;
    filterObject.categories = checkedCategories;
    filterObject.models = checkedModels;
    filterObject.baseLeadSource = checkedBaseLeadSource;
    filterObject.source = checkedSource;
    filterObject.subSource = checkedSubSource;
    filterObject.userType = checkedUserType;
    filterObject.followUpToggle = checkedStatus;
    filterObject.parentDealer = checkedDealer;
    filterObject.outlet = checkedOutlet;
    sessionStorage.setItem('filterObject', JSON.stringify(filterObject))
    this.callApiOnCheck();
  }

  callApiOnCheck() {
    // this.isLoading = new BehaviorSubject<boolean>(true);
    // if (this.roleId == 8 || this.roleId == 9) {
    //   this.getParentDealerChartCounts();
    // } else {
    if (this.roleId == 7 || this.roleId == 6) {
      this.getRegionWiseCounts();
    } else {
      this.getZoneWiseCounts();
    }
    this.getGeographyChartCounts();
    // }
    if (this.selectedCardIndex != -1) {
      this.getRegionWiseCounts();
    }

    // this.getLineChartCounts();
    this.getHorizontalChartCounts(this.selectedFollowupCardIndex);
    // this.getFollowupTableCountData();
    setTimeout(() => {
      // this.isLoading = new BehaviorSubject<boolean>(false);
    }, 1600)
  }

  selectedStatusToggle: any = 'Follow Up TAT'
  toggleStatus(item: any, slider: any) {
    console.log("item: ", item)
    if (slider.checked) {
      this.selectedStatusToggle = item.label;
      this.statusesToggle.forEach((element: any) => {
        if (element.value != item.value) {
          element.checked = false;
        }
      });
      setTimeout(() => {
        // if (this.roleId == 8 || this.roleId == 9) {
        //   this.getParentDealerChartCounts();
        // } else {
        this.getGeographyChartCounts();
        // }
      }, 100);
    } else {
      setTimeout(() => {
        item.checked = true; // Reset the item's checked value to true
      }, 0);
    }

  }
  autoCheck(zone: any, region: any) {
    /** Autocheck logic */
    let anyRegionChecked: boolean = false;
    let anyAreaChecked: boolean = false;

    let initialCheck: boolean = false;
    initialCheck = zone.Regions.some((region: any) => region.checked);
    let initialCheckArea: boolean = false;
    if (region) {
      initialCheckArea = region.Areas.some((area: any) => area.checked);
    }
    if (!initialCheck) {
      for (const zoneItem of this.dropdownData) {
        let loopZoneId: any = zoneItem.zone_id
        // Check if any region in the current zone is checked
        anyRegionChecked = zoneItem.Regions.some((region: any) => region.checked && zone.zone_id != loopZoneId);

        if (anyRegionChecked) {
          zone.Regions.forEach((region: any) => {
            region.checked = true;
            // Check if any area is checked anywhere in dropdownData (not just current region)
            anyAreaChecked = this.dropdownData.some((z: any) =>
              z.Regions.some((r: any) => r.Areas.some((area: any) => area.checked))
            );

            if (anyAreaChecked) {
              region.Areas.forEach((area: any) => {
                area.checked = true;
              });
            }
          });
        }
      }
    }

    if (initialCheck && !initialCheckArea) {
      for (const zoneItem of this.dropdownData) {
        let loopZoneId: any = zoneItem.zone_id
        // Check if any region in the current zone is checked
        anyRegionChecked = zoneItem.Regions.some((region: any) => region.checked && zone.zone_id != loopZoneId);

        if (anyRegionChecked) {
          zone.Regions.forEach((reg: any) => {
            // Check if any area is checked anywhere in dropdownData (not just current region)
            anyAreaChecked = this.dropdownData.some((z: any) =>
              z.Regions.some((r: any) => r.Areas.some((area: any) => area.checked))
            );

            if (anyAreaChecked) {
              region.Areas.forEach((area: any) => {
                area.checked = true;
              });
            }
          });
        }
      }
    }
  }

  onDealerCheck(event: any, dealerId: any) {
    let dealer = this.dealerData.find((z: any) => z.parent_dealer_id == dealerId);
    let filteredDealer = this.filteredDealerData.find((z: any) => z.parent_dealer_id == dealerId);

    if (event.checked) {
      filteredDealer.checked = true;
      dealer.checked = true;
    } else {
      filteredDealer.checked = false;
      dealer.checked = false;

      dealer.Outlets.forEach((outlet: any) => {
        outlet.checked = false;
      });

      filteredDealer.Outlets.forEach((outlet: any) => {
        outlet.checked = false;
      });
    }
  }

  onOutletCheck(event: any, dealerId: any, outletId: any) {

    let dealer = this.dealerData.find((z: any) => z.parent_dealer_id == dealerId);

    let outlet = this.dealerData.find((r: any) => r.outlet_id == outletId);
    // Find the zone and region in filteredData using id
    let filteredDealer = this.filteredDealerData.find((z: any) => z.parent_dealer_id == dealerId);
    let filteredOutlet = this.filteredDealerData.find((r: any) => r.outlet_id == outletId);
    if (event.checked) {
      outlet.checked = true
      filteredOutlet.checked = true
      // const anyOutletChecked = dealer.Outlets.some((r: any) => r.checked);
      // if (anyOutletChecked) {
      //   dealer.checked = true;
      // }

      // const anyOutletCheckedInFiltered = filteredDealer.Outlets.some((r: any) => r.checked);
      // if (anyOutletCheckedInFiltered) {
      //   filteredDealer.checked = true;
      // }
    } else {
      outlet.checked = false;
      filteredOutlet.checked = false;
    }
  }

  isAnyAreaChecked: boolean = false;
  updateSelectAllStatus() {
    this.dropdownData.forEach((zone: any) => {
      // Update `selectAupdateSelectAllStatus() {
      this.dropdownData.forEach((zone: any) => {
        zone.States.forEach((state: any) => {
          const allStateChecked = zone.States.every((state: any) => state.checked);
          zone.selectALlStateChecked = allStateChecked
          // Update `selectAllAreasChecked` for each region
          state.Regions.forEach((region: any) => {
            const allAreasChecked = region.ParentDealers.every((dealer: any) => dealer.checked);
            region.selectAllAreasChecked = allAreasChecked;
          });

          // Update `selectAllChecked` for the zone
          const allRegionsChecked = state.Regions.every((region: any) => region.checked);
          state.selectAllChecked = allRegionsChecked;
        });
      });
      this.filterDealerByArea();
      let checkedAreas: any = []
      checkedAreas = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)        // Flatten regions
        .flatMap((region: any) => region.ParentDealers)      // Flatten areas
        .filter((area: any) => area.checked)         // Filter checked areas
        .map((area: any) => area.parent_dealer_id);
      if (checkedAreas.length > 0) {
        this.isAnyAreaChecked = true
      } else {
        this.isAnyAreaChecked = false
      }
    })
  }


  selectAllZoneChecked: boolean = false;
  onZoneCheckAll(event: any) {
    if (event.checked) {
      this.selectAllZoneChecked = true;
      this.dropdownData.forEach((zone: any) => {
        zone.checked = true;
      });
    } else {
      this.selectAllZoneChecked = false;
      this.dropdownData.forEach((zone: any) => {
        zone.checked = false;
        zone.States.forEach((state: any) => {
          state.checked = false;
          state.Regions.forEach((region: any) => {
            region.checked = false;
            // region.Areas.forEach((area: any) => {
            //   area.checked = false;
            region.ParentDealers.forEach((dealer: any) => {
              dealer.checked = false;
              dealer.Outlets.forEach((outlet: any) => {
                outlet.checked = false;
              });
            })
            // });
          })
        })
      });
    }
    this.updateSelectAllStatus();
  }

  onZoneCheck(event: any, zoneId: any) {
    let zone = this.dropdownData.find((z: any) => z.zone_id == zoneId);
    let filteredZone = this.filteredData.find((z: any) => z.zone_id == zoneId);

    if (event.checked) {
      filteredZone.checked = true;
      zone.checked = true;
      // this.autoCheck(zone, null);
    } else {
      filteredZone.checked = false;
      zone.checked = false;

      zone.States.forEach((state: any) => {
        state.checked = false;
        state.Regions.forEach((region: any) => {
          region.checked = false;
          // region.Areas.forEach((area: any) => {
          //   area.checked = false;
          region.ParentDealers.forEach((dealer: any) => {
            dealer.checked = false;
            dealer.Outlets.forEach((outlet: any) => {
              outlet.checked = false;
            });
          })
          // });
        });
      });

      filteredZone.States.forEach((state: any) => {
        state.checked = false;
        state.Regions.forEach((region: any) => {
          region.checked = false;
          // region.Areas.forEach((area: any) => {
          //   area.checked = false;
          region.ParentDealers.forEach((dealer: any) => {
            dealer.checked = false;
            dealer.Outlets.forEach((outlet: any) => {
              outlet.checked = false;
            });
          })
          // });
        });
      });
    }
    this.updateSelectAllStatus()
  }

  onRegionCheckAll(event: any, zoneId: any, stateId: any, stateObj: any) {
    let zone: any = this.dropdownData.find((z: any) => z.zone_id == zoneId);
    let state = zone.States.find((z: any) => z.state_id == stateId);
    let filteredZone = this.filteredData.find((z: any) => z.zone_id == zoneId);
    let filteredState = filteredZone.States.find((z: any) => z.state_id == stateId);
    if (event.checked) {
      // this.autoCheck(zone, null)
      zone.checked = true;
      filteredZone.checked = true;
      state.checked = true;
      filteredState.checked = true;
      stateObj.Regions.forEach((region: any) => {
        let regionToCheck = state.Regions.find((r: any) => r.region_id === region.region_id);
        let filteredRegionToCheck = filteredState.Regions.find((r: any) => r.region_id === region.region_id);

        if (regionToCheck) regionToCheck.checked = true;
        if (filteredRegionToCheck) filteredRegionToCheck.checked = true;
      });
    } else {

      stateObj.Regions.forEach((region: any) => {
        let regionToUncheck = state.Regions.find((r: any) => r.region_id === region.region_id);
        let filteredRegionToUncheck = filteredState.Regions.find((r: any) => r.region_id === region.region_id);

        if (regionToUncheck) regionToUncheck.checked = false;
        if (filteredRegionToUncheck) filteredRegionToUncheck.checked = false;

        // region.Areas.forEach((area: any) => {
        //   area.checked = false;
        region.ParentDealers.forEach((dealer: any) => {
          dealer.checked = false;
          dealer.Outlets.forEach((outlet: any) => {
            outlet.checked = false;
          });
        })
        // })
      });
    }
    this.updateSelectAllStatus()
  }

  updateSelectAllRegion(zoneId: any) {
    let zone = this.dropdownData.find((z: any) => z.zone_id == zoneId);
    let filteredZone = this.filteredData.find((z: any) => z.zone_id == zoneId);

    // Check if every region is checked
    let allRegionsChecked = zone.Regions.every((region: any) => region.checked);

    // Update the "Select All" checkbox for this zone
    zone.selectAllChecked = allRegionsChecked;
    filteredZone.selectAllChecked = allRegionsChecked;
  }

  onRegionCheck(event: any, zoneId: any, stateId: any, regionId: any) {
    // Find the zone and region in dropdownData using id
    let zone = { ...this.dropdownData.find((z: any) => z.zone_id == zoneId) };
    let state = zone?.States.find((r: any) => r.state_id == stateId);
    let region = state?.Regions.find((r: any) => r.region_id == regionId);

    // Find the zone and region in filteredData using id
    let filteredZone = this.filteredData.find((z: any) => z.zone_id == zoneId);
    let filteredState = filteredZone?.States.find((r: any) => r.state_id == stateId);
    let filteredRegion = filteredState?.Regions.find((r: any) => r.region_id == regionId);

    if (event.checked) {
      // this.autoCheck(zone, region);
      state.checked = true;
      filteredState.checked = true;
      region.checked = true
      filteredRegion.checked = true
      // Set zone checked if any region is checked in dropdownData
      const anyRegionChecked = zone.States.some((r: any) => r.checked);
      if (anyRegionChecked) {
        zone.checked = true;
      }

      // Set zone checked if any region is checked in filteredData
      const anyRegionCheckedInFiltered = filteredZone.States.some((r: any) => r.checked);
      if (anyRegionCheckedInFiltered) {
        filteredZone.checked = true;
      }
    } else {
      // Uncheck all areas within the unchecked region
      region.checked = false;
      // region?.Areas.forEach((area: any) => {
      //   area.checked = false;
      region.ParentDealers.forEach((dealer: any) => {
        dealer.checked = false;
        dealer.Outlets.forEach((outlet: any) => {
          outlet.checked = false;
        });
        // })
      });

      filteredRegion.checked = false;
      // filteredRegion?.Areas.forEach((area: any) => {
      //   area.checked = false;
      region.ParentDealers.forEach((dealer: any) => {
        dealer.checked = false;
        dealer.Outlets.forEach((outlet: any) => {
          outlet.checked = false;
        });
        // })
      });
    }
    this.updateSelectAllStatus()
  }


  onAreaCheckAll(event: any, zoneId: any, stateId: any, regionId: any) {
    let zone = this.dropdownData.find((z: any) => z.zone_id == zoneId);
    let state = zone.States.find((r: any) => r.state_id == stateId);
    let region = state.Regions.find((r: any) => r.region_id == regionId);

    let filteredZone = this.filteredData.find((z: any) => z.zone_id == zoneId);
    let filteredState = filteredZone.States.find((r: any) => r.state_id == stateId);
    let filteredRegion = filteredState.Regions.find((r: any) => r.region_id == regionId);

    if (event.checked) {
      zone.checked = true;
      filteredZone.checked = true;

      state.checked = true;
      filteredState.checked = true;

      region.checked = true;
      filteredRegion.checked = true;
      // Check all areas within this region
      // region.Areas.forEach((area: any) => {
      //   area.checked = true;

      region.ParentDealers.forEach((dealer: any) => {
        dealer.checked = true;
        dealer.Outlets.forEach((outlet: any) => {
          outlet.checked = true;
        });
      })

      // });

      // filteredRegion.Areas.forEach((area: any) => {
      //   area.checked = true;

      filteredRegion.ParentDealers.forEach((dealer: any) => {
        dealer.checked = true;
        dealer.Outlets.forEach((outlet: any) => {
          outlet.checked = true;
        });
      })
      // });
    } else {
      // Uncheck all areas within this region
      // region.Areas.forEach((area: any) => {
      //   area.checked = false;
      region.ParentDealers.forEach((dealer: any) => {
        dealer.checked = false;
        dealer.Outlets.forEach((outlet: any) => {
          outlet.checked = false;
        });
      })
      // });

      // filteredRegion.Areas.forEach((area: any) => {
      //   area.checked = false;
      filteredRegion.ParentDealers.forEach((dealer: any) => {
        dealer.checked = false;
        dealer.Outlets.forEach((outlet: any) => {
          outlet.checked = false;
        });
      })
      // });
    }
    this.updateSelectAllStatus()
  }
  updateRegionSelectAllStatus(zoneId: any, regionId: any) {
    let zone = this.dropdownData.find((z: any) => z.zone_id == zoneId);
    let region = zone.Regions.find((r: any) => r.region_id == regionId);


    let allAreasChecked = region.Areas.every((area: any) => area.checked);

    // Update the "Select All" checkbox for areas
    region.selectAllAreasChecked = allAreasChecked;
  }

  onAreaCheck(event: any, zoneId: any, stateId: any, regionId: any, outletId: any) {

    // Find the zone, region, and area based on the provided ids
    let zone = this.dropdownData.find((z: any) => z.zone_id == zoneId);
    let state = zone.States.find((r: any) => r.state_id == stateId);
    let region = state.Regions.find((r: any) => r.region_id == regionId);
    // let area = region.Areas.find((a: any) => a.area_id == areaId);

    let filteredZone = this.filteredData.find((z: any) => z.zone_id == zoneId);
    let filteredState = filteredZone.States.find((r: any) => r.state_id == stateId);
    let filteredRegion = filteredState.Regions.find((r: any) => r.region_id == regionId);
    // let filteredArea = filteredRegion.Areas.find((a: any) => a.area_id == areaId);

    if (event.checked) {
      region.checked = true;
      filteredRegion.checked = true;
      filteredRegion.ParentDealers.forEach((dealer: any) => {
        dealer.Outlets.forEach((outlet: any) => {
          if (outlet.outlet_id === outletId) {
            dealer.checked = true;       // Check the dealer if the outlet matches
            outlet.checked = true;       // Check only the specific outlet
          }
        });
      })
      region.ParentDealers.forEach((dealer: any) => {
        dealer.Outlets.forEach((outlet: any) => {
          if (outlet.outlet_id === outletId) {
            dealer.checked = true;       // Check the dealer if the outlet matches
            outlet.checked = true;       // Check only the specific outlet
          }
        });
      });

      const areaChecked = region.checked;
      // Set region checked if any area is checked
      if (areaChecked) {
        state.checked = areaChecked
        region.checked = areaChecked;
      }

      // Set zone checked if any region is checked
      const anyRegionChecked = state.Regions.some((region: any) => region.checked);
      if (anyRegionChecked) {
        zone.checked = anyRegionChecked;
      }

      // Repeat the same process for the filtered data
      const areaCheckedInFiltered = region.checked;

      // Set region checked if any area is checked in filtered data
      if (areaCheckedInFiltered) {
        filteredState.checked = areaCheckedInFiltered;
        filteredRegion.checked = areaCheckedInFiltered;
      }

      // Set zone checked if any region is checked in filtered data
      const anyRegionCheckedInFiltered = filteredZone.States.some((region: any) => region.checked);
      if (anyRegionCheckedInFiltered) {
        filteredZone.checked = areaCheckedInFiltered;
      }
    } else {
      // filteredRegion.checked = false;
      // region.checked = false;
      region.ParentDealers.forEach((dealer: any) => {
        dealer.Outlets.forEach((outlet: any) => {
          if (outlet.outlet_id === outletId) {
            outlet.checked = false;       // Check only the specific outlet
          }
        });
        const allOutletsUnchecked = dealer.Outlets.every((outlet: any) => !outlet.checked);

        // If all outlets are unchecked, uncheck the dealer
        if (allOutletsUnchecked) {
          dealer.checked = false;
          // filteredRegion.checked = false;
          // region.checked = false;
        }
      })
      filteredRegion.ParentDealers.forEach((dealer: any) => {
        dealer.Outlets.forEach((outlet: any) => {
          if (outlet.outlet_id === outletId) {
            outlet.checked = false;       // Check only the specific outlet
          }
        });
        const allOutletsUnchecked = dealer.Outlets.every((outlet: any) => !outlet.checked);

        // If all outlets are unchecked, uncheck the dealer
        if (allOutletsUnchecked) {
          dealer.checked = false;
          // filteredRegion.checked = false;
          // region.checked = false;
        }
      })
    }
    this.updateSelectAllStatus()
  }

  onBaseSourceCheck(event: any, baseSourceId: any) {
    let baseSource = this.sourceList.find((z: any) => z.id == baseSourceId);
    let filteredBaseSource = this.filteredDataSource.find((z: any) => z.id == baseSourceId);

    if (event.checked) {
      filteredBaseSource.checked = true;
      baseSource.checked = true;

    } else {
      filteredBaseSource.checked = false;
      baseSource.checked = false;

      baseSource.lead_sources.forEach((source: any) => {
        source.checked = false;
        source.lead_sub_sources.forEach((subsource: any) => {
          subsource.checked = false;
        });
      });

      filteredBaseSource.lead_sources.forEach((source: any) => {
        source.checked = false;
        source.lead_sub_sources.forEach((subsource: any) => {
          subsource.checked = false;
        });
      });
    }
    this.updateSelectAllSource();
  }

  onSourceCheck(event: any, baseSourceId: any, sourceId: any) {
    let source = this.sourceList.find((r: any) => r.id == sourceId);

    let filteredSource = this.filteredDataSource.find((r: any) => r.id == sourceId);

    if (event.checked) {
      source.checked = true
      filteredSource.checked = true
      // Set zone checked if any region is checked in dropdownData
      const anySourceChecked = source.lead_sub_sources.some((r: any) => r.checked);
      if (anySourceChecked) {
        source.checked = true;
      }

      // Set zone checked if any region is checked in filteredData
      const anySourceCheckedInFiltered = filteredSource.lead_sub_sources.some((r: any) => r.checked);
      if (anySourceCheckedInFiltered) {
        filteredSource.checked = true;
      }
    } else {
      // Uncheck all areas within the unchecked region
      source.checked = false;
      source?.lead_sub_sources.forEach((ss: any) => {
        ss.checked = false;
      });

      filteredSource.checked = false;
      filteredSource?.lead_sub_sources.forEach((ss: any) => {
        ss.checked = false;
      });
    }
    this.updateSelectAllSource();
  }


  onSubsourceCheck(event: any, baseSourceId: any, sourceId: any, subSourceId: any) {
    // Find the zone, region, and area based on the provided ids
    // let baseSource = this.sourceList.find((z: any) => z.id == baseSourceId);
    let source = this.sourceList.find((r: any) => r.id == sourceId);
    let subSource = source.lead_sub_sources.find((a: any) => a.id == subSourceId);

    // let filteredBaseSource = this.filteredDataSource.find((z: any) => z.id == baseSourceId);
    let filteredSource = this.sourceList.find((r: any) => r.id == sourceId);
    let filteredSubSource = filteredSource.lead_sub_sources.find((a: any) => a.id == subSourceId);

    if (event.checked) {
      subSource.checked = true;
      filteredSubSource.checked = true;

      const subSourceChecked = subSource.checked;
      // Set region checked if any area is checked
      if (subSourceChecked) {
        source.checked = subSourceChecked;
      }

      // Set zone checked if any region is checked
      // const anySourceChecked = baseSource.lead_sources.some((ls: any) => ls.checked);
      // if (anySourceChecked) {
      //   baseSource.checked = anySourceChecked;
      // }

      // Repeat the same process for the filtered data
      const subSourceCheckedInFiltered = filteredSubSource.checked;

      // Set region checked if any area is checked in filtered data
      if (subSourceCheckedInFiltered) {
        filteredSource.checked = subSourceCheckedInFiltered;
      }

      // Set zone checked if any region is checked in filtered data
      // const anySourceCheckedInFiltered = filteredBaseSource.lead_sources.some((ls: any) => ls.checked);
      // if (anySourceCheckedInFiltered) {
      //   filteredBaseSource.checked = subSourceCheckedInFiltered;
      // }
    } else {
      filteredSubSource.checked = false;
      subSource.checked = false;
    }
    this.updateSelectAllSource();
  }

  updateSelectAllSource() {
    this.sourceList.forEach((leadsource: any) => {
      const allSubsourceChecked = leadsource.lead_sub_sources.every((area: any) => area.checked);
      leadsource.selectAllSubSourceChecked = allSubsourceChecked;
    });

    // Update `selectAllChecked` for the zone
    this.selectAllSourceChecked = this.filteredDataSource.every((source: any) => source.checked);
    // source.selectAllSourceChecked = allLeadSourceChecked;
    // });
  }

  selectAllSourceChecked: boolean = false;
  onSourceCheckAll(event: any) {
    if (event.checked) {
      this.sourceList.forEach((item: any) => {
        item.checked = true;
      })
      this.selectAllSourceChecked = true;
    } else {
      this.sourceList.forEach((item: any) => {
        item.checked = false;
        item.lead_sub_sources.forEach((subsource: any) => {
          subsource.checked = false;
        });
      })
      this.selectAllSourceChecked = false;
    }

    this.updateSelectAllSource()
  }

  onSubSourceCheckAll(event: any, baseId: any, sourceId: any) {
    // let base = this.sourceList.find((z: any) => z.id == baseId);
    let leadsource = this.sourceList.find((r: any) => r.id == sourceId);

    // let filteredBase = this.filteredDataSource.find((z: any) => z.id == baseId);
    let filteredLeadSource = this.sourceList.find((r: any) => r.id == sourceId);

    if (event.checked) {
      // base.checked = true;
      // filteredBase.checked = true;

      leadsource.checked = true;
      filteredLeadSource.checked = true;
      // Check all areas within this region
      leadsource.lead_sub_sources.forEach((subsource: any) => {
        subsource.checked = true;
      });

      filteredLeadSource.lead_sub_sources.forEach((subsource: any) => {
        subsource.checked = true;
      });
    } else {
      // Uncheck all areas within this region
      leadsource.lead_sub_sources.forEach((subsource: any) => {
        subsource.checked = false;
      });

      filteredLeadSource.lead_sub_sources.forEach((subsource: any) => {
        subsource.checked = false;
      });
    }
    this.updateSelectAllSource()
  }

  onCategoryCheck(event: any, catId: any) {
    const checkedCategoryIds = this.categoryData
      .filter((category: any) => category.checked)  // Filter categories where checked is true
      .map((category: any) => category.category_id);         // Map only the category IDs
    const allUnchecked = this.categoryData.every((category: any) => !category.checked);
    this.modelsData.forEach((model: any) => {
      if (!checkedCategoryIds.includes(model.category_id)) {
        model.checked = false;
      }
    })
    if (allUnchecked) {
      this.filteredModelData = [...this.modelsData]; // Reset filtered model data if all categories are unchecked
    } else {
      this.filteredModelData = [...this.modelsData.filter((model: any) => checkedCategoryIds.includes(model.category_id))]
    }
  }

  onModelCheck(event: any) {
    // this.callApiOnCheck();
  }

  onStatusCheck(event: any, id: any) {
    if (event.checked) {
      this.statusData.forEach((item: any) => {
        if (item.id != id) {
          item.checked = false
        }
      })
    }
  }

  onUserCheck(event: any, obj: any) {
    if (event.checked) {
      this.userData.forEach((item: any) => {
        if (item.role_id != obj.role_id) {
          item.checked = false;
        }
      });
    } else {
      setTimeout(() => {
        obj.checked = true; // Reset the item's checked value to true
      }, 0);
    }
  }

  clearFilter(data: any) {
    this.selectThisMonth();
    sessionStorage.removeItem('filterObject');
    this.selectedRegionalMgrs = [];
    this.selectedZonalMgrs = [];
    this.selectedAreaMgrs = [];
    this.searchTerm = '';

    this.dropdownData.forEach((zone: any) => {
      zone.checked = false;
      zone.selectAllChecked = false;
      zone.States.forEach((state: any) => {
        state.checked = false;
        state.Regions.forEach((region: any) => {
          region.selectAllAreasChecked = false;
          region.checked = false;
          // region.Areas.forEach((area: any) => {
          //   area.checked = false;
          region.ParentDealers.forEach((dealer: any) => {
            dealer.checked = false;
            dealer.Outlets.forEach((outlet: any) => {
              outlet.checked = false;
            });
          })
          // })
        });
      });
    })
    this.selectAllZoneChecked = false;
    this.selectAllModelChecked = false;
    this.selectAllCategoryChecked = false;

    this.statusData.forEach((status: any) => {
      status.checked = false;
    })

    this.categoryData.forEach((cat: any) => {
      cat.checked = false;
    })

    this.modelsData.forEach((model: any) => {
      model.checked = false;
    })
    this.filteredModelData = [...this.modelsData];

    this.sourceList.forEach((source: any) => {
      source.checked = false;
      source.lead_sub_sources.forEach((ss: any) => {
        ss.checked = false;
      });
    });

    this.dealerData.forEach((dealer: any) => {
      dealer.checked = false;
      // dealer.Outlets.forEach((outlet: any) => {
      //   outlet.checked = false;
      // });
    })

    this.filteredData = [...this.dropdownData];
    this.filteredDataSource = [...this.sourceList];
    this.filteredDealerData = [...this.dealerData];
    // this.isLoading = new BehaviorSubject<boolean>(true);

    setTimeout(() => {
      // if (this.roleId == 8 || this.roleId == 9) {
      //   this.getParentDealerChartCounts();
      // } else {
      this.getGeographyChartCounts();
      // }
      // this.getLineChartCounts();
      this.getHorizontalChartCounts(this.selectedFollowupCardIndex);
      // this.getFollowupTableCountData();
    }, 200)
    setTimeout(() => {
      // this.isLoading = new BehaviorSubject<boolean>(false);
    }, 2000)
    if (data) {
      this.getZoneWiseCounts();
    }
  }

  toggleDropdown(event: Event) {
    const target = event.currentTarget as HTMLElement;
    const parentDropdown = target.closest('.dropdown-submenu');
    if (parentDropdown) {
      const submenu = parentDropdown.querySelector('.dropdown-menu') as HTMLElement;
      submenu.style.display = submenu.style.display === 'block' ? 'none' : 'block';
      event.stopPropagation();
    }
  }


  searchTerm: string = ''; // Bind this to the search input
  filteredData: any = [...this.dropdownData]; // Initialize filtered data
  // Filter logic to filter zones, regions, and areas based on the search term
  filterDropdownData() {
    const searchLower = this.searchTerm.toLowerCase();

    this.filteredData = this.dropdownData.map((zone: any) => ({
      ...zone,
      States: zone.States.map((state: any) => ({
        ...state,
        Regions: state.Regions.map((region: any) => ({
          ...region,
          ParentDealers: region.ParentDealers.map((dealer: any) => ({
            ...dealer,
            Outlets: dealer.Outlets.filter((outlet: any) =>
              outlet.outlet_name.toLowerCase().includes(searchLower)
            )
          })).filter((dealer: any) =>
            dealer.parent_dealer_name.toLowerCase().includes(searchLower) ||
            dealer.Outlets.length > 0
          )
        })).filter((region: any) =>
          region.region_name.toLowerCase().includes(searchLower) ||
          region.ParentDealers.length > 0
        )
      })).filter((state: any) =>
        state.state_name.toLowerCase().includes(searchLower) ||
        state.Regions.length > 0
      )
    })).filter((zone: any) =>
      zone.zone_name.toLowerCase().includes(searchLower) ||
      zone.States.length > 0
    );
  }



  searchTermDealer: string = ''; // Bind this to the search input
  filterDealerData() {
    const searchLower = this.searchTermDealer.toLowerCase();
    this.filteredDealerData = this.dealerData.map((dealer: any) => ({
      ...dealer,
      Outlets: dealer.Outlets.map((outlet: any) => ({
        ...outlet
      })).filter((outlet: any) => outlet.outlet_name.toLowerCase().includes(searchLower))
    })).filter((dealer: any) => dealer.parent_dealer_name.toLowerCase().includes(searchLower) || dealer.Outlets.length > 0);
  }


  sourceList: any = [];
  sourceSearchTerm: string = ''; // Bind this to the search input
  filteredDataSource: any = [...this.sourceList]; // Initialize filtered data
  // Filter logic to filter zones, regions, and areas based on the search term
  filterSourceData() {
    const searchLower = this.sourceSearchTerm.toLowerCase();
    this.filteredDataSource = this.sourceList.map((zone: any) => ({
      ...zone,
      Regions: zone.Regions.map((region: any) => ({
        ...region,
        areas: region.areas.filter((area: any) => area.area_name.toLowerCase().includes(searchLower)),
      })).filter((region: any) => region.region_name.toLowerCase().includes(searchLower) || region.areas.length > 0),
    })).filter((zone: any) => zone.zone_name.toLowerCase().includes(searchLower) || zone.Regions.length > 0);
  }



  /** Service call & Data Manipulations */
  getGeographyList() {
    let filterObject: any = {}
    if (sessionStorage.getItem('filterObject')) {
      filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
    }
    let request: any = {};
    request["is_outlet_all"] = this.isActiveOutlet ? 2 : 1;
    this.followupService.getGeography(request).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        this.dropdownData = responseData.data
        if (!this.isEmpty(filterObject)) {
          if (filterObject.zones) {
            this.dropdownData.forEach((zone: any) => {
              if (filterObject.zones.includes(zone.zone_id)) {
                zone.checked = true;
                zone.States.forEach((state: any) => {
                  if (filterObject.states.includes(state.state_id)) {
                    state.checked = true;
                    state.Regions.forEach((region: any) => {
                      if (filterObject.regions.includes(region.region_id)) {
                        region.checked = true;
                        // region.Areas.forEach((area: any) => {
                        //   if (filterObject.areas.includes(area.area_id)) {
                        //     area.checked = true;
                        region.ParentDealers.forEach((dealer: any) => {
                          if (filterObject.parentDealer.includes(dealer.parent_dealer_id)) {
                            dealer.checked = true;
                          }
                          dealer.Outlets.forEach((outlet: any) => {
                            if (filterObject.outlet.includes(outlet.outlet_id)) {
                              outlet.checked = true;
                            }
                          });
                        });
                        //   }
                        // });
                      }
                    });
                  }
                });
              }
            });
          }
          setTimeout(() => {
            //   if(this.roleId == 8 || this.roleId == 9 ){
            //   this.dealerData = this.dropdownData.flatMap((zone: any) =>
            //     zone.States.flatMap((state: any) =>
            //       state.Regions.flatMap((region: any) =>
            //         region.Areas
            //           .filter((area: any) =>
            //             (filterObject?.areas || []).includes(area.area_id)
            //           )
            //           .flatMap((filteredArea: any) =>
            //             filteredArea.ParentDealers.map((dealer: any) => ({
            //               ...dealer,
            //               checked: (filterObject?.parentDealer || []).includes(dealer.parent_dealer_id),
            //               Outlets: dealer.Outlets.map((outlet: any) => ({
            //                 ...outlet,
            //                 checked: (filterObject?.outlet || []).includes(outlet.outlet_id)
            //               }))
            //             }))
            //           )
            //       )
            //     )
            //   );
            // }
            let everyZoneChecked: boolean = false;
            everyZoneChecked = this.dropdownData.every((zone: any) => zone.checked)
            this.selectAllZoneChecked = everyZoneChecked;
            this.updateSelectAllStatus();
          }, 300)
        } else {
          this.filterDealerByArea();
        }
        if (this.roleId == 7 || this.roleId == 6) {
          this.getRegionWiseCounts();
        } else {
          this.getZoneWiseCounts();
        }
        this.filteredData = [...this.dropdownData]; // Initialize filtered data
      }
    });
  }

  getSourceList() {
    this.followupService.getLeadSource({}).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        this.sourceList = responseData.data
        if (!this.isEmpty(this.filterObject)) {
          if (this.filterObject.baseLeadSource) {
            this.sourceList.forEach((baseSource: any) => {
              if (this.filterObject.baseLeadSource.includes(baseSource.id)) {
                baseSource.checked = true;
                baseSource.lead_sources.forEach((source: any) => {
                  if (this.filterObject.source.includes(source.id)) {
                    source.checked = true;
                    source.lead_sub_sources.forEach((subSource: any) => {
                      if (this.filterObject.subSource.includes(subSource.id)) {
                        subSource.checked = true;
                      }
                    });
                  }
                });
              }
            });
          }
          setTimeout(() => {
            this.updateSelectAllSource();
          }, 300)
        }
        this.sourceList = this.flattenLeadSources(this.sourceList)
        // let obj: any = {
        //   "id": 4,
        //   "lead_source": "DMS",
        //   "status": true,
        //   "lead_sub_sources": [],
        //   "base_lead_source_id": 1,
        //   "selectAllSubSourceChecked": true
        // }
        // this.sourceList.push(obj);
        // console.log("sourceList: ", this.sourceList)
        this.filteredDataSource = [...this.sourceList]; // Initialize filtered data
      }
    });
  }

  flattenLeadSources(data: any) {
    let leadSourcesArray: any = [];

    data.forEach((baseSource: any) => {
      baseSource.lead_sources.forEach((leadSource: any) => {
        leadSourcesArray.push({
          ...leadSource,
          base_lead_source_id: baseSource.id // Assign base lead source ID
        });
      });
    });

    return leadSourcesArray;
  }

  getStatusList() {
    let request = { "caseToEvaluate": "dms_stage" }

    this.followupService.getStatus(request).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        this.statusData = responseData.data
      }
    });
  }

  filteredModelData: any = [];
  getProductList() {
    this.followupService.getProduct({}).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        if (responseData.data.length > 0) {
          this.categoryData = responseData.data
          if (!this.isEmpty(this.filterObject)) {
            if (this.filterObject.categories) {
              this.categoryData.forEach((category: any) => {
                if (this.filterObject.categories.includes(category.category_id)) {
                  category.checked = true;
                  category.Models.forEach((model: any) => {
                    if (this.filterObject.models) {
                      if (this.filterObject.models.includes(model.model_id)) {
                        model.checked = true;
                      }
                    }
                  })
                }
              });
            }
          }
          this.modelsData = [...this.categoryData.reduce((acc: any, category: any) => {
            return acc.concat(category.Models);
          }, [])];
          this.filteredModelData = [...this.modelsData]

        }
      }
    });
  }


  filteredDealerData: any = [];
  dealerData: any = [];
  getDealerOutletList() {
    let req: any = { "is_outlet_all": this.isActiveOutlet ? 2 : 1 };
    this.followupService.getDealersAndOutlets(req).subscribe((response: any) => {
      let responseData: any = response.body;
      this.isLoading = new BehaviorSubject<boolean>(false);
      if (responseData.responseCode == 200) {
        if (responseData.data.length > 0) {
          this.dealerData = [...responseData.data];
          if (!this.isEmpty(this.filterObject)) {
            if (this.filterObject.parentDealer) {
              this.dealerData.forEach((dealer: any) => {
                if (this.filterObject.parentDealer.includes(dealer.parent_dealer_id)) {
                  dealer.checked = true;
                  dealer.Outlets.forEach((outlet: any) => {
                    if (this.filterObject.outlet.includes(outlet.outlet_id)) {
                      outlet.checked = true;
                    }
                  });
                }
              });
            }
          }
          this.dealerData = this.flattenParentDealer(this.dealerData)
          this.filteredDealerData = [...this.dealerData]
        }
      }
    });
  }

  flattenParentDealer(data: any) {
    let outletsArray: any = [];

    data.forEach((dealer: any) => {
      dealer.Outlets.forEach((outlet: any) => {
        outletsArray.push({
          ...outlet,
          parent_dealer_id: dealer.parent_dealer_id // Assign base lead source ID
        });
      });
    });
    return outletsArray;
  }

  getUserList() {
    let request: any = {}
    this.followupService.getUser(request).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        let data: any = responseData.data
        if (data.length > 0) {
          let tempData: any = data.filter((item: any) => item.role_id == 3 || item.role_id == 4);
          if (tempData.length > 0) {
            this.userData = tempData
            this.userData.forEach((item: any) => {
              if (item.role_id == 4) {
                item.checked = true;
              }
            })
          }
        }
      }
    });
  }

  allZoneCounts: any = []
  totalLeadsInZones: any = 0
  totalEnquiries: any = 0;
  overallCountObj: any = {}
  getZoneWiseCounts() {
    this.startLoading();
    let checkedUserType: any = [];
    checkedUserType = this.userData.filter((user: any) => user.checked)         // Filter checked areas
      .map((user: any) => user.role_id);

    let checkedZones: any = [];
    checkedZones = this.selectedZonalMgrs.map((zone: any) => zone.zone_id);

    let request: any = {
      "startDate": moment(this.startDate).format('YYYY-MM-DD'), //mandatory
      "endDate": moment(this.endDate).format('YYYY-MM-DD'), //mandatory
      "groupby": "zone",
      "responseType": "arrayOfObjects",
      "current_stage.role_id": 3,
      "sortby": this.selectedFollowupCard,
      "current_stage.stage_id": checkedUserType[0] == 3 ? this.stageIds : [2, 4, 5, 7, 14, 15, 16],
    }
    if (this.selectedFollowupCardIndex == 0) {
      request['current_stage.role_id'] = 4;
      request['current_stage.stage_id'] = [2, 4, 5, 6, 7, 9, 10, 12, 13, 14, 15, 16];
    }
    if (checkedZones.length > 0) {
      request['outlet_details.zone_id'] = checkedZones
    }
    if(request['current_stage.role_id'] == 3){
      request["current_stage.stage_id"] = this.stageIds 
    }else{
       request["current_stage.stage_id"] = [2, 4, 5, 7, 14, 15, 16]
    }
    request["is_outlet_all"] = this.isActiveOutlet ? 2 : 1;
    this.headerCards = [];
    // this.isLoading = new BehaviorSubject<boolean>(true);
    this.followupService.getZoneCounts(request).subscribe({
      next: (response: any) => {
        let responseData: any = response.body;
        if (responseData.responseCode == 200) {
          // this.totalEnquiries = responseData?.total ? responseData?.total : 0;
          let totalLeadsMap = responseData.total.reduce((acc: any, item: any) => {
            acc[item.zone_id] = item.totalLeads;
            return acc;
          }, {});
          // Update data array with the totalLeadsInZone key
          let tempObj = responseData.data.filter((item: any) => item.zone_id == 0)
          if (tempObj.length > 0) {
            this.overallCountObj = tempObj[0]
          }
          responseData.data = responseData.data.filter((item: any) => item.zone_id !== 0).map((item: any) => ({
            ...item,
            totalLeadsInZone: totalLeadsMap[item.zone_id] || 0
          }));

          this.headerCards = []
          this.dropdownData.forEach((item: any) => {
            // Flag to track if zone_id is found
            let found = false;

            responseData?.data?.forEach((element: any) => {
              if (item.zone_id == element.zone_id) {
                // If a match is found, push the object and set the flag to true
                this.headerCards.push({ totalLeadsInZone: element?.totalLeadsInZone ? element?.totalLeadsInZone : 0, id: item.zone_id, name: item.zone_name.replace(/\s\(\d+\)$/, ''), count: element.count ? element.count : 0, Count: element.Count ? element.Count : this.selectedFollowupCardIndex == 2 ? 0 : '0h 0m 0s', totalLeads: element?.totalLeads || 0 });
                found = true;
              }
            });
            // If no match was found, push the default value only if the object is not already in headerCards
            if (!found && !this.headerCards.some((card: any) => card.id == item.zone_id)) {
              this.headerCards.push({ totalLeadsInZone: 0, id: item.zone_id, name: item.zone_name.replace(/\s\(\d+\)$/, ''), count: 0, Count: this.selectedFollowupCardIndex == 2 ? 0 : '0h 0m 0s' });
            }
          });
          /**To sort the zones by id */

          this.headerCards.sort((a: any, b: any) => a.id - b.id);
          const customOrder = ["East", "North", "South 1", "South 2", "West"];

          const sorted = this.headerCards.sort((a: any, b: any) => {
            return customOrder.indexOf(a.name) - customOrder.indexOf(b.name);
          });
          console.log("headerCards: ", this.headerCards)
          setTimeout(() => {
            // this.isLoading = new BehaviorSubject<boolean>(false);
          }, 1200)
        }
      }, error: (err) => {
        console.error('Error fetching stage counts:', err);
        this.stopLoading()
      },
      complete: () => {
        this.stopLoading()
      }
    });
  }

  getRegionWiseCounts() {
    let checkedUserType: any = [];
    checkedUserType = this.userData.filter((user: any) => user.checked)         // Filter checked areas
      .map((user: any) => user.role_id);
    let request: any = {
      "startDate": moment(this.startDate).format('YYYY-MM-DD'), //mandatory
      "endDate": moment(this.endDate).format('YYYY-MM-DD'), //mandatory
      "groupby": "region",
      "responseType": "arrayOfObjects",
      "current_stage.role_id": checkedUserType.length > 0 ? checkedUserType[0] : 3,
      "sortby": this.selectedFollowupCard,
      "outlet_details.zone_id": this.roleId == 6 ? this.userDetails.zone_id : this.selectedZone.id,
      "current_stage.stage_id": checkedUserType[0] == 3 ? this.stageIds : [2, 4, 5, 7, 14, 15, 16],
    }
    if (this.selectedFollowupCardIndex == 0) {
      request['current_stage.role_id'] = 4;
    }
    request["is_outlet_all"] = this.isActiveOutlet ? 2 : 1;
    this.subHeaderCards = [];
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.followupService.getZoneCounts(request).subscribe({
      next: (response: any) => {
        let responseData: any = response.body;
        if (responseData.responseCode == 200) {
          let totalLeadsMap = responseData?.total?.reduce((acc: any, item: any) => {
            acc[item.region_id] = item.totalLeads;
            return acc;
          }, {});
          // Update data array with the totalLeadsInZone key
          responseData.data = responseData.data.filter((item: any) => item.zone_id !== 0).map((item: any) => ({
            ...item,
            totalLeadsInZone: totalLeadsMap[item.region_id] || 0
          }));
          this.subHeaderCards = responseData.data;
          /**To sort the zones by id */
          this.subHeaderCards.sort((a: any, b: any) => a.region_id - b.region_id);
          setTimeout(() => {
            this.isLoading = new BehaviorSubject<boolean>(false);
          }, 1200)
        }
      }, error: (err) => {
        console.error('Error fetching stage counts:', err);
      },
      complete: () => {
      }
    });
  }


  getGeographyChartCounts() {
    // this.startLoading()
    // Get checked zone IDs
    let checkedZones: any = [];
    checkedZones = this.dropdownData
      .filter((zone: any) => zone.checked)         // Filter checked zones
      .map((zone: any) => zone.zone_id);                // Map to zone IDs

    let checkedStates: any = []
    checkedStates = this.dropdownData.flatMap((zone: any) => zone.States)
      .filter((state: any) => state.checked)
      .map((state: any) => state.state_id);

    // Get checked region IDs
    let checkedRegions: any = []
    checkedRegions = this.dropdownData.flatMap((zone: any) => zone.States)
      .flatMap((zone: any) => zone.Regions)        // Flatten regions
      .filter((region: any) => region.checked)     // Filter checked regions
      .map((region: any) => region.region_id);            // Map to region IDs

    // Get checked area IDs
    let checkedAreas: any = []
    // checkedAreas = this.dropdownData.flatMap((zone: any) => zone.States)
    //   .flatMap((zone: any) => zone.Regions)        // Flatten regions
    //   .flatMap((region: any) => region.Areas)      // Flatten areas
    //   .filter((area: any) => area.checked)         // Filter checked areas
    //   .map((area: any) => area.area_id);        

    let checkedCategories: any = []
    checkedCategories = this.categoryData.filter((category: any) => category.checked)         // Filter checked areas
      .map((category: any) => category.category_id);

    let checkedModels: any = []
    checkedModels = this.modelsData.filter((model: any) => model.checked)     // Filter checked regions
      .map((model: any) => model.model_id);

    let checkedBaseLeadSource: any = []
    checkedBaseLeadSource = [
      ...new Set(
        this.sourceList
          .filter((source: any) => source.checked)
          .map((source: any) => source.base_lead_source_id)
      )
    ];

    let checkedSource: any = []
    checkedSource = this.sourceList
      .filter((source: any) => source.checked)
      .map((source: any) => source.id);

    let checkedSubSource: any = []
    checkedSubSource = this.sourceList
      .flatMap((source: any) => source.lead_sub_sources)
      .filter((subSource: any) => subSource.checked)
      .map((subSource: any) => subSource.id);

    let checkedStatus: any = []
    checkedStatus = this.statusesToggle.filter((status: any) => status.checked)         // Filter checked areas
      .map((status: any) => status.value);

    let checkedDealer: any = [];
    let checkedOutlet: any = []
    if (this.roleId == 8 || this.roleId == 5 || this.roleId == 10) {
      checkedDealer = [
        ...new Set(
          this.dealerData
            .filter((dealer: any) => dealer.checked)
            .map((dealer: any) => dealer.parent_dealer_id)
        )
      ];

      checkedOutlet = this.dealerData
        .filter((outlet: any) => outlet.checked)
        .map((outlet: any) => outlet.outlet_id);
    } else {
      checkedDealer = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)
        // .flatMap((region: any) => region.Areas)
        .flatMap((area: any) => area.ParentDealers)
        .filter((dealer: any) => dealer.checked)
        .map((dealer: any) => dealer.parent_dealer_id);

      checkedOutlet = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)
        // .flatMap((region: any) => region.Areas)
        .flatMap((area: any) => area.ParentDealers)
        .flatMap((dealer: any) => dealer.Outlets)
        .filter((outlet: any) => outlet.checked)
        .map((outlet: any) => outlet.outlet_id);
    }


    let checkedUserType: any = [];
    checkedUserType = this.userData.filter((user: any) => user.checked)         // Filter checked areas
      .map((user: any) => user.role_id);
    let request: any = {
      "startDate": moment(this.startDate).format('YYYY-MM-DD'), //mandatory
      "endDate": moment(this.endDate).format('YYYY-MM-DD'), //mandatory
      "current_stage.role_id": checkedUserType.length > 0 ? checkedUserType[0] : 3,
      "current_stage.stage_id": checkedUserType[0] == 3 ? this.stageIds : [2, 4, 5, 7, 14, 15, 16],
    }
  
    let groupBy: any = []
    if (checkedZones.length > 0) {
      request["outlet_details.zone_id"] = checkedZones;
      groupBy.push("zone")
    } else {
      if (this.roleId == 6) {
        groupBy.push('zone', "state", "region")
      } else if (this.roleId == 7) {
        groupBy.push('zone', "state", "region", 'parentDealer', 'outlet')
      } else if (this.roleId == 8) {
        groupBy.push('zone', "state", "region", 'parentDealer', 'outlet')
      } else if (this.roleId == 5 || this.roleId == 10) {
        groupBy.push('zone', "state", "region", 'parentDealer', 'outlet')
      } else {
        groupBy.push("zone")
      }
    }
    if (checkedStates.length > 0) {
      request["outlet_details.state_id"] = checkedStates;
      groupBy.push("state")
    }
    if (checkedRegions.length > 0) {
      request["outlet_details.region_id"] = checkedRegions;
      groupBy.push("region")
    }
    if (checkedAreas.length > 0) {
      request["outlet_details.area_id"] = checkedAreas;
      groupBy.push("area")
    }
    if (checkedCategories.length > 0) {
      request["product_details.product_category_id"] = checkedCategories;
    }
    if (checkedModels.length > 0) {
      request["product_details.product_model_id"] = checkedModels;
    }
    if (checkedBaseLeadSource.length > 0) {
      // request["base_lead_source_id"] = checkedBaseLeadSource;
    }
    if (checkedSource.length > 0) {
      request["lead_source_id"] = checkedSource;
    }
    if (checkedSubSource.length > 0) {
      request["lead_sub_source_id"] = checkedSubSource;
    }
    if (checkedStatus.length > 0) {
      request["sortby"] = this.selectedFollowupCardIndex == 2
        ? 'avgFolloUpTat'
        : this.selectedFollowupCardIndex == 3
          ? 'todaysFollowUp'
          : 'firstFolloUpTat';

    }
    if (checkedDealer.length > 0) {
      request["outlet_details.parent_dealer_id"] = checkedDealer;
      if (!groupBy.includes("parentDealer")) {
        groupBy.push("parentDealer");
      }
    } else {
      if (groupBy.includes("area") && !groupBy.includes("parentDealer")) {
        groupBy.push("parentDealer")
      }
    }

    if (checkedOutlet.length > 0) {
      request["outlet_details.outlet_id"] = checkedOutlet;
      if (!groupBy.includes("outlet")) {
        groupBy.push("outlet");
      }
    } else {
      if (groupBy.includes("area") && !groupBy.includes("outlet")) {
        groupBy.push("outlet")
      }
    }
    if (this.selectedFollowupCardIndex == 0) {
      request['current_stage.role_id'] = 4;
    }
    request["groupby"] = groupBy;
    request["is_outlet_all"] = this.isActiveOutlet ? 2 : 1;
    this.followupService.getGeographyChartCounts(request).subscribe({
      next: (response: any) => {
        let responseData: any = response.body;
        if (responseData.responseCode == 200) {
          this.formattedTotalCount = 1;
          this.chartsData = [];
          this.regionData = [];
          console.log(">>>>>>>>>>", responseData.data)
          if (responseData.data.length > 0) {
            this.regionData = responseData.data.sort((a: any, b: any) => a.zone_id - b.zone_id);
            setTimeout(() => {
              if (this.selectedFollowupCardIndex == 2) {
                if (checkedDealer.length > 0 || checkedOutlet.length > 0 || groupBy.includes("outlet")) {
                  this.regionData = this.regionData.flatMap((zone: any) => zone.states).flatMap((state: any) => state.regions).flatMap((region: any) => region.parentDealers)
                  this.onPDChartByLeads();
                } else {
                  this.onZoneByLead();
                }
              } else if (this.selectedFollowupCardIndex == 3) {
                if (checkedDealer.length > 0 || checkedOutlet.length > 0 || groupBy.includes("outlet")) {
                  this.regionData = this.regionData.flatMap((zone: any) => zone.states).flatMap((state: any) => state.regions).flatMap((region: any) => region.parentDealers)
                  this.onPDChart();
                } else {
                  this.onZone();
                }
              }
              else {
                console.log("checkedStatus: ", checkedStatus[0])
                if (checkedStatus[0] == '1folloUpTat' || checkedStatus[0] == '2folloUpTat' || checkedStatus[0] == '3folloUpTat' ||
                  checkedStatus[0] == '4folloUpTat' || checkedStatus[0] == '5folloUpTat' || checkedStatus[0] == '6folloUpTat' ||
                  checkedStatus[0] == '7folloUpTat' || checkedStatus[0] == '7greatefolloUpTat' || checkedStatus[0] == 'dseFolloUpTat' || checkedStatus[0] == 'ddFolloUpTat' || checkedStatus[0] == 'firstFolloUpTat') {
                  if (checkedDealer.length > 0 || checkedOutlet.length > 0 || groupBy.includes("outlet")) {
                    this.regionData = this.regionData.flatMap((zone: any) => zone.states).flatMap((state: any) => state.regions).flatMap((region: any) => region.parentDealers)
                    this.onPDChartMinutes();
                  } else {
                    if (groupBy.includes("outlet") || groupBy.includes("parentDealer")) {
                      this.regionData = this.regionData.flatMap((zone: any) => zone.states).flatMap((state: any) => state.regions).flatMap((region: any) => region.parentDealers)
                      this.onPDChartMinutes();
                    } else {
                      this.onZoneMinutes();
                    }

                  }
                } else {
                  if (checkedDealer.length > 0 || checkedOutlet.length > 0 || groupBy.includes("outlet")) {
                    this.regionData = this.regionData.flatMap((zone: any) => zone.states).flatMap((state: any) => state.regions).flatMap((region: any) => region.parentDealers)
                    this.onPDChart();
                  } else {
                    if (groupBy.includes("outlet") || groupBy.includes("parentDealer")) {
                      this.regionData = this.regionData.flatMap((zone: any) => zone.states).flatMap((state: any) => state.regions).flatMap((region: any) => region.parentDealers)
                      this.onPDChart();
                    } else {
                      this.onZone();
                    }
                  }
                }
              }
            }, 100)
          }
        }
      }, error: (err) => {
        console.error('Error fetching stage counts:', err);
        // this.stopLoading(); // Ensure loader stops even on error
      },
      complete: () => {
        // this.stopLoading(); // Stop loader after completion
      }
    });
  }

  compareLineChart() {
    if (this.followupStartMonth && this.followupEndMonth) {
      this.isGlobalDateCategory = false;
      this.getLineChartCounts();
    } else {
      this.toastr.error("From and To month is required to compare!")
    }
  }

  compareBarChart() {
    if (this.horizontalBarStartMonth && this.horizontalBarEndMonth) {
      this.isGlobalDateCategory = false;
      this.getHorizontalChartCounts(this.selectedFollowupCardIndex);
    } else {
      this.toastr.error("From and To month is required to compare!")
    }
  }

  @ViewChild('lineChart') lineChart!: ChartComponent;
  getLineChartCounts() {
    // let checkedZones: any = [];
    // checkedZones = this.dropdownData
    //   .filter((zone: any) => zone.checked)         // Filter checked zones
    //   .map((zone: any) => zone.zone_id);                // Map to zone IDs

    // // Get checked region IDs
    // let checkedRegions: any = []
    // checkedRegions = this.dropdownData
    //   .flatMap((zone: any) => zone.Regions)        // Flatten regions
    //   .filter((region: any) => region.checked)     // Filter checked regions
    //   .map((region: any) => region.region_id);            // Map to region IDs

    // // Get checked area IDs
    // let checkedAreas: any = []
    // checkedAreas = this.dropdownData
    //   .flatMap((zone: any) => zone.Regions)        // Flatten regions
    //   .flatMap((region: any) => region.Areas)      // Flatten areas
    //   .filter((area: any) => area.checked)         // Filter checked areas
    //   .map((area: any) => area.area_id);                // Map to area IDs

    // let checkedCategories: any = []
    // checkedCategories = this.categoryData.filter((category: any) => category.checked)         // Filter checked areas
    //   .map((category: any) => category.category_id);

    // let checkedModels: any = []
    // checkedModels = this.modelsData.filter((model: any) => model.checked)     // Filter checked regions
    //   .map((model: any) => model.model_id);

    // let checkedBaseLeadSource: any = []
    // checkedBaseLeadSource = [
    //   ...new Set(
    //     this.sourceList
    //       .filter((source: any) => source.checked)
    //       .map((source: any) => source.base_lead_source_id)
    //   )
    // ];

    // let checkedSource: any = []
    // checkedSource = this.sourceList
    //   .filter((source: any) => source.checked)
    //   .map((source: any) => source.id);

    // let checkedSubSource: any = []
    // checkedSubSource = this.sourceList
    //   .flatMap((source: any) => source.lead_sub_sources)
    //   .filter((subSource: any) => subSource.checked)
    //   .map((subSource: any) => subSource.id);

    // let checkedUserType: any = [];
    // checkedUserType = this.userData.filter((user: any) => user.checked)         // Filter checked areas
    //   .map((user: any) => user.role_id);

    // let checkedDealer: any = [];
    // checkedDealer = this.dropdownData
    //   .flatMap((zone: any) => zone.Regions)
    //   .flatMap((region: any) => region.Areas)
    //   .flatMap((area: any) => area.ParentDealers)
    //   .filter((dealer: any) => dealer.checked)
    //   .map((dealer: any) => dealer.parent_dealer_id);

    // let checkedOutlet: any = []
    // checkedOutlet = this.dropdownData
    //   .flatMap((zone: any) => zone.Regions)
    //   .flatMap((region: any) => region.Areas)
    //   .flatMap((area: any) => area.ParentDealers)
    //   .flatMap((dealer: any) => dealer.Outlets)
    //   .filter((outlet: any) => outlet.checked)
    //   .map((outlet: any) => outlet.outlet_id);

    // let request: any = {};
    // if (!this.isGlobalDateCategory) {
    //   const startDateA = moment(this.followupStartMonth).startOf('month').format('YYYY-MM-DD');
    //   const endDateA = moment(this.followupStartMonth).endOf('month').format('YYYY-MM-DD');

    //   const startDateB = moment(this.followupEndMonth).startOf('month').format('YYYY-MM-DD');
    //   const endDateB = moment(this.followupEndMonth).endOf('month').format('YYYY-MM-DD');

    //   request = {
    //     "startDate": startDateA, //mandatory
    //     "endDate": endDateA, //mandatory
    //     "compareStartDate": startDateB,
    //     "compareEndDate": endDateB,
    //     "filter1": { "current_stage.stage_id": 3 },
    //     "filter2": {
    //       "current_stage.stage_id": 2
    //     }
    //   }
    // } else {
    //   request = {
    //     "startDate": moment(this.startDate).format('YYYY-MM-DD'), //mandatory
    //     "endDate": moment(this.endDate).format('YYYY-MM-DD'), //mandatory
    //     "filter1": { "current_stage.stage_id": 3 },
    //     "filter2": {
    //       "current_stage.stage_id": 2
    //     }
    //   }
    // }
    // if (checkedZones.length > 0) {
    //   request["outlet_details.zone_id"] = checkedZones;
    // }
    // if (checkedRegions.length > 0) {
    //   request["outlet_details.region_id"] = checkedRegions;
    // }
    // if (checkedAreas.length > 0) {
    //   request["outlet_details.area_id"] = checkedAreas;
    // }
    // if (checkedCategories.length > 0) {
    //   request["product_details.product_category_id"] = checkedCategories;
    // }
    // if (checkedModels.length > 0) {
    //   request["product_details.product_model_id"] = checkedModels;
    // }
    // if (checkedBaseLeadSource.length > 0) {
    //   // request["base_lead_source_id"] = checkedBaseLeadSource;
    // }
    // if (checkedSource.length > 0) {
    //   request["lead_source_id"] = checkedSource;
    // }
    // if (checkedSubSource.length > 0) {
    //   request["lead_sub_source_id"] = checkedSubSource;
    // }
    // if (checkedDealer.length > 0) {
    //   request["outlet_details.parent_dealer_id"] = checkedDealer;
    // }

    // if (checkedOutlet.length > 0) {
    //   request["outlet_details.outlet_id"] = checkedOutlet;
    // }
    // this.followupService.getLineChartCount(request).subscribe((response: any) => {
    //   let responseData: any = response.body;
    //   if (responseData.responseCode == 200) {
    //     let categories: any = [];
    //     let enquiryCounts: any = [];
    //     let testRideCounts: any = [];
    //     let compareEnquiryCounts: any = [];
    //     let compareTestRideCounts: any = [];

    //     if (!this.isGlobalDateCategory) {
    //       if (responseData?.data?.comparedData?.firstFieldEnq.length > 0) {
    //         compareEnquiryCounts = responseData?.data?.comparedData?.firstFieldEnq.map((item: any) => item.count);
    //       }
    //       if (responseData?.data?.comparedData?.secondFieldTest.length > 0) {
    //         compareTestRideCounts = responseData?.data?.comparedData?.secondFieldTest.map((item: any) => item.count);
    //       }

    //       if (responseData?.data?.currentData?.firstFieldEnq.length > 0) {
    //         categories = responseData?.data?.currentData?.firstFieldEnq.map((item: any) => item.date);
    //         enquiryCounts = responseData?.data?.currentData?.firstFieldEnq.map((item: any) => item.count);
    //       }
    //       if (responseData?.data?.currentData?.secondFieldTest.length > 0) {
    //         testRideCounts = responseData?.data?.currentData?.secondFieldTest.map((item: any) => item.count);
    //       }
    //       this.followupOptions.series = [];
    //       this.followupOptions.xaxis.categories = [];
    //       // this.enquiryOptions.xaxis.categories = categories;
    //       this.followupOptions.series.push(
    //         {
    //           name: "Assigned /" + moment(this.followupStartMonth, 'MMMM').endOf('month').format('MMM-YY'),
    //           data: enquiryCounts
    //         },
    //         {
    //           name: "Follow Up /" + moment(this.followupStartMonth, 'MMMM').endOf('month').format('MMM-YY'),
    //           data: testRideCounts
    //         },
    //         {
    //           name: "Assigned /" + moment(this.followupEndMonth, 'MMMM').endOf('month').format('MMM-YY'),
    //           data: compareEnquiryCounts
    //         },
    //         {
    //           name: "Follow Up /" + moment(this.followupEndMonth, 'MMMM').endOf('month').format('MMM-YY'),
    //           data: compareTestRideCounts
    //         }
    //       )

    //     } else {
    //       if (responseData?.data?.currentData?.firstFieldEnq.length > 0) {
    //         categories = responseData?.data?.currentData?.firstFieldEnq.map((item: any) => moment(item.date, 'YYYY-MM-DD').format('DD-MMM'));
    //         enquiryCounts = responseData?.data?.currentData?.firstFieldEnq.map((item: any) => item.count);
    //       }
    //       if (responseData?.data?.currentData?.secondFieldTest.length > 0) {
    //         testRideCounts = responseData?.data?.currentData?.secondFieldTest.map((item: any) => item.count);
    //       }

    //       this.followupOptions.series = [];
    //       this.followupOptions.xaxis.categories = [];
    //       this.followupOptions.xaxis.categories = categories;
    //       this.followupOptions.series.push(
    //         {
    //           name: "Assigned",
    //           data: enquiryCounts
    //         },
    //         {
    //           name: "Follow Up",
    //           data: testRideCounts
    //         }
    //       )
    //     }
    //     if (this.lineChart) {
    //       const totalBars = this.followupOptions?.series[0]?.data?.length;
    //       const barWidth = 70;// Fixed width for each bar
    //       let totalWidth: any
    //       if (totalBars > 14) {
    //         // Calculate the total width needed for all bars
    //         totalWidth = totalBars * barWidth;
    //         if (totalWidth < 990 && 700 < totalWidth) {
    //           totalWidth = 1000;
    //         }
    //         if (totalWidth < 500) {
    //           totalWidth = 750;
    //         }
    //       }


    //       setTimeout(() => {
    //         this.lineChart.updateOptions({
    //           chart: {
    //             width: totalBars > 14 ? totalWidth + 'px' : '100%'
    //           },
    //           xaxis: {
    //             categories: this.followupOptions.xaxis.categories,
    //           },
    //           series: this.followupOptions.series,
    //         });
    //       }, 100);
    //     }
    //   }
    // });
  }


  getIcon(cardName: string): string {
    if (cardName.toLowerCase().includes('south')) {
      return `${this.bucketurl}/images/south.png`;
    } else if (cardName.toLowerCase().includes('west')) {
      return `${this.bucketurl}/images/west.png`;
    } else if (cardName.toLowerCase().includes('north')) {
      return `${this.bucketurl}/images/north.png`;
    } else if (cardName.toLowerCase().includes('east')) {
      return `${this.bucketurl}/images/east.png`;
    }
    // Default icon if no match found
    return `${this.bucketurl}/images/south.png`;
  }

  formattedTotalCount: any = 1;
  onZoneMinutes() {
    let isEveryRegion: boolean = this.regionData.every((object: any) => {
      return !object.states || object.states.length === 0;
    });
    let c = this.regionData.reduce((sum: number, zone: any) => sum + (zone.count ?? 0), 0);
    this.formattedTotalCount = c;

    /**
     * If all the regions is empty in all the zones, then show all the zones count in single pie chart
     */
    if (isEveryRegion) {
      // No regions, show all zones in one chart
      const zoneLabels = this.regionData.map((zone: any) => zone.zone_name);
      const zoneCounts = this.regionData.map((zone: any) => zone.count ?? 0);
      const zoneLeadsCounts = this.regionData.map((zone: any) => zone.totalLeads ?? 0);
      const totalCount = zoneCounts.reduce((accumulator: any, currentValue: any) => accumulator + parseFloat(currentValue), 0);
      const totalZoneCount = this.regionData.reduce((sum: number, zone: any) => {
        if (!zone.totalLeads || !zone.count) {
          return sum; // Skip if totalLeads or count is 0 or undefined
        }
        return sum + (zone.count / zone.totalLeads);
      }, 0);

      const formattedTotalCount = totalCount == 0 ? 0 : this.formatTime(totalZoneCount);
      this.formattedTotalCount = formattedTotalCount;
      const chartData = {
        data: {
          labels: zoneLabels,  // Zone names as labels
          datasets: [
            {
              data: zoneCounts,  // Zone counts
              backgroundColor: [
                // Original colors
                "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                // First additional set
                "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                // New additional colors
                "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                // Additional colors to reach 40
                "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
              ],
              // hoverBackgroundColor: this.getRandomColors(zoneLabels.length)
            }
          ]
        },
        options: {
          title: '',
          subText1: '',
          subText2: '',
          cutout: '28%',
          plugins: {
            datalabels: {
              color: '#fff',
              display: true,
              // formatter: function (value: any, context: any) {
              //   if (value < 60) {
              //     return `${value} sec`;
              //   } else if (value < 3600) {
              //     const minutes = Math.floor(value / 60);
              //     return `${minutes} min`;
              //   } else {
              //     const hours = Math.floor(value / 3600);
              //     return `${hours} hr`;
              //   }
              // },
              formatter: function (value: any, context: any) {
                const index = context.dataIndex; // Get index of data label
                const leads = zoneLeadsCounts[index]
                const totalSeconds = Math.floor(value / leads);
                const hours = Math.floor(totalSeconds / 3600);
                const minutes = Math.floor((totalSeconds % 3600) / 60);
                const seconds = Math.floor(totalSeconds % 60);

                let formattedTime = '';

                // Conditionally format hours
                if (hours > 0) {
                  formattedTime += `${hours}h `;
                }

                // Conditionally format minutes
                if (minutes > 0) {
                  formattedTime += `${minutes}m `;
                }

                // Conditionally format seconds
                if (seconds > 0) {
                  // Only show seconds if there are no hours or if seconds are present with minutes
                  formattedTime += `${seconds}s`;
                }

                // Trim any trailing spaces
                return formattedTime.trim();

              },
              font: {
                size: 9
              },
              anchor: 'end',
              align: 'start'
            },
            legend: {
              display: true,
              labels: {
                usePointStyle: true,
                text: 'Zones'
              }
            },
            tooltip: { enabled: false } //
          },
          responsive: true,
          maintainAspectRatio: false
        }
      };

      this.chartsData.push(chartData);

    } else {
      let isEveryArea: boolean = this.regionData.every((object: any) => {
        return !object.states || object.states.length === 0;
      });

      this.regionData.forEach((zoneObj: any) => {
        const zoneName = zoneObj.zone_name;
        const zoneCount = zoneObj.count;
        const formattedZoneCount = this.formatTime(zoneCount / zoneObj.totalLeads);
        if (zoneObj.states && zoneObj.states.length > 0) {
          // Zone has regions, create separate charts for each zone
          const regionLeadsCounts = zoneObj.states.map((zone: any) => zone.totalLeads ?? 0);
          console.log("regionLeadsCounts: ", regionLeadsCounts)

          zoneObj.states.forEach((regionObj: any) => {
            const regionName = regionObj.state_name;
            const regionCount = regionObj.count;
            const formattedRegionCount = this.formatTime(regionCount / zoneObj.totalLeads);

            if (regionObj?.regions && regionObj?.regions.length > 0) {
              // Region has areas, show all areas in one chart
              const areaLabels = regionObj.regions.map((area: any) => area.region_name);
              const areaCounts = regionObj.regions.map((area: any) => area.count);

              const chartData = {
                zone: zoneName,
                region: regionName,
                data: {
                  labels: areaLabels,  // Area names as labels
                  datasets: [
                    {
                      data: areaCounts,  // Area counts
                      backgroundColor: [
                        // Original colors
                        "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                        // First additional set
                        "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                        // New additional colors
                        "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                        // Additional colors to reach 40
                        "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                        "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                        "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                        "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                        "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
                      ],
                      // hoverBackgroundColor: this.getRandomColors(areaLabels.length)
                    }
                  ]
                },

                options: {
                  title: `${zoneName} - ${formattedZoneCount}`,
                  subText1: ` ${regionName} - ${formattedRegionCount}`,
                  subText2: '',
                  cutout: '28%',
                  plugins: {
                    datalabels: {
                      color: '#fff',
                      display: true,
                      // formatter: function (value: any, context: any) {
                      //   if (value < 60) {
                      //     return `${value} sec`;
                      //   } else if (value < 3600) {
                      //     const minutes = Math.floor(value / 60);
                      //     return `${minutes} min`;
                      //   } else {
                      //     const hours = Math.floor(value / 3600);
                      //     return `${hours} hr`;
                      //   }
                      // },
                      formatter: function (value: any, context: any) {
                        const index = context.dataIndex;
                        const leads = regionLeadsCounts[index]
                        const totalSeconds = Math.floor(value / leads);
                        const hours = Math.floor(totalSeconds / 3600);
                        const minutes = Math.floor((totalSeconds % 3600) / 60);
                        const seconds = Math.floor(totalSeconds % 60);


                        let formattedTime = '';

                        // Conditionally format hours
                        if (hours > 0) {
                          formattedTime += `${hours}h `;
                        }

                        // Conditionally format minutes
                        if (minutes > 0) {
                          formattedTime += `${minutes}m `;
                        }

                        // Conditionally format seconds
                        if (seconds > 0) {
                          // Only show seconds if there are no hours or if seconds are present with minutes
                          formattedTime += `${seconds}s`;
                        }

                        // Trim any trailing spaces
                        return formattedTime.trim();

                      },
                      font: {
                        size: 9
                      },
                      anchor: 'end',
                      align: 'start'
                    },
                    legend: {
                      display: true,
                      labels: {
                        usePointStyle: true,
                        text: 'Zones'
                      }
                    }, tooltip: { enabled: false } //
                  },
                  responsive: true,
                  maintainAspectRatio: false
                }
              };
              let filteredData: any = []
              filteredData = this.chartsData.filter((item: any) => item.region == chartData.region)
              if (filteredData.length == 0) {
                this.chartsData.push(chartData);
              }
            } else {
              // Region has no areas, show all regions in one chart for the zone
              let isNoArea: boolean = zoneObj.states.every((item: any) => !item?.regions || item?.regions?.length === 0);
              let filteredDataNoArea = zoneObj.states.filter((item: any) => {
                return !item?.regions || item?.regions?.length == 0;
              });
              if (filteredDataNoArea.length != 0) {

                const regionLabels = filteredDataNoArea.map((region: any) => region.state_name);
                const regionCounts = filteredDataNoArea.map((region: any) => region.count);

                const chartData = {
                  zone: zoneName.toLowerCase(),
                  region: regionName.toLowerCase(),
                  data: {
                    labels: regionLabels,  // Region names as labels
                    datasets: [
                      {
                        data: regionCounts,  // Region counts
                        backgroundColor: [
                          // Original colors
                          "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                          // First additional set
                          "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                          // New additional colors
                          "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                          // Additional colors to reach 40
                          "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                          "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                          "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                          "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                          "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
                        ],
                        // hoverBackgroundColor: this.getRandomColors(regionLabels.length)
                      }
                    ]
                  },
                  options: {
                    title: `${zoneName} - ${formattedZoneCount}`,
                    subText1: '',
                    subText2: '',
                    cutout: '28%',
                    plugins: {
                      datalabels: {
                        color: '#fff',
                        display: true,
                        // formatter: function (value: any, context: any) {
                        //   if (value < 60) {
                        //     return `${value} sec`;
                        //   } else if (value < 3600) {
                        //     const minutes = Math.floor(value / 60);
                        //     return `${minutes} min`;
                        //   } else {
                        //     const hours = Math.floor(value / 3600);
                        //     return `${hours} hr`;
                        //   }
                        // },
                        formatter: function (value: any, context: any) {
                          const index = context.dataIndex;
                          const leads = regionLeadsCounts[index]
                          const totalSeconds = Math.floor(value / leads);
                          const hours = Math.floor(totalSeconds / 3600);
                          const minutes = Math.floor((totalSeconds % 3600) / 60);
                          const seconds = Math.floor(totalSeconds % 60);

                          let formattedTime = '';

                          // Conditionally format hours
                          if (hours > 0) {
                            formattedTime += `${hours}h `;
                          }

                          // Conditionally format minutes
                          if (minutes > 0) {
                            formattedTime += `${minutes}m `;
                          }

                          // Conditionally format seconds
                          if (seconds > 0) {
                            // Only show seconds if there are no hours or if seconds are present with minutes
                            formattedTime += `${seconds}s`;
                          }

                          // Trim any trailing spaces
                          return formattedTime.trim();

                        },
                        font: {
                          size: 9
                        },
                        anchor: 'end',
                        align: 'start'
                      },
                      legend: {
                        display: true,
                        labels: {
                          usePointStyle: true,
                          text: 'Zones'
                        }
                      }, tooltip: { enabled: false } //
                    },
                    responsive: true,
                    maintainAspectRatio: false
                  }
                };
                let filteredData: any = []
                if (isNoArea) {
                  filteredData = this.chartsData.filter((item: any) => item?.zone?.toLowerCase() == chartData.zone)
                  if (filteredData.length == 0) {
                    this.chartsData.push(chartData);
                  }
                } else {
                  filteredData = this.chartsData.filter((item: any) => item.zone.toLowerCase() == chartData.zone && item.region.toLowerCase() == chartData.region)
                  if (filteredData.length == 0) {
                    this.chartsData.push(chartData);
                  }
                }

              }
            }
          });
        } else {

          let filteredDataNoRegions = this.regionData.filter((item: any) => {
            return item?.regions && item?.regions?.length == 0;
          });
          const zoneLabels = filteredDataNoRegions.map((zone: any) => zone.zone_name);
          const zoneCounts = filteredDataNoRegions.map((zone: any) => zone.count);
          const totalCount = zoneCounts.reduce((accumulator: any, currentValue: any) => accumulator + currentValue, 0);
          const formattedCount = this.formatTime(totalCount);
          const chartData = {
            zone: 'remaining-zones',
            data: {
              labels: zoneLabels,  // Zone names as labels
              datasets: [
                {
                  data: zoneCounts,  // Zone counts
                  backgroundColor: [
                    // Original colors
                    "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                    // First additional set
                    "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                    // New additional colors
                    "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                    // Additional colors to reach 40
                    "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                    "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                    "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                    "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                    "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
                  ],
                  // hoverBackgroundColor: this.getRandomColors(zoneLabels.length)
                }
              ]
            },
            options: {
              title: '',
              cutout: '28%',
              plugins: {
                datalabels: {
                  color: '#fff',
                  display: true,
                  // formatter: function (value: any, context: any) {
                  //   if (value < 60) {
                  //     return `${value} sec`;
                  //   } else if (value < 3600) {
                  //     const minutes = Math.floor(value / 60);
                  //     return `${minutes} min`;
                  //   } else {
                  //     const hours = Math.floor(value / 3600);
                  //     return `${hours} hr`;
                  //   }
                  // },
                  formatter: function (value: any, context: any) {
                    const totalSeconds = Math.floor(value);
                    const hours = Math.floor(totalSeconds / 3600);
                    const minutes = Math.floor((totalSeconds % 3600) / 60);
                    const seconds = Math.floor(totalSeconds % 60);


                    let formattedTime = '';

                    // Conditionally format hours
                    if (hours > 0) {
                      formattedTime += `${hours}h `;
                    }

                    // Conditionally format minutes
                    if (minutes > 0) {
                      formattedTime += `${minutes}m `;
                    }

                    // Conditionally format seconds
                    if (seconds > 0) {
                      // Only show seconds if there are no hours or if seconds are present with minutes
                      formattedTime += `${seconds}s`;
                    }

                    // Trim any trailing spaces
                    return formattedTime.trim();

                  },
                  font: {
                    weight: 'bold',
                    size: 9
                  },
                  anchor: 'end',
                  align: 'start'
                },
                legend: {
                  display: true,
                  labels: {
                    usePointStyle: true,
                    text: 'Zones'
                  }
                }, tooltip: { enabled: false } //
              },
              responsive: true,
              maintainAspectRatio: false
            }
          };
          let filteredData = this.chartsData.filter((item: any) => item.zone.toLowerCase() == chartData.zone)
          if (filteredData.length == 0) {
            this.chartsData.push(chartData);
          }
        }

      });
    }
  }


  getParentDealerChartCounts() {
    let checkedDealer: any = [];
    checkedDealer = this.dealerData
      .filter((dealer: any) => dealer.checked)         // Filter checked zones
      .map((dealer: any) => dealer.parent_dealer_id);                // Map to zone IDs

    // Get checked region IDs
    let checkedOutlet: any = []
    checkedOutlet = this.dealerData
      .flatMap((dealer: any) => dealer.Outlets)        // Flatten regions
      .filter((outlet: any) => outlet.checked)     // Filter checked regions
      .map((outlet: any) => outlet.outlet_id);

    let checkedCategories: any = []
    checkedCategories = this.categoryData.filter((category: any) => category.checked)         // Filter checked areas
      .map((category: any) => category.category_id);

    let checkedModels: any = []
    checkedModels = this.modelsData.filter((model: any) => model.checked)     // Filter checked regions
      .map((model: any) => model.model_id);

    let checkedBaseLeadSource: any = []
    checkedBaseLeadSource = [
      ...new Set(
        this.sourceList
          .filter((source: any) => source.checked)
          .map((source: any) => source.base_lead_source_id)
      )
    ];

    let checkedSource: any = []
    checkedSource = this.sourceList
      .filter((source: any) => source.checked)
      .map((source: any) => source.id);

    let checkedSubSource: any = []
    checkedSubSource = this.sourceList
      .flatMap((source: any) => source.lead_sub_sources)
      .filter((subSource: any) => subSource.checked)
      .map((subSource: any) => subSource.id);

    let checkedStatus: any = []
    checkedStatus = this.statusesToggle.filter((status: any) => status.checked)         // Filter checked areas
      .map((status: any) => status.value);

    let checkedUserType: any = [];
    checkedUserType = this.userData.filter((user: any) => user.checked)         // Filter checked areas
      .map((user: any) => user.role_id);

    let request: any = {
      "startDate": moment(this.startDate).format('YYYY-MM-DD'), //mandatory
      "endDate": moment(this.endDate).format('YYYY-MM-DD'), //mandatory
      "current_stage.role_id": checkedUserType.length > 0 ? checkedUserType[0] : 3,
      "current_stage.stage_id": this.stageIds
    }

    let groupBy: any = ["parentDealer"]

    if (checkedDealer.length > 0) {
      request["outlet_details.parent_dealer_id"] = checkedDealer;
    }

    if (checkedOutlet.length > 0) {
      request["outlet_details.outlet_id"] = checkedOutlet;
      groupBy.push("outlet")
    } else {
      if (this.roleId == 9) {
        groupBy.push("outlet")
      }
    }
    request["groupby"] = groupBy;

    if (checkedCategories.length > 0) {
      request["product_details.product_category_id"] = checkedCategories;
    }
    if (checkedModels.length > 0) {
      request["product_details.product_model_id"] = checkedModels;
    }
    if (checkedBaseLeadSource.length > 0) {
      // request["base_lead_source_id"] = checkedBaseLeadSource;
    }
    if (checkedSource.length > 0) {
      request["lead_source_id"] = checkedSource;
    }
    if (checkedSubSource.length > 0) {
      request["lead_sub_source_id"] = checkedSubSource;
    }
    if (checkedStatus.length > 0) {
      request["sortby"] = checkedStatus[0];
    }
    this.formattedTotalCount = 1;
    this.followupService.getParentDealerChartCount(request).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        this.chartsData = [];
        this.regionData = [];
        if (responseData.data.length > 0) {
          this.regionData = responseData.data
          setTimeout(() => {
            if (checkedStatus[0] == 'firstFolloUpTat') {
              this.onPDChartMinutes();
            } else {
              this.onPDChart();
            }
          }, 100)
        }
      }
    });
  }


  formatTime(value: any) {
    const totalSeconds = Math.round(parseFloat(value));  // parseFloat in case value is a string
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);
    let formattedTime = '';

    // Conditionally format hours
    if (hours > 0) {
      formattedTime += `${hours}h `;
    }

    // Conditionally format minutes
    if (minutes > 0) {
      formattedTime += `${minutes}m `;
    }

    // Conditionally format seconds
    if (seconds > 0) {
      // Only show seconds if there are no hours or if seconds are present with minutes
      formattedTime += `${seconds}s`;
    }

    // Trim any trailing spaces
    return formattedTime.trim();

  }

  selectAllModelChecked: boolean = false;
  onModelCheckAll(event: any) {
    if (event.checked) {
      this.modelsData.forEach((model: any) => {
        model.checked = true
      })
      this.filteredModelData.forEach((model: any) => {
        model.checked = true
      })
      this.selectAllModelChecked = true;
    } else {
      this.modelsData.forEach((model: any) => {
        model.checked = false
      })
      this.filteredModelData.forEach((model: any) => {
        model.checked = false
      })
      this.selectAllModelChecked = false;
    }
  }

  selectAllCategoryChecked: boolean = false;
  onCategoryCheckAll(event: any) {
    if (event.checked) {
      this.categoryData.forEach((cat: any) => {
        cat.checked = true
      })
      this.selectAllCategoryChecked = true;
    } else {
      this.categoryData.forEach((cat: any) => {
        cat.checked = false
      })
      this.selectAllCategoryChecked = false;
    }
  }
  isEmpty(obj: any): boolean {
    return Object.keys(obj).length === 0;
  }

  filterDealerByArea() {
    // if (this.roleId != 8 || this.roleId != 9) {
    //   let checkedDealer: any = [];
    //   checkedDealer = this.dealerData
    //     .filter((dealer: any) => dealer.checked)
    //     .map((dealer: any) => dealer.parent_dealer_id);

    //   let checkedAreas = [];
    //   checkedAreas = this.dropdownData
    //     .flatMap((zone: any) => zone.Regions)        // Flatten regions
    //     .flatMap((region: any) => region.Areas)      // Flatten areas
    //     .filter((area: any) => area.checked)         // Filter checked areas
    //     .map((area: any) => area.area_id);

    //   let checkedOutlet: any = []
    //   checkedOutlet = this.dealerData
    //     .flatMap((dealer: any) => dealer.Outlets)
    //     .filter((outlet: any) => outlet.checked)
    //     .map((outlet: any) => outlet.outlet_id);

    //   this.dealerData = checkedAreas.length === 0
    //     ? this.dropdownData.flatMap((zone: any) =>
    //       zone.Regions.flatMap((region: any) =>
    //         region.Areas.flatMap((area: any) =>
    //           area.ParentDealers.map((dealer: any) => ({
    //             ...dealer, // Spread existing dealer properties
    //             checked: checkedDealer.includes(dealer.parent_dealer_id), // Retain dealer checked status
    //             Outlets: dealer.Outlets.map((outlet: any) => ({
    //               ...outlet, // Spread existing outlet properties
    //               checked: checkedOutlet.includes(outlet.outlet_id) // Retain outlet checked status
    //             }))
    //           }))
    //         )
    //       )
    //     )
    //     : this.dropdownData.flatMap((zone: any) =>
    //       zone.Regions.flatMap((region: any) =>
    //         region.Areas
    //           .filter((area: any) => checkedAreas.includes(area.area_id)) // Filter areas by checked IDs
    //           .flatMap((filteredArea: any) =>
    //             filteredArea.ParentDealers.map((dealer: any) => ({
    //               ...dealer, // Spread existing dealer properties
    //               checked: checkedDealer.includes(dealer.parent_dealer_id), // Retain dealer checked status
    //               Outlets: dealer.Outlets.map((outlet: any) => ({
    //                 ...outlet, // Spread existing outlet properties
    //                 checked: checkedOutlet.includes(outlet.outlet_id) // Retain outlet checked status
    //               }))
    //             }))
    //           )
    //       )
    //     );
    //   if (checkedAreas.length == 0) {
    //     this.dealerData.forEach((dealer: any) => {
    //       dealer.checked = false;
    //       dealer.Outlets.forEach((outlet: any) => {
    //         outlet.checked = false;
    //       });
    //     })
    //   }
    //   this.filteredDealerData = [...this.dealerData];
    // }
  }

  stageCounts: any = {}
  horizontalBarStartMonth: any;
  horizontalBarEndMonth: any;
  currentuntouch: any = 0;
  currenttotaltouch: any = 0;
  @ViewChild('horizontalChart') horizontalChart!: ChartComponent;
  getHorizontalChartCounts(index?: any) {
    // this.startLoading();
    this.currentuntouch = 0;
    this.currenttotaltouch = 0;
    // Get checked zone IDs
    let checkedZones: any = [];
    checkedZones = this.dropdownData
      .filter((zone: any) => zone.checked)         // Filter checked zones
      .map((zone: any) => zone.zone_id);                // Map to zone IDs

    let checkedStates: any = []
    checkedStates = this.dropdownData.flatMap((zone: any) => zone.States)
      .filter((state: any) => state.checked)
      .map((state: any) => state.state_id);

    // Get checked region IDs
    let checkedRegions: any = []
    checkedRegions = this.dropdownData.flatMap((zone: any) => zone.States)
      .flatMap((zone: any) => zone.Regions)        // Flatten regions
      .filter((region: any) => region.checked)     // Filter checked regions
      .map((region: any) => region.region_id);            // Map to region IDs

    // Get checked area IDs
    let checkedAreas: any = []
    // checkedAreas = this.dropdownData.flatMap((zone: any) => zone.States)
    //   .flatMap((zone: any) => zone.Regions)        // Flatten regions
    //   .flatMap((region: any) => region.Areas)      // Flatten areas
    //   .filter((area: any) => area.checked)         // Filter checked areas
    //   .map((area: any) => area.area_id);        

    let checkedCategories: any = []
    checkedCategories = this.categoryData.filter((category: any) => category.checked)         // Filter checked areas
      .map((category: any) => category.category_id);

    let checkedModels: any = []
    checkedModels = this.modelsData.filter((model: any) => model.checked)     // Filter checked regions
      .map((model: any) => model.model_id);
    
    let checkedBaseLeadSource: any = []
    checkedBaseLeadSource = [
      ...new Set(
        this.sourceList
          .filter((source: any) => source.checked)
          .map((source: any) => source.base_lead_source_id)
      )
    ];

    let checkedSource: any = []
    checkedSource = this.sourceList
      .filter((source: any) => source.checked)
      .map((source: any) => source.id);

    let checkedSubSource: any = []
    checkedSubSource = this.sourceList
      .flatMap((source: any) => source.lead_sub_sources)
      .filter((subSource: any) => subSource.checked)
      .map((subSource: any) => subSource.id);

    let checkedDealer: any = [];
    let checkedOutlet: any = []
    if (this.roleId == 8 || this.roleId == 5 || this.roleId == 10) {
      checkedDealer = [
        ...new Set(
          this.dealerData
            .filter((dealer: any) => dealer.checked)
            .map((dealer: any) => dealer.parent_dealer_id)
        )
      ];

      checkedOutlet = this.dealerData
        .filter((outlet: any) => outlet.checked)
        .map((outlet: any) => outlet.outlet_id);
    } else {
      checkedDealer = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)
        // .flatMap((region: any) => region.Areas)
        .flatMap((area: any) => area.ParentDealers)
        .filter((dealer: any) => dealer.checked)
        .map((dealer: any) => dealer.parent_dealer_id);

      checkedOutlet = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)
        // .flatMap((region: any) => region.Areas)
        .flatMap((area: any) => area.ParentDealers)
        .flatMap((dealer: any) => dealer.Outlets)
        .filter((outlet: any) => outlet.checked)
        .map((outlet: any) => outlet.outlet_id);
    }

    let checkedUserType: any = [];
    checkedUserType = this.userData.filter((user: any) => user.checked)         // Filter checked areas
      .map((user: any) => user.role_id);

    let request: any = {};
    if (!this.isGlobalDateCategory) {
      const startDateA = moment(this.horizontalBarStartMonth).startOf('month').format('YYYY-MM-DD');
      const endDateA = moment(this.horizontalBarStartMonth).endOf('month').format('YYYY-MM-DD');

      const startDateB = moment(this.horizontalBarEndMonth).startOf('month').format('YYYY-MM-DD');
      const endDateB = moment(this.horizontalBarEndMonth).endOf('month').format('YYYY-MM-DD');

      request = {
        "startDate": startDateA, //mandatory
        "endDate": endDateA, //mandatory
        "compareStartDate": startDateB,
        "compareEndDate": endDateB,
        "current_stage.role_id": checkedUserType.length > 0 ? checkedUserType[0] : 3,
        "current_stage.stage_id": this.stageIds,
      }
    } else {
      request = {
        "startDate": moment(this.startDate).format('YYYY-MM-DD'), //mandatory
        "endDate": moment(this.endDate).format('YYYY-MM-DD'), //mandatory
        "current_stage.role_id": checkedUserType.length > 0 ? checkedUserType[0] : 3,
        "current_stage.stage_id": checkedUserType[0] == 3 ? this.stageIds : [2, 4, 5, 6, 7, 14, 15, 16],
      }
    }

    if (checkedZones.length > 0) {
      request["outlet_details.zone_id"] = checkedZones;
    }
    if (checkedStates.length > 0) {
      request["outlet_details.state_id"] = checkedStates;
    }
    if (checkedRegions.length > 0) {
      request["outlet_details.region_id"] = checkedRegions;
    }
    if (checkedAreas.length > 0) {
      request["outlet_details.area_id"] = checkedAreas;
    }
    if (checkedCategories.length > 0) {
      request["product_details.product_category_id"] = checkedCategories;
    }
    if (checkedModels.length > 0) {
      request["product_details.product_model_id"] = checkedModels;
    }
     if (checkedSource.length > 0) {
      request["lead_source_id"] = checkedSource;
    }
    if (checkedSubSource.length > 0) {
      request["lead_sub_source_id"] = checkedSubSource;
    }
    if (checkedDealer.length > 0) {
      request["outlet_details.parent_dealer_id"] = checkedDealer;
    }

    if (checkedOutlet.length > 0) {
      request["outlet_details.outlet_id"] = checkedOutlet;
    }
    request["is_outlet_all"] = this.isActiveOutlet ? 2 : 1;
    if (this.selectedFollowupCardIndex == 3) {
      request["sortby"] = 'todaysFollowUp'
    }
    if (this.selectedFollowupCardIndex == 0) {
      request['current_stage.role_id'] = 4;
    }
    this.followupService.geBarCounts(request).subscribe({
      next: (response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        this.horizontalBarOptions.series = [];
        this.horizontalBarOptions.xaxis.categories = [];
        // this.currentuntouch = responseData.data.currentuntouch ? responseData.data.currentuntouch : 0;
        console.log("responseData: ", index)
        //if(index == 2 || index == 3 ){
        this.currenttotaltouch = responseData.data.currenttotaltouch ? responseData.data.currenttotaltouch : 0
       // }
        if (responseData.data.ddTotalData.length > 0) {
          let dataSet: any = responseData.data.ddTotalData.length > 0 ? responseData.data.ddTotalData[0] : {};
          this.stageCounts = {}
          this.stageCounts = {
            totalLeads: dataSet?.totalLeads?.[0]?.total ?? 0,
            untouchedLeads: dataSet?.untouchedLeads?.[0]?.total ?? 0,
            followUp: dataSet?.followUp?.[0]?.total ?? 0,
            assigned: dataSet?.assigned?.[0]?.total ?? 0,
            nonSales: dataSet?.nonSales?.[0]?.total ?? 0,
            junk: dataSet?.junk?.[0]?.total ?? 0,
            noResponse: dataSet?.noResponse?.[0]?.total ?? 0
          };
        }
        if (responseData.data.currentData.length > 0 || responseData.data.comparedData.length > 0) {
          if (this.isGlobalDateCategory) {

            if (responseData.data.currentData.length > 0) {
              let response: any = responseData.data.currentData
              // response.sort((a: any, b: any) => a['_id'] - b['_id']);
              console.log("response:", response)
              let nullAndZeroCount = response
                .filter((item: any) => item['_id'] == null || item['_id'] == 0) // Filter items where id is null or 0
                .reduce((sum: number, item: any) => sum + item.count, 0); // Sum the counts

              let dataSet: any = response
                .filter((item: any) => item['_id'] !== -1 && item['_id'] !== null && item['_id'] !== 0) // Exclude -1, null, and 0
                .map((item: any) => item.count);
              // if (nullAndZeroCount > 0) {
              dataSet.unshift(nullAndZeroCount); // Push to the beginning of array
              // }
              if (this.selectedFollowupCardIndex == 0) {
                this.currentuntouch = responseData.data.currentuntouch ? responseData.data.currentuntouch : 0;
              } else {
                this.currentuntouch = nullAndZeroCount ? nullAndZeroCount : 0
              }
              console.log("dataSet: ", dataSet)
              let catName: any = response.map((item: any) => item['_id'] || 'Not Mapped');
              let catArray: any = [];
              catName.forEach((item: any) => {
                catArray.push(item)
              })
              this.horizontalBarOptions.xaxis.categories = ['0', '1', '2', '3', '4', '5', '6', '7', '>7'];
              console.log("catArray: ", catArray)
              this.horizontalBarOptions.series.push({ name: 'Enquiries', data: dataSet })
              // this.horizontalBarOptions.series.push({ name: 'Enquiries 2', data: dataSet })
              setTimeout(() => {
                this.horizontalChart.updateOptions({
                  xaxis: {
                    categories: ['0', '1', '2', '3', '4', '5', '6', '7', '>7'],
                  },
                  colors: [
                    '#AE83E8', // Purple
                    '#E67FE6', // Pink
                    '#8AE9E9', // Light Blue
                    '#E9EB72', // Yellow
                    '#E78F92', // Light Red
                    '#E6B76B', // Orange
                    '#A0DA8C', // Green
                    '#E983A6', // Dark Pink
                    '#6BAAE6', // Blue
                    '#A783E6', // Lavender
                    '#E6A083',  // Coral,
                    '#7FD6B3', // Teal
                    '#D697E6'  // Soft Purple
                  ],
                  legend: {
                    show: false   // Dynamically hide the legend
                  }
                });
              }, 500)
            } else {
              this.horizontalBarOptions.series.push({ name: 'Enquiries', data: [] })
            }
          } else {
            if (responseData.data.currentData.length > 0 || responseData.data.comparedData.length > 0) {
              let formattedResponse1: any = responseData.data.currentData.map((item: any) => {
                return {
                  id: item['_id'],
                  name: item['_id'].toString(), // or update accordingly
                  count: item.count,
                };
              })
              let formattedResponse2: any = responseData.data.comparedData.map((item: any) => {
                return {
                  id: item['_id'],
                  name: item['_id'].toString(), // or update accordingly
                  count: item.count,
                };
              })
              let currentCount: any = formattedResponse1.length > 0
                ? formattedResponse1.map((item: any) => ({
                  ...item,
                  name: item.name && item.name.trim() !== '' ? item.name : 'Not Mapped',
                  id: item.name && item.name.trim() !== '' ? item.id : null
                }))
                : [];

              let compareCount: any = formattedResponse2.length > 0
                ? formattedResponse2.map((item: any) => ({
                  ...item,
                  name: item.name && item.name.trim() !== '' ? item.name : 'Not Mapped',
                  id: item.name && item.name.trim() !== '' ? item.id : null
                }))
                : [];
              // Handle if either array is empty
              const uniqueIds = new Set([
                ...((currentCount && currentCount.length > 0) ? currentCount.map((item: any) => item.id) : []),
                ...((compareCount && compareCount.length > 0) ? compareCount.map((item: any) => item.id) : [])
              ]);

              let updatedCurrentCount: any = [...uniqueIds].map(id => {
                const currentItem = currentCount.find((item: any) => item.id === id);
                const compareItem = compareCount.find((item: any) => item.id === id);

                // Only add to currentCount if it exists in currentCount or compareCount
                return currentItem || { count: 0, selectStageCount: 0, id, name: compareItem?.name || '' };
              }).filter(item => item.name !== '');  // Filter out items with empty name (i.e., those not present in either array)

              let updatedCompareCount: any = [...uniqueIds].map(id => {
                const currentItem = currentCount?.find((item: any) => item.id === id);
                const compareItem = compareCount?.find((item: any) => item.id === id);

                // Only add to compareCount if it exists in currentCount or compareCount
                return compareItem || { count: 0, id, name: currentItem?.name || '' };
              }).filter(item => item.name !== '');  // Filter out items with empty name

              // updatedCurrentCount.sort((a: any, b: any) => a.id - b.id);
              // updatedCompareCount.sort((a: any, b: any) => a.id - b.id);

              // Resulting arrays
              // console.log("updatedCurrentCount:", updatedCurrentCount);
              // console.log("updatedCompareCount: ", updatedCompareCount);


              let dataSet1: any = updatedCurrentCount.map((item: any) => item.count)
              let catName: any = updatedCompareCount.map((item: any) => item.name || 'Not Mapped');
              let catArray: any = []
              let dataSet1Array: any = []
              let dataSet2Array: any = []
              const colorsDark = [
                '#8B5ED6', // Darker Purple
                '#D152D1', // Darker Pink
                '#4FCFCF', // Darker Light Blue
                '#D1D45A', // Darker Yellow
                '#C75B5E', // Darker Light Red
                '#D1903A', // Darker Orange
                '#75B964', // Darker Green
                '#D15F85', // Darker Dark Pink
                '#3C84CC', // Darker Blue
                '#8A5BD1', // Darker Lavender
                '#CC744D',  // Darker Coral
              ];
              updatedCurrentCount.forEach((item: any, index: number) => {
                // Use the modulus operator to cycle through colors
                const colorIndex = index % colorsDark.length;
                dataSet1Array.push({ x: item.name ? item.name : 'Not Mapped', y: item.count, fillColor: colorsDark[colorIndex] });
              });
              catName.forEach((item: any) => {
                catArray.push([item])
              })
              this.horizontalBarOptions.xaxis.categories = catArray;
              this.horizontalBarOptions.series.push({ name: moment(this.horizontalBarStartMonth, 'MMMM').endOf('month').format('MMM-YY'), data: dataSet1Array })

              const colorslight = [
                '#AE83E8', // Purple
                '#E67FE6', // Pink
                '#8AE9E9', // Light Blue
                '#E9EB72', // Yellow
                '#E78F92', // Light Red
                '#E6B76B', // Orange
                '#A0DA8C', // Green
                '#E983A6', // Dark Pink
                '#6BAAE6', // Blue
                '#A783E6', // Lavender
                '#E6A083',  // Coral
                '#7FD6B3', // Teal
                '#D697E6'  // Soft Purple
              ]

              updatedCompareCount.forEach((item: any, index: number) => {
                // Use the modulus operator to cycle through colors
                const colorIndex = index % colorsDark.length;
                dataSet2Array.push({ x: item.name ? item.name : 'Not Mapped', y: item.count, fillColor: colorslight[colorIndex] });
              });
              let dataSet2: any = responseData.data.comparedData.map((item: any) => item.count)
              this.horizontalBarOptions.series.push({ name: moment(this.horizontalBarEndMonth, 'MMMM').endOf('month').format('MMM-YY'), data: dataSet2Array })
              // setTimeout(() => {
              //   this.horizontalChart.updateOptions({
              //     legend: {
              //       show: false   // Dynamically hide the legend
              //     }
              //   });
              // }, 100)

            } else {
              //No data
              this.horizontalBarOptions.series.push({ name: 'Enquiries', data: [] });
            }

          }
          setTimeout(() => {

            if (this.horizontalChart) {
              let maxValue: any
              let buffer: any
              if (this.horizontalBarOptions?.series[0]?.data) {
                maxValue = Math.max(...this.horizontalBarOptions?.series[0]?.data);
                buffer = maxValue * 1.1; // Add a 10% buffer

                if (buffer < 1) {
                  buffer = 1; // Ensure at least 1 unit is added if maxValue is small
                }
                let tickAmount = buffer <= 5 ? buffer : 5;
                this.horizontalChart.updateOptions({
                  xaxis: {
                    categories: this.horizontalBarOptions.xaxis.categories,
                    max: Math.ceil(buffer), // Ensure x-axis max is greater
                    min: 0, // Start x-axis from 0
                    tickAmount: tickAmount, // Ensure distinct tick marks
                    labels: {
                      formatter: (val: number) => Math.round(val) // Ensure distinct whole numbers
                    }
                  },
                  series: this.horizontalBarOptions.series,
                  colors: [
                    '#AE83E8', // Purple
                    '#E67FE6', // Pink
                    '#8AE9E9', // Light Blue
                    '#E9EB72', // Yellow
                    '#E78F92', // Light Red
                    '#E6B76B', // Orange
                    '#A0DA8C', // Green
                    '#E983A6', // Dark Pink
                    '#6BAAE6', // Blue
                    '#A783E6', // Lavender
                    '#E6A083'  // Coral
                  ],
                  legend: {
                    show: false   // Dynamically hide the legend
                  }
                });
              } else {
                this.horizontalChart.updateOptions({
                  xaxis: {
                    categories: this.horizontalBarOptions.xaxis.categories,
                  },
                  series: this.horizontalBarOptions.series,
                  colors: [
                    '#AE83E8', // Purple
                    '#E67FE6', // Pink
                    '#8AE9E9', // Light Blue
                    '#E9EB72', // Yellow
                    '#E78F92', // Light Red
                    '#E6B76B', // Orange
                    '#A0DA8C', // Green
                    '#E983A6', // Dark Pink
                    '#6BAAE6', // Blue
                    '#A783E6', // Lavender
                    '#E6A083'  // Coral
                  ],
                  legend: {
                    show: false   // Dynamically hide the legend
                  }
                });
              }
            }
          }, 500)
        }

      } else {
        this.horizontalBarOptions.series = [];
      }
    }, error: (err) => {
        this.horizontalBarOptions.series = [];
        console.error('Error fetching stage counts:', err);
        // this.stopLoading(); // Ensure loader stops even on error
      },
      complete: () => {
        // this.stopLoading(); // Stop loader after completion
      }
    });
  }

  follwupCountData: any = [];
  totalEnquiriesTable: any = 0;
  untouchedEnquiriesTable: any = 0;
  getFollowupTableCountData() {
    let checkedZones: any = [];
    checkedZones = this.dropdownData
      .filter((zone: any) => zone.checked)         // Filter checked zones
      .map((zone: any) => zone.zone_id);                // Map to zone IDs

    let checkedStates: any = []
    checkedStates = this.dropdownData.flatMap((zone: any) => zone.States)
      .filter((state: any) => state.checked)
      .map((state: any) => state.state_id);

    // Get checked region IDs
    let checkedRegions: any = []
    checkedRegions = this.dropdownData.flatMap((zone: any) => zone.States)
      .flatMap((zone: any) => zone.Regions)        // Flatten regions
      .filter((region: any) => region.checked)     // Filter checked regions
      .map((region: any) => region.region_id);            // Map to region IDs

    // Get checked area IDs
    let checkedAreas: any = []
    // checkedAreas = this.dropdownData.flatMap((zone: any) => zone.States)
    //   .flatMap((zone: any) => zone.Regions)        // Flatten regions
    //   .flatMap((region: any) => region.Areas)      // Flatten areas
    //   .filter((area: any) => area.checked)         // Filter checked areas
    //   .map((area: any) => area.area_id);        

    let checkedCategories: any = []
    checkedCategories = this.categoryData.filter((category: any) => category.checked)         // Filter checked areas
      .map((category: any) => category.category_id);

    let checkedModels: any = []
    checkedModels = this.modelsData.filter((model: any) => model.checked)     // Filter checked regions
      .map((model: any) => model.model_id);

    let checkedDealer: any = [];
    checkedDealer = this.dropdownData.flatMap((zone: any) => zone.States)
      .flatMap((zone: any) => zone.Regions)
      // .flatMap((region: any) => region.Areas)
      .flatMap((area: any) => area.ParentDealers)
      .filter((dealer: any) => dealer.checked)
      .map((dealer: any) => dealer.parent_dealer_id);

    let checkedOutlet: any = []
    checkedOutlet = this.dropdownData.flatMap((zone: any) => zone.States)
      .flatMap((zone: any) => zone.Regions)
      // .flatMap((region: any) => region.Areas)
      .flatMap((area: any) => area.ParentDealers)
      .flatMap((dealer: any) => dealer.Outlets)
      .filter((outlet: any) => outlet.checked)
      .map((outlet: any) => outlet.outlet_id);

    let checkedUserType: any = [];
    checkedUserType = this.userData.filter((user: any) => user.checked)         // Filter checked areas
      .map((user: any) => user.role_id);
    let request: any = {
      "startDate": moment(this.startDate).format('YYYY-MM-DD'), //mandatory
      "endDate": moment(this.endDate).format('YYYY-MM-DD'), //mandatory
      "current_stage.stage_id": checkedUserType[0] == 3 ? this.stageIds : [2, 4, 5, 7, 14, 15, 16],
      "current_stage.role_id": checkedUserType.length > 0 ? checkedUserType[0] : 3
    }
    if (checkedZones.length > 0) {
      request["outlet_details.zone_id"] = checkedZones;
    }
    if (checkedStates.length > 0) {
      request["outlet_details.state_id"] = checkedStates;
    }
    if (checkedRegions.length > 0) {
      request["outlet_details.region_id"] = checkedRegions;
    }
    if (checkedAreas.length > 0) {
      request["outlet_details.area_id"] = checkedAreas;
    }
    if (checkedCategories.length > 0) {
      request["product_details.product_category_id"] = checkedCategories;
    }
    if (checkedModels.length > 0) {
      request["product_details.product_model_id"] = checkedModels;
    }

    if (checkedDealer.length > 0) {
      request["outlet_details.parent_dealer_id"] = checkedDealer;
    }

    if (checkedOutlet.length > 0) {
      request["outlet_details.outlet_id"] = checkedOutlet;
    }
    request["is_outlet_all"] = this.isActiveOutlet ? 2 : 1;
    this.followupService.geFollowupTableCounts(request).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        this.untouchedEnquiriesTable = responseData.data.untouch
        this.totalEnquiriesTable = responseData.data.totaltouch
        console.log(">>", responseData.data.data)
        const filteredDatas = responseData.data.data.filter((item: any) => {
          if (typeof item._id === 'number') {
            return item._id > 0;
          }
          return true;
        });

        this.follwupCountData = filteredDatas.map((item: any) => {
          return {
            ...item,
            enquiriesPer: item.totalCount !== 0 ? parseFloat(((item.count / item.totalCount) * 100).toFixed(2)) : 0,
            testRidePer: item.testride !== 0 ? parseFloat(((item.testride / item.count) * 100).toFixed(2)) : 0,
            bookedPer: item.booked !== 0 ? parseFloat(((item.booked / item.count) * 100).toFixed(2)) : 0,
            retailPer: item.retail !== 0 ? parseFloat(((item.retail / item.count) * 100).toFixed(2)) : 0,
            lostPer: item.lost !== 0 ? parseFloat(((item.lost / item.count) * 100).toFixed(2)) : 0
          };
        });



        console.log("this.follwupCountData: ", this.follwupCountData)
      } else {
        this.follwupCountData = []
      }
    });
  }

  isActiveOutlet: boolean = false;
  outletToggle(event: any) {
    this.isActiveOutlet = event.checked;
    let filterObject: any = {}
    if (sessionStorage.getItem('filterObject')) {
      filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
    }
    filterObject.isActiveOutlet = this.isActiveOutlet;
    sessionStorage.setItem('filterObject', JSON.stringify(filterObject));
    // this.getGeographyList();
    this.getUserList();
    this.callApiOnCheck();
    if (this.roleId == 8 || this.roleId == 9 || this.roleId == 5 || this.roleId == 10) {
      this.getDealerOutletList();
    } else {
      this.getGeographyList();
    }
  }
  onZoneByLead() {
    let isEveryRegion: boolean = this.regionData.every((object: any) => {
      return !object.regions || object.regions.length === 0;
    });
    /**
     * If all the regions is empty in all the zones, then show all the zones count in single pie chart
     */
    if (isEveryRegion) {
      // No regions, show all zones in one chart
      const zoneLabels = this.regionData.map((zone: any) => zone.zone_name);
      const zoneCounts = this.regionData.map((zone: any) => zone.count);
      const totalCount = zoneCounts.reduce((accumulator: any, currentValue: any) => accumulator + currentValue, 0);
      const zoneLeadsCounts = this.regionData.map((zone: any) => zone.totalLeads ?? 0);

      const chartData = {
        data: {
          labels: zoneLabels,  // Zone names as labels
          datasets: [
            {
              data: zoneCounts,  // Zone counts
              backgroundColor: [
                // Original colors
                "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                // First additional set
                "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                // New additional colors
                "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                // Additional colors to reach 40
                "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
              ],
              // hoverBackgroundColor: this.getRandomColors(zoneLabels.length)
            }
          ]
        },
        options: {
          title: '',
          subText1: '',
          subText2: '',
          cutout: '28%',
          plugins: {
            datalabels: {
              color: '#fff',
              display: true,
              formatter: function (value: any, context: any) {
                // Calculate percentage
                const total = context.chart._metasets[context.datasetIndex].total;
                const index = context.dataIndex; // Get index of data label
                const leads = zoneLeadsCounts[index]
                const totalSeconds = (value / leads).toFixed(2);
                const percentage = ((value / total) * 100).toFixed(0);

                // Return count and percentage on different lines
                return `${totalSeconds}`;
              },
              font: {
                size: 9
              },
              anchor: 'end',
              align: 'start'
            },
            legend: {
              display: true,
              labels: {
                usePointStyle: true,
                text: 'Zones'
              }
            }, tooltip: { enabled: false } //
          },
          responsive: true,
          maintainAspectRatio: false
        }
      };

      this.chartsData.push(chartData);

    } else {
      let isEveryArea: boolean = this.regionData.every((object: any) => {
        return !object.regions || object.regions.length === 0;
      });

      this.regionData.forEach((zoneObj: any) => {
        const zoneName = zoneObj.zone_name;
        const zoneCount = (zoneObj.count / zoneObj.totalLeads).toFixed(2);

        if (zoneObj.regions && zoneObj.regions.length > 0) {
          const regionLeadsCounts = zoneObj.regions.map((zone: any) => zone.totalLeads ?? 0);
          // Zone has regions, create separate charts for each zone
          zoneObj.regions.forEach((regionObj: any) => {
            const regionName = regionObj.region_name;
            const regionCount = regionObj.count;

            if (regionObj?.areas && regionObj?.areas.length > 0) {
              // Region has areas, show all areas in one chart
              const areaLabels = regionObj.areas.map((area: any) => area.area_name);
              const areaCounts = regionObj.areas.map((area: any) => area.count);

              const chartData = {
                zone: zoneName,
                region: regionName,
                data: {
                  labels: areaLabels,  // Area names as labels
                  datasets: [
                    {
                      data: areaCounts,  // Area counts
                      backgroundColor: [
                        // Original colors
                        "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                        // First additional set
                        "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                        // New additional colors
                        "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                        // Additional colors to reach 40
                        "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                        "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                        "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                        "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                        "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
                      ],
                      // hoverBackgroundColor: this.getRandomColors(areaLabels.length)
                    }
                  ]
                },

                options: {
                  title: `${zoneName} - ${zoneCount}`,
                  subText1: ` ${regionName} - ${regionCount}`,
                  subText2: '',
                  cutout: '28%',
                  plugins: {
                    datalabels: {
                      color: '#fff',
                      display: true,
                      formatter: function (value: any, context: any) {
                        // Calculate percentage
                        const total = context.chart._metasets[context.datasetIndex].total;
                        const percentage = ((value / total) * 100).toFixed(0);
                        const index = context.dataIndex;
                        const leads = regionLeadsCounts[index]
                        const totalSeconds = (value / leads).toFixed(2);
                        // Return count and percentage on different lines
                        return `${totalSeconds}`;
                      },
                      font: {
                        size: 9
                      },
                      anchor: 'end',
                      align: 'start'
                    },
                    legend: {
                      display: true,
                      labels: {
                        usePointStyle: true,
                        text: 'Zones'
                      }
                    }, tooltip: { enabled: false } //
                  },
                  responsive: true,
                  maintainAspectRatio: false
                }
              };
              let filteredData: any = []
              filteredData = this.chartsData.filter((item: any) => item.region == chartData.region)
              if (filteredData.length == 0) {
                this.chartsData.push(chartData);
              }
            } else {
              // Region has no areas, show all regions in one chart for the zone
              let isNoArea: boolean = zoneObj.regions.every((item: any) => !item?.areas || item?.areas?.length === 0);
              let filteredDataNoArea = zoneObj.regions.filter((item: any) => {
                return !item?.areas || item?.areas?.length == 0;
              });
              if (filteredDataNoArea.length != 0) {

                const regionLabels = filteredDataNoArea.map((region: any) => region.region_name);
                const regionCounts = filteredDataNoArea.map((region: any) => region.count);

                const chartData = {
                  zone: zoneName.toLowerCase(),
                  region: regionName.toLowerCase(),
                  data: {
                    labels: regionLabels,  // Region names as labels
                    datasets: [
                      {
                        data: regionCounts,  // Region counts
                        backgroundColor: [
                          // Original colors
                          "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                          // First additional set
                          "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                          // New additional colors
                          "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                          // Additional colors to reach 40
                          "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                          "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                          "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                          "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                          "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
                        ],
                        // hoverBackgroundColor: this.getRandomColors(regionLabels.length)
                      }
                    ]
                  },
                  options: {
                    title: `${zoneName} - ${zoneCount}`,
                    subText1: '',
                    subText2: '',
                    cutout: '28%',
                    plugins: {
                      datalabels: {
                        color: '#fff',
                        display: true,
                        formatter: function (value: any, context: any) {
                          // Calculate percentage
                          const total = context.chart._metasets[context.datasetIndex].total;
                          const percentage = ((value / total) * 100).toFixed(0);
                          const index = context.dataIndex;
                          const leads = regionLeadsCounts[index]
                          const totalSeconds = (value / leads).toFixed(2);
                          // Return count and percentage on different lines
                          return `${totalSeconds}`;
                        },
                        font: {
                          size: 9
                        },
                        anchor: 'end',
                        align: 'start'
                      },
                      legend: {
                        display: true,
                        labels: {
                          usePointStyle: true,
                          text: 'Zones'
                        }
                      }, tooltip: { enabled: false } //
                    },
                    responsive: true,
                    maintainAspectRatio: false
                  }
                };
                let filteredData: any = []
                if (isNoArea) {
                  filteredData = this.chartsData.filter((item: any) => item?.zone?.toLowerCase() == chartData.zone)
                  if (filteredData.length == 0) {
                    this.chartsData.push(chartData);
                  }
                } else {
                  filteredData = this.chartsData.filter((item: any) => item.zone.toLowerCase() == chartData.zone && item.region.toLowerCase() == chartData.region)
                  if (filteredData.length == 0) {
                    this.chartsData.push(chartData);
                  }
                }

              }
            }
          });
        } else {

          let filteredDataNoRegions = this.regionData.filter((item: any) => {
            return item?.regions && item?.regions?.length == 0;
          });
          const zoneLabels = filteredDataNoRegions.map((zone: any) => zone.zone_name);
          const zoneCounts = filteredDataNoRegions.map((zone: any) => zone.count);
          const totalCount = zoneCounts.reduce((accumulator: any, currentValue: any) => accumulator + currentValue, 0);

          const chartData = {
            zone: 'remaining-zones',
            data: {
              labels: zoneLabels,  // Zone names as labels
              datasets: [
                {
                  data: zoneCounts,  // Zone counts
                  backgroundColor: [
                    // Original colors
                    "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                    // First additional set
                    "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                    // New additional colors
                    "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                    // Additional colors to reach 40
                    "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                    "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                    "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                    "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                    "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
                  ],
                  // hoverBackgroundColor: this.getRandomColors(zoneLabels.length)
                }
              ]
            },
            options: {
              title: '',
              cutout: '28%',
              plugins: {
                datalabels: {
                  color: '#fff',
                  display: true,
                  formatter: function (value: any, context: any) {
                    // Calculate percentage
                    const total = context.chart._metasets[context.datasetIndex].total;
                    const percentage = ((value / total) * 100).toFixed(0);

                    // Return count and percentage on different lines
                    return `${value}\n ${percentage}%`;
                  },
                  font: {
                    weight: 'bold',
                    size: 9
                  },
                  anchor: 'end',
                  align: 'start'
                },
                legend: {
                  display: true,
                  labels: {
                    usePointStyle: true,
                    text: 'Zones'
                  }
                }, tooltip: { enabled: false } //
              },
              responsive: true,
              maintainAspectRatio: false
            }
          };
          let filteredData = this.chartsData.filter((item: any) => item.zone.toLowerCase() == chartData.zone)
          if (filteredData.length == 0) {
            this.chartsData.push(chartData);
          }
        }

      });
    }
  }

  onPDChartByLeads() {
    let isEveryOutlet: boolean = this.regionData.every((object: any) => {
      return !object.outlets || object.outlets.length === 0;
    });

    if (isEveryOutlet) {
      const dealerLabels = this.regionData.map((dealer: any) => dealer.parent_dealer || dealer.parent_dealer_name);
      const dealerCounts = this.regionData.map((dealer: any) => dealer.count / dealer.totalLedads);
      const totalCount = dealerCounts.reduce((accumulator: any, currentValue: any) => accumulator + currentValue, 0);


      const chartData = {
        data: {
          labels: dealerLabels,  // Zone names as labels
          datasets: [
            {
              data: dealerCounts,  // Zone counts
              backgroundColor: [
                // Original colors
                "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                // First additional set
                "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                // New additional colors
                "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                // Additional colors to reach 40
                "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
              ],
              // hoverBackgroundColor: this.getRandomColors(zoneLabels.length)
            }
          ]
        },
        options: {
          title: '',
          subText1: '',
          subText2: '',
          cutout: '28%',
          plugins: {
            datalabels: {
              color: '#fff',
              display: true,
              formatter: function (value: any, context: any) {
                // Calculate percentage
                const total = context.chart._metasets[context.datasetIndex].total;
                const percentage = ((value / total) * 100).toFixed(0);

                // Return count and percentage on different lines
                return `${value}\n ${percentage}%`;
              },
              font: {
                size: 9
              },
              anchor: 'end',
              align: 'start'
            },
            legend: {
              display: true,
              labels: {
                usePointStyle: true,
                text: 'Zones'
              }
            }, tooltip: { enabled: false } //
          },
          responsive: true,
          maintainAspectRatio: false
        }
      };

      this.chartsData.push(chartData);

    } else {

      this.regionData.forEach((dealerObj: any) => {
        const dealerName = dealerObj.parent_dealer || dealerObj.parent_dealer_name;
        const dealerCount = (dealerObj.count / dealerObj.totalLeads).toFixed(2);

        if (dealerObj.outlets && dealerObj.outlets.length > 0) {
          const outletLeadsCounts = dealerObj.outlets.map((zone: any) => zone.totalLeads ?? 0);
          dealerObj.outlets.forEach((ouletObj: any) => {
            const outletName = ouletObj.outlet_name;
            const outletCount = ouletObj.count;

            let filteredDataNoArea = dealerObj.outlets
            if (filteredDataNoArea.length != 0) {

              const outletLabels = filteredDataNoArea.map((outlet: any) => outlet.outlet_name);
              const outletCounts = filteredDataNoArea.map((outlet: any) => outlet.count);

              const chartData = {
                zone: dealerName?.toLowerCase(),
                region: outletName?.toLowerCase(),
                data: {
                  labels: outletLabels,  // Region names as labels
                  datasets: [
                    {
                      data: outletCounts,  // Region counts
                      backgroundColor: [
                        // Original colors
                        "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                        // First additional set
                        "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                        // New additional colors
                        "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                        // Additional colors to reach 40
                        "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                        "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                        "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                        "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                        "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
                      ],
                      // hoverBackgroundColor: this.getRandomColors(regionLabels.length)
                    }
                  ]
                },
                options: {
                  title: `${dealerName} - ${dealerCount}`,
                  subText1: '',
                  subText2: '',
                  cutout: '28%',
                  plugins: {
                    datalabels: {
                      color: '#fff',
                      display: true,
                      formatter: function (value: any, context: any) {
                        // Calculate percentage
                        const total = context.chart._metasets[context.datasetIndex].total;
                        const percentage = ((value / total) * 100).toFixed(0);
                        const index = context.dataIndex; // Get index of data label
                        const leads = outletLeadsCounts[index]
                        const totalSeconds = (value / leads).toFixed(2);
                        // Return count and percentage on different lines
                        return `${totalSeconds}`;
                      },
                      font: {
                        size: 9
                      },
                      anchor: 'end',
                      align: 'start'
                    },
                    legend: {
                      display: true,
                      labels: {
                        usePointStyle: true,
                        text: 'Zones'
                      }
                    }, tooltip: { enabled: false } //
                  },
                  responsive: true,
                  maintainAspectRatio: false
                }
              };
              let filteredData: any = []

              filteredData = this.chartsData.filter((item: any) => item?.zone?.toLowerCase() == chartData?.zone && item?.zone?.toLowerCase() == chartData?.zone)
              if (filteredData.length == 0) {
                this.chartsData.push(chartData);
              }

            }

          });
        } else {

          let filteredDataNoOutlets = this.regionData.filter((item: any) => {
            return item?.outlets && item?.outlets?.length == 0;
          });
          const dealerLabels = filteredDataNoOutlets.map((dealer: any) => dealer.parent_dealer || dealer.parent_dealer_name);
          const dealerCounts = filteredDataNoOutlets.map((dealer: any) => dealer.count);
          const totalCount = dealerCounts.reduce((accumulator: any, currentValue: any) => accumulator + currentValue, 0);

          const chartData = {
            zone: 'remaining-zones',
            data: {
              labels: dealerLabels,  // Zone names as labels
              datasets: [
                {
                  data: dealerCounts,  // Zone counts
                  backgroundColor: [
                    // Original colors
                    "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                    // First additional set
                    "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                    // New additional colors
                    "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                    // Additional colors to reach 40
                    "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                    "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                    "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                    "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                    "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
                  ],
                  // hoverBackgroundColor: this.getRandomColors(zoneLabels.length)
                }
              ]
            },
            options: {
              title: '',
              cutout: '28%',
              plugins: {
                datalabels: {
                  color: '#fff',
                  display: true,
                  formatter: function (value: any, context: any) {
                    // Calculate percentage
                    const total = context.chart._metasets[context.datasetIndex].total;
                    const percentage = ((value / total) * 100).toFixed(0);

                    // Return count and percentage on different lines
                    return `${value}\n ${percentage}%`;
                  },
                  font: {
                    weight: 'bold',
                    size: 9
                  },
                  anchor: 'end',
                  align: 'start'
                },
                legend: {
                  display: true,
                  labels: {
                    usePointStyle: true,
                    text: 'Zones'
                  }
                }, tooltip: { enabled: false } //
              },
              responsive: true,
              maintainAspectRatio: false
            }
          };
          let filteredData = this.chartsData.filter((item: any) => item?.zone?.toLowerCase() == chartData?.zone)
          if (filteredData.length == 0) {
            this.chartsData.push(chartData);
          }
        }

      });
    }
  }

  selectedZonalMgrs: any = []
  onZoneSelect(item: any) {
    let zoneId: any = this.selectedZonalMgrs.map((item: any) => item.zone_id);
    this.regionalList = [...this.regionalListAll.filter((zone: any) => zoneId.includes(zone.zone_id))];
    let event = { checked: true }
    this.onZoneCheck(event, item.zone_id)

    let ids: any = [...new Set(this.regionalList.map((item: any) => item.outlet_id).flat())]
    this.areaList = [...this.areaListAll.filter((item: any) =>
      Array.isArray(item.outlet_id) && item.outlet_id.some((id: any) => ids.includes(id))
    )];
  }


  onZoneDeSelect(item: any) {
    let zoneId: any = this.selectedZonalMgrs.map((item: any) => item.zone_id)
    this.regionalList = [...this.regionalListAll.filter((zone: any) => zoneId.includes(zone.zone_id))];
    if (this.regionalList.length == 0) {
      this.regionalList = this.regionalListAll
    }
    let event = { checked: false }
    const regionalUsernames = this.regionalList.map((r: any) => r.username);
    this.selectedRegionalMgrs = this.selectedRegionalMgrs.filter((mgr: any) =>
      regionalUsernames.includes(mgr.username)
    );
    if (this.regionalList.length == this.regionalListAll.length) {
      this.selectedRegionalMgrs = [];
      this.selectedAreaMgrs = [];
    }
    this.onZoneCheck(event, item.zone_id)

    let ids: any = [...new Set(this.regionalList.map((item: any) => item.outlet_id).flat())]
    this.areaList = [...this.areaListAll.filter((item: any) =>
      Array.isArray(item.outlet_id) && item.outlet_id.some((id: any) => ids.includes(id))
    )];
    if (this.selectedRegionalMgrs.length == 0) {
      this.selectedAreaMgrs = []
    }
  }

  selectedRegionalMgrs: any = []
  onRegionSelect(item: any) {
    let filterUser: any = [];
    filterUser = this.regionalListAll.filter((user: any) => user.username.toLowerCase().trim() == item.username.toLowerCase().trim())
    let regionIds: any = []
    if (filterUser.length > 0) {
      regionIds = filterUser[0].region_id
    }
    // Flatten selectedRegionalMgrs' region_id arrays
    let outletIdList: number[] = this.selectedRegionalMgrs
      .map((mgr: any) => mgr.outlet_id)
      .flat();
    // Get areaList based on selected region IDs
    this.areaList = [
      ...this.areaListAll.filter((area: any) =>
        Array.isArray(area.outlet_id) &&
        area.outlet_id.some((id: any) => outletIdList.includes(id))
      )
    ];

    let stateId: any = null
    // Simulate checkbox events for all selected regions
    if (filterUser.length > 0) {
      stateId = filterUser[0].state_id
    }
    // Check the selected regions and their parent zones
    const zoneRegionInfoList: { zone_id: number; region_id: number, state_id: number }[] = [];

    for (const zone of this.dropdownData) {
      for (const state of zone.States || []) {
        for (const region of state.Regions || []) {
          if (regionIds.includes(region.region_id)) {
            zone.checked = true;
            region.checked = true;
            state.checked = true;
            zoneRegionInfoList.push({
              zone_id: zone.zone_id,
              region_id: region.region_id,
              state_id: state.state_id
            });
          }
        }
      }
    }

    console.log("zoneRegionInfoList: ", zoneRegionInfoList)
    const event = { checked: true };
    setTimeout(() => {
      zoneRegionInfoList.forEach(info => {
        this.onRegionCheck(event, info.zone_id, info.state_id, info.region_id);
      });
    }, 100);

    setTimeout(() => {
      this.updateAreaManagersList()
    }, 300);
  }


  onRegionDeSelect(item: any) {
    let filterUser: any = [];
    filterUser = this.regionalListAll.filter((user: any) => user.username.toLowerCase().trim() == item.username.toLowerCase().trim())
    let regionIds: any = []
    if (filterUser.length > 0) {
      regionIds = filterUser[0].region_id
    }
    // Flatten selectedRegionalMgrs region_id arrays
    let ouletIdList: number[] = this.selectedRegionalMgrs
      .map((mgr: any) => mgr.oulet_id)
      .flat();

    // Update areaList based on currently selected regions
    this.areaList = [
      ...this.areaListAll.filter((region: any) => ouletIdList.includes(region.oulet_id))
    ];
    const regionalUsernames = this.areaList.map((r: any) => r.username);
    this.selectedAreaMgrs = this.selectedAreaMgrs.filter((mgr: any) =>
      regionalUsernames.includes(mgr.username)
    );
    const event = { checked: false };
    if (this.areaList.length == this.areaListAll.length) {
      this.selectedAreaMgrs = [];
    }
    // Loop through all region IDs and find zone-region relationships
    const zoneRegionInfoList: { zone_id: number; region_id: number, state_id: number }[] = [];

    let stateId: any = null
    // Simulate checkbox events for all selected regions
    if (filterUser.length > 0) {
      stateId = filterUser[0].state_id
    }
    for (const zone of this.dropdownData) {
      for (const state of zone.States || []) {
        for (const region of state.Regions || []) {
          if (regionIds.includes(region.region_id)) {
            region.checked = false;
            // region.Areas.forEach((area: any) => {
            //   area.checked = false;
            region.ParentDealers.forEach((dealer: any) => {
              dealer.checked = false;
              dealer.Outlets.forEach((outlet: any) => {
                outlet.checked = false;
              });
              // })
            })
            const anyFiltered = state.Regions.some((region: any) => region.checked);
            if (!anyFiltered) {
              state.checked = false;
            }
            // Optional: If no regions are checked under a zone, uncheck the zone
            const anyRegionCheckedInFiltered = zone.States.some((region: any) => region.checked);
            if (!anyRegionCheckedInFiltered) {
              // zone.checked = false;
            }

            zoneRegionInfoList.push({
              zone_id: zone.zone_id,
              region_id: region.region_id,
              state_id: state.state_id
            });
          }
        }
      }
    }
    console.log("zoneRegionInfoList: ", zoneRegionInfoList)
    // Trigger uncheck logic
    setTimeout(() => {
      zoneRegionInfoList.forEach(info => {
        this.onRegionCheck(event, info.zone_id, info.state_id, info.region_id);
      });
    }, 100);

    // If no areas remain selected, call getAreaManager
    if (this.areaList.length === 0) {
      this.areaList = [...this.areaListAll]
    }
    if (this.selectedRegionalMgrs.length == 0 && this.selectedZonalMgrs.length == 0) {
      this.areaList = [...this.areaListAll]
    } else if (this.selectedRegionalMgrs.length == 0 && this.selectedZonalMgrs.length != 0) {
      let ids: any = [...new Set(this.regionalList.map((item: any) => item.outlet_id).flat())]
      this.areaList = [...this.areaListAll.filter((item: any) =>
        Array.isArray(item.outlet_id) && item.outlet_id.some((id: any) => ids.includes(id))
      )];
    }
    setTimeout(() => {
      this.updateAreaManagersList()
    }, 300);
  }


  selectedAreaMgrs: any = []
  onAreaSelect(item: any) {
    const outletIds = item.outlet_id || [];
    const zoneRegionInfoList: { zone_id: number; region_id: number; }[] = [];
    let filterUser: any = [];
    filterUser = this.areaListAll.filter((user: any) => user.username.toLowerCase().trim() == item.username.toLowerCase().trim())
    let stateId: any = null
    if (filterUser.length > 0) {
      stateId = filterUser[0].state_id
    }
    console.log("outletIds: ", outletIds)
    for (const zone of this.dropdownData) {
      for (const state of zone.States || []) {
        for (const region of state.Regions || []) {
          // for (const area of region.Areas || []) {
          for (const dealer of region.ParentDealers) {
            for (const outlet of dealer.Outlets) {
              if (outletIds.includes(outlet.outlet_id)) {
                zoneRegionInfoList.push({
                  zone_id: zone.zone_id,
                  region_id: region.region_id,
                  // area_id: area.area_id
                });
                zone.checked = true;
                state.checked = true;
                region.checked = true;
                // area.checked = true;
                dealer.checked = true;
                outlet.checked = true;
              }
            }
          }
          // }
        }
      }
    }

    for (const zone of this.filteredData) {
      for (const state of zone.States || []) {
        for (const region of state.Regions || []) {
          // for (const area of region.Areas || []) {
          for (const dealer of region.ParentDealers) {
            for (const outlet of dealer.Outlets) {
              if (outletIds.includes(outlet.outlet_id)) {
                zone.checked = true;
                state.checked = true;
                region.checked = true;
                // area.checked = true;
                dealer.checked = true;
                outlet.checked = true;
              }
            }
            // }
          }
        }
      }
    }
    this.updateSelectAllStatus()
  }



  onAreaDeSelect(item: any) {
    const outletIds = item.outlet_id || [];
    let filterUser: any = [];
    filterUser = this.areaListAll.filter((user: any) => user.username.toLowerCase().trim() == item.username.toLowerCase().trim())
    let stateId: any = null
    let regionId: any = []
    if (filterUser.length > 0) {
      stateId = filterUser[0].state_id
      regionId = filterUser[0].region_id
    }
    for (const zone of this.dropdownData) {
      for (const state of zone.States || []) {
        for (const region of state.Regions || []) {
          // for (const area of region.Areas || []) {
          region.ParentDealers.forEach((dealer: any) => {
            dealer.Outlets.forEach((outlet: any) => {
              if (outletIds.includes(outlet.outlet_id)) {
                // area.checked = false;
                dealer.checked = false;
                outlet.checked = false;
              }
            });
          })
          // }
        }
      }
    }
      setTimeout(()=>{
      this.updateFilter();
    },100)
    this.updateSelectAllStatus();
  }

  getZonalManager() {
    this.followupService.getGeography({ "is_outlet_all": this.isActiveOutlet ? 2 : 1 }).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        this.zonalList = responseData.data
        if (sessionStorage.getItem('filterObject')) {
          this.filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
          if (this.filterObject.zonalManagers) {
            this.selectedZonalMgrs = this.filterObject.zonalManagers || [];
          }
        }
      }
    });
  }

  regionalListAll: any = []
  getRegionalManager() {
    let zoneId: any = null;
    let regionId: any = [];
    if (sessionStorage.getItem('loginResponse')) {
      const loginResponse = JSON.parse(sessionStorage.getItem('loginResponse') || '{}');
      if (loginResponse && loginResponse.data) {
        zoneId = loginResponse.data?.user?.zone_id;
        regionId = loginResponse.data?.user?.regions;
      }
    }
    this.followupService.getRegionalMgrs({}).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {

        if (this.roleId == 2) {
          this.regionalList = responseData.data
          this.regionalListAll = [...responseData.data]
        } else if (this.roleId == 6) {
          this.regionalList = [...responseData.data.filter((item: any) => item.zone_id == zoneId)]
          this.regionalListAll = [...responseData.data.filter((item: any) => item.zone_id == zoneId)]
        } else if (this.roleId == 7) {
          this.regionalList = responseData.data.filter((item: any) =>
            Array.isArray(item.region_id) &&
            item.region_id.length === regionId.length &&
            item.region_id.every((id: any) => regionId.includes(id)) &&
            regionId.every((id: any) => item.region_id.includes(id))
          );

          this.regionalListAll = responseData.data.filter((item: any) =>
            Array.isArray(item.region_id) &&
            item.region_id.length === regionId.length &&
            item.region_id.every((id: any) => regionId.includes(id)) &&
            regionId.every((id: any) => item.region_id.includes(id))
          );

        }
        setTimeout(() => {
          if (sessionStorage.getItem('filterObject')) {
            let filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
            let selectedZonalMgrs: any = []
            if (filterObject.zonalManagers) {
              selectedZonalMgrs = filterObject.zonalManagers || [];
            }
            if (selectedZonalMgrs.length > 0) {
              let zoneId: any = selectedZonalMgrs.map((item: any) => item.zone_id);
              this.regionalList = [...this.regionalListAll.filter((zone: any) => zoneId.includes(zone.zone_id))];
            }
            if (filterObject?.regionalManagers) {
              if (filterObject?.regionalManagers.length > 0) {
                let regionMgrs: any = filterObject?.regionalManagers || [];
                let names: any = regionMgrs.map((user: any) => user.username.toLowerCase().trim())
                let filterUser: any = [];
                filterUser = this.regionalListAll.filter((user: any) => names.includes(user.username.toLowerCase().trim()))
                this.selectedRegionalMgrs = filterUser;
              }
            }
          }
        }, 1000)
      }
    });
  }

  areaListAll: any = []
  getAreaManager() {
    let regionId: any = [];
    let zoneId: any = null
    if (sessionStorage.getItem('loginResponse')) {
      const loginResponse = JSON.parse(sessionStorage.getItem('loginResponse') || '{}');
      if (loginResponse && loginResponse.data) {
        zoneId = loginResponse.data?.user?.zone_id;
        regionId = loginResponse.data?.user?.regions;
      }
    }
    this.followupService.getAreaMgrs({}).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        if (this.roleId == 2) {
          this.areaList = responseData.data;
          this.areaListAll = [...responseData.data]
          if (sessionStorage.getItem('filterObject')) {
            let filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
            let selectedRegionalMgrs: any = []
            if (filterObject.regionalManagers) {
              selectedRegionalMgrs = filterObject.regionalManagers || [];
            }
            if (selectedRegionalMgrs.length > 0) {
              let regionIdList: number[] = selectedRegionalMgrs
                .map((mgr: any) => mgr.outlet_id)
                .flat();
              // Get areaList based on selected region IDs
              this.areaList = [
                ...this.areaListAll.filter((region: any) =>
                  Array.isArray(region.outlet_id) && region.outlet_id.some((id: any) => regionIdList.includes(id))
                )
              ];
            }
            if (filterObject?.areaManagers) {
              if (filterObject?.areaManagers.length > 0) {
                let areaMgrs: any = filterObject?.areaManagers || [];
                let names: any = areaMgrs.map((user: any) => user.username.toLowerCase().trim())
                let filterUser: any = [];
                filterUser = [...this.areaListAll.filter((user: any) =>
                  names.map((name: any) => name.toLowerCase().trim()).includes(user.username.toLowerCase().trim())
                )]
                this.selectedAreaMgrs = filterUser;
              }
            }
          }

        } else if (this.roleId == 6 || this.roleId == 7) {
          setTimeout(() => {
            let ids: any = [...new Set(this.regionalListAll.map((item: any) => item.outlet_id).flat())]
            this.areaList = responseData.data.filter((item: any) =>
              Array.isArray(item.outlet_id) && item.outlet_id.some((id: any) => ids.includes(id))
            );
            this.areaListAll = [
              ...responseData.data.filter((item: any) =>
                Array.isArray(item.outlet_id) &&
                item.outlet_id.some((id: any) => ids.includes(id))
              )
            ];
            if (sessionStorage.getItem('filterObject')) {
              let filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
              let selectedRegionalMgrs: any = []
              if (filterObject.regionalManagers) {
                selectedRegionalMgrs = filterObject.regionalManagers || [];
              }
              if (selectedRegionalMgrs.length > 0) {
                let regionIdList: number[] = selectedRegionalMgrs
                  .map((mgr: any) => mgr.outlet_id)
                  .flat();
                // Get areaList based on selected region IDs
                this.areaList = [
                  ...this.areaListAll.filter((region: any) =>
                    Array.isArray(region.outlet_id) && region.outlet_id.some((id: any) => regionIdList.includes(id))
                  )
                ];
              }
              if (filterObject?.areaManagers) {
                if (filterObject?.areaManagers.length > 0) {
                  let areaMgrs: any = filterObject?.areaManagers || [];
                  let names: any = areaMgrs.map((user: any) => user.username.toLowerCase().trim())
                  let filterUser: any = [];
                  filterUser = [...this.areaListAll.filter((user: any) =>
                    names.map((name: any) => name.toLowerCase().trim()).includes(user.username.toLowerCase().trim())
                  )]
                  this.selectedAreaMgrs = filterUser;
                }
              }
            }

          }, 800)
        }
      }
    });
  }

  applyManagers() {
    // let zoneId: any = this.selectedZonalMgrs.map((item: any) => item.zone_id);
    // let event = { checked: true }
    // this.onZoneCheck(event, zoneId)
    let filterObject: any = {}
    if (sessionStorage.getItem('filterObject')) {
      filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
    }
    filterObject.zonalManagers = this.selectedZonalMgrs;
    filterObject.regionalManagers = this.selectedRegionalMgrs;
    filterObject.areaManagers = this.selectedAreaMgrs;
    sessionStorage.setItem('filterObject', JSON.stringify(filterObject))
    setTimeout(() => {
      this.applyDateRange();
    }, 100)
  }

  filterManagerList() {
    let zoneId: any = null;
    let regionId: any = [];
    let areaId: any = [];
    if (sessionStorage.getItem('loginResponse')) {
      const loginResponse = JSON.parse(sessionStorage.getItem('loginResponse') || '{}');
      if (loginResponse && loginResponse.data) {
        zoneId = loginResponse.data?.user?.zone_id;
        regionId = loginResponse.data?.user?.regions;
        areaId = loginResponse.data?.user?.areas;
      }
    }
    if (this.roleId == 2 && this.regionalList.length == 0 || this.roleId == 2 && this.areaList.length == 0) {
      this.regionalList = [...this.zonalList.flatMap((zone: any) => zone.Regions)]
      this.areaList = [...this.zonalList.flatMap((zone: any) => zone.Regions).flatMap((region: any) => region.Areas)]
    } else if (this.roleId == 6 && this.regionalList.length == 0 || this.roleId == 6 && this.areaList.length == 0) {
      this.regionalList = [...this.zonalList.filter((item: any) => item.zone_id == zoneId).flatMap((zone: any) => zone.Regions)]
      this.areaList = [...this.zonalList.filter((item: any) => item.zone_id == zoneId).flatMap((zone: any) => zone.Regions).flatMap((region: any) => region.Areas)]
    } else if (this.roleId == 7 && this.regionalList.length == 0 || this.roleId == 7 && this.areaList.length == 0) {
      this.areaList = [...this.zonalList.flatMap((zone: any) => zone.Regions).filter((item: any) => regionId.includes(item.region_id)).flatMap((region: any) => region.Areas)]
    }
  }


  onStateCheck(event: any, zoneId: any, stateId: any) {
    // Find the zone and region in dropdownData using id
    let zone = { ...this.dropdownData.find((z: any) => z.zone_id == zoneId) };
    let state = zone?.States.find((r: any) => r.state_id == stateId);

    // Find the zone and region in filteredData using id
    let filteredZone = this.filteredData.find((z: any) => z.zone_id == zoneId);
    let filteredState = filteredZone?.States.find((r: any) => r.state_id == stateId);

    if (event.checked) {
      // this.autoCheck(zone, region);
      state.checked = true
      filteredState.checked = true
      // Set zone checked if any region is checked in dropdownData
      const anyRegionChecked = zone.States.some((r: any) => r.checked);
      if (anyRegionChecked) {
        zone.checked = true;
      }

      // Set zone checked if any region is checked in filteredData
      const anyRegionCheckedInFiltered = filteredZone.States.some((r: any) => r.checked);
      if (anyRegionCheckedInFiltered) {
        filteredZone.checked = true;
      }
    } else {
      // Uncheck all areas within the unchecked region
      state.checked = false;
      state?.Regions.forEach((region: any) => {
        region.checked = false;
        // region?.Areas.forEach((area: any) => {
        //   area.checked = false;
        region.ParentDealers.forEach((dealer: any) => {
          dealer.checked = false;
          dealer.Outlets.forEach((outlet: any) => {
            outlet.checked = false;
          });
        })
        // })
      });

      filteredState.checked = false;
      filteredState?.Regions.forEach((region: any) => {
        region.checked = false;
        // region?.Areas.forEach((area: any) => {
        //   area.checked = false;
        region.ParentDealers.forEach((dealer: any) => {
          dealer.checked = false;
          dealer.Outlets.forEach((outlet: any) => {
            outlet.checked = false;
          });
        })
        // })
      });
    }
    this.updateSelectAllStatus()
  }

  onStateCheckAll(event: any, zoneId: any, zoneObj: any) {
    let zone = this.dropdownData.find((z: any) => z.zone_id == zoneId);
    let filteredZone = this.filteredData.find((z: any) => z.zone_id == zoneId);

    if (event.checked) {
      // this.autoCheck(zone, null)
      zone.checked = true;
      filteredZone.checked = true;
      zoneObj.States.forEach((region: any) => {
        let regionToCheck = zone.States.find((r: any) => r.state_id === region.state_id);
        let filteredRegionToCheck = filteredZone.States.find((r: any) => r.state_id === region.state_id);

        if (regionToCheck) regionToCheck.checked = true;
        if (filteredRegionToCheck) filteredRegionToCheck.checked = true;
      });
    } else {

      zoneObj.States.forEach((state: any) => {
        let regionToUncheck = zone.States.find((r: any) => r.state_id === state.state_id);
        let filteredRegionToUncheck = filteredZone.States.find((r: any) => r.state_id === state.state_id);

        if (regionToUncheck) regionToUncheck.checked = false;
        if (filteredRegionToUncheck) filteredRegionToUncheck.checked = false;
        state.Regions.forEach((region: any) => {
          region.checked = false;
          // region.Areas.forEach((area: any) => {
          //   area.checked = false;
          region.ParentDealers.forEach((dealer: any) => {
            dealer.checked = false;
            dealer.Outlets.forEach((outlet: any) => {
              outlet.checked = false;
            });
          })
          // });
        })
      });
    }
    this.updateSelectAllStatus()
  }

  showErrorForArea() {
    if (this.roleId == 2) {
      if (this.selectedZonalMgrs.length === 0 && this.selectedRegionalMgrs.length === 0) {
        this.toastr.error('Please select Zonal Manager and Regional Manager first!');
        return;
      } else if (this.selectedRegionalMgrs.length === 0) {
        this.toastr.error('Please select Regional Manager!');
      } else if (this.selectedZonalMgrs.length === 0) {
        this.toastr.error('Please select Zonal Manager!');
      }
    } else if (this.roleId == 6) {
      if (this.selectedRegionalMgrs.length === 0) {
        this.toastr.error('Please select Regional Manager!');
      }
    }
  }

  showErrorForRegion() {
    if (this.roleId == 2) {
      if (this.selectedZonalMgrs.length === 0) {
        this.toastr.error('Please select Zonal Manager first!');
      }
    }
  }

  activeRequests = 0;
  startLoading() {
    this.activeRequests++;
    console.log("++++", this.activeRequests)
    this.isLoading = new BehaviorSubject<boolean>(true);
  }

  stopLoading() {
    this.activeRequests--;
    console.log("---", this.activeRequests)
    if (this.activeRequests <= 0) {
      this.isLoading = new BehaviorSubject<boolean>(false);
    }
  }

  get isAnyCategoryChecked(): boolean {
    return this.selectAllCategoryChecked || this.categoryData?.some((item: any) => item.checked);
  }

  get isAnyModelChecked(): boolean {
    return this.selectAllModelChecked || this.modelsData?.some((item: any) => item.checked);
  }

  get isAnySourceChecked(): boolean {
    return this.selectAllSourceChecked || this.sourceList?.some((item: any) => item.checked);
  }

  get isAnyGeographyChecked(): boolean {
    return this.selectAllZoneChecked || this.dropdownData?.some((zone: any) => zone.checked);
  }

  get isAnyOutletChecked(): boolean {
    return this.dealerData?.some((item: any) => item.checked);
  }

  reset() {
    let filterObject: any = {}
    if (sessionStorage.getItem('filterObject')) {
      filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
      if (filterObject.startDate) {
        this.startDate = new Date(filterObject.startDate);
        this.endDate = new Date(filterObject.endDate);
        this.dateRange = new DateRange(this.startDate, this.endDate);
        this.selectedButton = filterObject.selectedButton;
      } else {
        this.selectThisMonth();
      }
    } else {
      this.selectThisMonth();
    }
  }

  updateAreaManagersList() {
    if (this.selectedRegionalMgrs.length != 0) {
      let outletIdList: number[] = this.selectedRegionalMgrs
        .map((mgr: any) => mgr.outlet_id)
        .flat();
      // Get areaList based on selected region IDs
      this.areaList = [
        ...this.areaListAll.filter((area: any) =>
          Array.isArray(area.outlet_id) &&
          area.outlet_id.some((id: any) => outletIdList.includes(id))
        )
      ];
    }
    if (this.selectedRegionalMgrs.length == 0 && this.selectedZonalMgrs.length == 0) {
      this.areaList = [...this.areaListAll]
    } else if (this.selectedRegionalMgrs.length == 0 && this.selectedZonalMgrs.length != 0) {
      let ids: any = [...new Set(this.regionalList.map((item: any) => item.outlet_id).flat())]
      this.areaList = [...this.areaListAll.filter((item: any) =>
        Array.isArray(item.outlet_id) && item.outlet_id.some((id: any) => ids.includes(id))
      )];
    }
  }

  updateFilter() {
      // this.isLoading = new BehaviorSubject<boolean>(true);
      this.dropdownData.forEach((zone: any) => {
        zone.checked = false;
        zone.selectAllChecked = false;
        zone.States.forEach((state: any) => {
          state.checked = false;
          state.Regions.forEach((region: any) => {
            region.selectAllAreasChecked = false;
            region.checked = false;
            region.ParentDealers.forEach((dealer: any) => {
              dealer.checked = false;
              dealer.Outlets.forEach((outlet: any) => {
                outlet.checked = false;
              });
            })
          })
        });
      })
      setTimeout(() => {
        let zoneId: any = this.selectedZonalMgrs.map((item: any) => item.zone_id);
        this.dropdownData.forEach((zone: any) => {
          if (zoneId.includes(zone.zone_id)) {
            zone.checked = true;
          }
        });
  
        this.regionalList = [...this.regionalListAll.filter((zone: any) => zoneId.includes(zone.zone_id))];
        let ids: any = [...new Set(this.regionalList.map((item: any) => item.outlet_id).flat())]
        this.areaList = [...this.areaListAll.filter((item: any) =>
          Array.isArray(item.outlet_id) && item.outlet_id.some((id: any) => ids.includes(id))
        )];
      }, 100)
      if (this.selectedRegionalMgrs.length > 0) {
        setTimeout(() => {
          let filterUserRegion: any = [];
          filterUserRegion = this.regionalListAll.filter((user: any) =>
            this.selectedRegionalMgrs.some((mgr: any) =>
              user.username.toLowerCase().trim() === mgr.username.toLowerCase().trim()
            )
          );
  
          let regionIds: any = []
          if (filterUserRegion.length > 0) {
            regionIds = filterUserRegion.map((user: any) => user.region_id).flat();
          }
          console.log("regionIds: ", regionIds)
          let outletIdList: number[] = this.selectedRegionalMgrs
            .map((mgr: any) => mgr.outlet_id)
            .flat();
  
          this.areaList = [
            ...this.areaListAll.filter((area: any) =>
              Array.isArray(area.outlet_id) &&
              area.outlet_id.some((id: any) => outletIdList.includes(id))
            )
          ];
  
          for (const zone of this.dropdownData) {
            for (const state of zone.States || []) {
              for (const region of state.Regions || []) {
                if (regionIds.includes(region.region_id)) {
                  zone.checked = true;
                  region.checked = true;
                  state.checked = true;
                }
              }
            }
          }
        }, 200)
      }
      if (this.selectedAreaMgrs.length > 0) {
        setTimeout(() => {
          const outletIds = this.selectedAreaMgrs.map((item: any) => item.outlet_id).flat() || [];
          let filterUserArea: any = [];
          filterUserArea = this.areaListAll.filter((user: any) =>
            this.selectedAreaMgrs.some((mgr: any) =>
              user.username.toLowerCase().trim() === mgr.username.toLowerCase().trim()
            )
          );
  
          for (const zone of this.dropdownData) {
            for (const state of zone.States || []) {
              for (const region of state.Regions || []) {
                for (const dealer of region.ParentDealers) {
                  for (const outlet of dealer.Outlets) {
                    if (outletIds.includes(outlet.outlet_id)) {
  
                      zone.checked = true;
                      state.checked = true;
                      region.checked = true;
                      dealer.checked = true;
                      outlet.checked = true;
                    }
                  }
                }
              }
            }
          }
  
          for (const zone of this.filteredData) {
            for (const state of zone.States || []) {
              for (const region of state.Regions || []) {
                for (const dealer of region.ParentDealers) {
                  for (const outlet of dealer.Outlets) {
                    if (outletIds.includes(outlet.outlet_id)) {
                      zone.checked = true;
                      state.checked = true;
                      region.checked = true;
                      dealer.checked = true;
                      outlet.checked = true;
                    }
                  }
                }
              }
            }
          }
          this.updateSelectAllStatus()
        }, 250)
      }
       setTimeout(()=>{
              // this.isLoading = new BehaviorSubject<boolean>(false);
          },300)
    }
}